import React, { useRef, useLayoutEffect, useContext, useCallback, useEffect, useState, useMemo } from 'react';
import { useMedia } from 'react-use';
import { RoleType } from '@vtblife/event-bus-events';
import cn from 'classnames';
import { useTooltip, Tooltip, Modal, Button as Button$1, Select, useSelectCustomControl, Input, Link, Collapse, Typography, useCollapseItem, Tabs as Tabs$1, LinkButton as LinkButton$1, Dropdown, useDropdownHover, RRLink } from '@vtblife/uikit';
import { __rest } from 'tslib';
import Icon from '@vtblife/uikit-icons';
import { EventBus } from '@vtblife/event-bus';
import useTransitionState from '@vtblife/uikit/dist/hooks/use-transition-state';
import axios from '@vtblife/axios';
import debounce from 'lodash/debounce';
import { cssTransition, toast } from 'react-toastify';
import * as Sentry from '@sentry/browser';
import 'react-toastify/dist/ReactToastify.css';
import { isError } from '@sentry/utils';
import { renderToStaticMarkup } from 'react-dom/server';
import Cookies from 'js-cookie';
import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import { GrowthBook } from '@growthbook/growthbook';
import { transformToGrowthBookAttributes } from '@vtblife/growthbook';
import querystring from 'querystring';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import { isSupported, getMessaging, getToken, onMessage } from '@firebase/messaging';
import { register } from '@vtblife/notification-webpush-api/axios-gen/token';
import { initializeApp } from '@firebase/app';
import { observer } from 'mobx-react';
import { osName } from 'react-device-detect';
import { Workbox } from 'workbox-window';
import { getWalletBalance } from '@vtblife/billing-api/axios-gen/billing_service';
import { isValid as isValid$1, compareAsc, parse } from 'date-fns';
import { ru as ru$1 } from 'date-fns/locale';
import useOnClickOutside from '@vtblife/uikit/dist/hooks/use-on-click-outside';
import { useLocation, matchPath } from 'react-router-dom';

const HeaderContextValue = React.createContext({
    items: [],
    loginText: 'Войти',
    mobileLoginText: 'Войти',
    closeMenu: () => null,
    toggleMenu: () => null,
    setIsMenuOpened: () => false,
    onMenuItemClick: () => null,
    isMenuOpened: false,
    logoutPath: '',
    isPartnerLogoVariant: false,
    loginPath: '/login',
    personalAreaPath: '/personal-area',
    isUserInfoMenuOpened: true,
    isTablet: true,
});

var TabsIds;
(function (TabsIds) {
    TabsIds["DEFAULT"] = "DEFAULT";
    TabsIds["REALTORS"] = "REALTORS";
    TabsIds["DEVELOPERS"] = "DEVELOPERS";
})(TabsIds || (TabsIds = {}));

const CLASSIFIED_LINKS = ['/nedvizhimost/kupit-kvartiru/', '/nedvizhimost/snyat-kvartiru/', '/novostroyki/'];
const comparePathProps = (pathname, props) => {
    if (props.exact) {
        return pathname === props.path;
    }
    return props.path !== '/' && (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith(props.path));
};
const extractItemPathname = (item) => {
    const itemHref = (item === null || item === void 0 ? void 0 : item.url) || (item === null || item === void 0 ? void 0 : item.path);
    return (itemHref === null || itemHref === void 0 ? void 0 : itemHref.startsWith('http')) ? new URL(itemHref).pathname : itemHref;
};
const compareClassifiedPathname = (pathname, href) => {
    const classifiedLink = CLASSIFIED_LINKS.find((link) => href === null || href === void 0 ? void 0 : href.includes(link));
    return classifiedLink && (pathname === null || pathname === void 0 ? void 0 : pathname.includes(classifiedLink));
};
const comparePathname = (pathname, item) => {
    if (!pathname)
        return false;
    if (item === null || item === void 0 ? void 0 : item.activeRoute) {
        const routes = Array.isArray(item.activeRoute) ? item.activeRoute : [item.activeRoute];
        return routes.some((route) => new RegExp(route).test(pathname));
    }
    const itemPathname = extractItemPathname(item);
    if (!itemPathname) {
        return false;
    }
    return (compareClassifiedPathname(pathname, itemPathname) ||
        comparePathProps(pathname, { path: itemPathname, exact: item === null || item === void 0 ? void 0 : item.exact }));
};

const comparePathnameWithTab = (pathname, item) => {
    var _a;
    return (comparePathname(pathname, item) || ((_a = item === null || item === void 0 ? void 0 : item.dropdownMenu) === null || _a === void 0 ? void 0 : _a.some((item) => comparePathnameWithTab(pathname, item))));
};
const getActiveTabId = (tabs, pathname) => {
    if (!tabs) {
        return;
    }
    let activeTabId = TabsIds.DEFAULT;
    for (const tab of tabs) {
        if (comparePathnameWithTab(pathname, tab)) {
            activeTabId = tab.id;
            break;
        }
    }
    return activeTabId;
};
const shouldShowPersonalButtons = ({ currentRoleType, pathname, items, }) => {
    const activeTabId = getActiveTabId(items, pathname);
    const rolesWithPersonalButtonsSupport = [
        RoleType.Client,
        RoleType.Employee,
        RoleType.Realtor,
        RoleType.Professional,
    ];
    if (activeTabId === TabsIds.DEVELOPERS ||
        (currentRoleType && !rolesWithPersonalButtonsSupport.includes(currentRoleType))) {
        return false;
    }
    return true;
};
const getPersonalButtonUrl = (roleType, urls) => {
    if (!urls)
        return;
    if (!urls.professionalUrl)
        return urls.url;
    return roleType === 'PROFESSIONAL' || roleType === 'REALTOR' ? urls.professionalUrl : urls.url;
};
const getOfferPlacementButtonUrl = (isAuthorized, urls) => {
    if (!urls)
        return;
    if (!urls.authorizedUrl)
        return urls.url;
    return isAuthorized ? urls.authorizedUrl : urls.url;
};
const isActivePath = (currentPathname, itemPath) => {
    if (!currentPathname || !itemPath)
        return false;
    const normalizedItemPath = itemPath.startsWith('/') ? itemPath : `/${itemPath}`;
    return (currentPathname === normalizedItemPath ||
        currentPathname.endsWith(`${normalizedItemPath}/`) ||
        currentPathname.endsWith(normalizedItemPath));
};
const getFilteredMenuItems = (items, deviceType) => items
    .filter((item) => { var _a; return (_a = item.device) === null || _a === void 0 ? void 0 : _a[deviceType]; })
    .map((item) => (Object.assign(Object.assign({}, item), (item.dropdownMenu && {
    dropdownMenu: getFilteredMenuItems(item.dropdownMenu, deviceType),
}))));

var styles$M = {"headerLayout":"_3-172-11QZa-abXWx","headerLayoutTransparent":"_3-172-11IDc-mzm-j","headerLayoutShort":"_3-172-11b-n-2UxBP","headerSpacer":"_3-172-11oA4-HZNLY","headerLayoutSticky":"_3-172-119n8-ALb8Y","headerLayoutBordered":"_3-172-11btz-GEd8H","headerLayoutContent":"_3-172-11QKJ-ZHINK","headerLayoutContentFull":"_3-172-11EwB-isgFM","headerLayoutBurger":"_3-172-111Rw-u9ncx","headerLayoutPersonalButtonsMobile":"_3-172-11Nfc-BjaB1","headerLayoutLeft":"_3-172-11fvt-csKhQ","headerLayoutLogo":"_3-172-11RA8-QK78m","headerLayoutLogoIcon":"_3-172-11Wsz-z-38Q","headerLayoutCloseMenuButton":"_3-172-11s6B-NdljU","headerLayoutOpened":"_3-172-110oe-CPIKq","personalAreaBtn":"_3-172-1104B-Sb0Yb","headerMobileButtonsContainer":"_3-172-11A-Z-J5kEM"};

const styles$L = {
    menuItemBase: 'menuItemBase',
};
const MenuItemBase = (_a) => {
    var { url, path, className, isCloseMenuDisabled, isActive, onClick, children, target, id, isSidebarEl } = _a, restProps = __rest(_a, ["url", "path", "className", "isCloseMenuDisabled", "isActive", "onClick", "children", "target", "id", "isSidebarEl"]);
    const href = path || url;
    const dataTestProp = restProps.dataTest || restProps['data-test'];
    const { closeMenu, onMenuItemClick, isMenuOpened } = React.useContext(HeaderContextValue);
    const ref = useRef(null);
    const handleItemClick = (e) => {
        !isCloseMenuDisabled && closeMenu();
        onClick === null || onClick === void 0 ? void 0 : onClick();
        onMenuItemClick === null || onMenuItemClick === void 0 ? void 0 : onMenuItemClick(e, { path, url, target, id, isSidebarEl });
    };
    useLayoutEffect(() => {
        var _a;
        if (isMenuOpened && isActive) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'center' });
        }
    }, [isMenuOpened]);
    const menuItemProps = {
        href,
        target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        className: cn(styles$L.menuItemBase, className),
        onClick: handleItemClick,
        'data-test': dataTestProp,
        ref,
    };
    return href ? React.createElement("a", Object.assign({}, menuItemProps), children) : React.createElement("button", Object.assign({}, menuItemProps), children);
};

const sendAnalyticsEvent$2 = (event) => { var _a, _b; return typeof event === 'string' ? (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event }) : (_b = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _b === void 0 ? void 0 : _b.push(event); };

const GEO_CONFIRM_CROSS = 'geo_confirm_cross';
const GEO_CONFIRM_YES = 'geo_confirm_yes';
const GEO_CONFIRM_NO = 'geo_confirm_no';
const GEO_CONFIRM_FOOTER = 'geo_confirm_footer';
const GEO_CONFIRM_HEADER = 'geo_confirm_header';
const GEO_CONFIRM_CHANGE = 'geo_confirm_change';

var styles$K = {"header-svg-icon-container":"_3-172-11kOg-mIDah"};

const sizes = {
    m: 24,
};
const SvgIcon = ({ iconComponent, size: externalSize = 'm', color }) => {
    const size = sizes[externalSize];
    return (React.createElement("i", { className: styles$K.headerSvgIconContainer, style: Object.assign({ fontSize: `${size}px`, lineHeight: `${size}px` }, (color && { color })) }, iconComponent));
};

const styles$J = {
    iconLinkMobile: 'iconLinkMobile',
    iconLinkDesktop: 'iconLinkDesktop',
    iconLinkDesktopTransparent: 'iconLinkDesktopTransparent',
    iconLink: 'iconLink',
};
const IconLink = ({ url, title, iconComponent, dataTest, onClick, isCloseMenuDisabled, color, }) => {
    const { to, registerControl } = useTooltip();
    const { isTransparent } = useContext(HeaderContextValue);
    if (!url && !onClick)
        return null;
    return (React.createElement(MenuItemBase, { url: url, dataTest: dataTest, isCloseMenuDisabled: isCloseMenuDisabled, onClick: onClick },
        React.createElement("span", { className: styles$J.iconLinkMobile },
            React.createElement("span", { className: styles$J.iconLink },
                React.createElement(SvgIcon, { iconComponent: iconComponent, color: color }))),
        React.createElement("span", { className: cn(styles$J.iconLinkDesktop, {
                [styles$J.iconLinkDesktopTransparent]: isTransparent,
            }), ref: registerControl },
            React.createElement("span", { className: styles$J.iconLink },
                React.createElement(SvgIcon, { iconComponent: iconComponent, color: color }),
                React.createElement(Tooltip, { to: to, direction: "down", placement: "body" }, title)))));
};

function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
var M2HeartCircleIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-4.75c-1.429-.992-2.79-2.11-3.967-3.394C6.95 13.672 6 12.265 6 10.888 6 9.058 7.482 7.25 9.42 7.25c.723 0 1.362.223 1.913.604.191.131.388.363.556.56l.111.13.111-.13c.168-.197.365-.429.556-.56a3.317 3.317 0 011.913-.604c1.938 0 3.42 1.808 3.42 3.638 0 1.377-.949 2.784-2.033 3.968C14.79 16.14 13.429 17.258 12 18.25z"
}));

function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
var M2BookmarkCircleIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm5-5V7H7v11l5-2.823L17 18z",
  fill: "currentColor"
}));

var styles$I = {"container":"_3-172-118tg-DtVPF","icon-link-container":"_3-172-11VKY-oFZbN","circle":"_3-172-11zXO-xEDee","icon-link":"_3-172-117AP-N42X8","closed":"_3-172-11PsZ-leZng","menu":"_3-172-11VlA-JuHiB"};

const FreshDot = ({ isSidebarClosed, isCircleVisible, variant, children }) => {
    if (!isCircleVisible) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: cn(styles$I.container, variant === 'icon-link' ? styles$I['icon-link-container'] : undefined) },
        children,
        React.createElement("span", { className: cn(styles$I.circle, variant && styles$I[variant], isSidebarClosed && styles$I.closed) })));
};

const ShellContextValue = React.createContext({
    survey: {},
    reportModal: {},
    updates: {},
    serviceWorker: {},
});
const ShellAuthorizeContextValue = React.createContext({
    authorize: {},
});
const ShellUserRegionContextValue = React.createContext({
    userRegion: {},
});
const ShellConfigContextValue = React.createContext({
    config: {},
});
const useAuthorizeContext = () => useContext(ShellAuthorizeContextValue).authorize;
const useSurveyContext = () => useContext(ShellContextValue).survey;
const useUserRegionContext = () => useContext(ShellUserRegionContextValue).userRegion;
const useConfigContext = () => useContext(ShellConfigContextValue).config;
const useUpdatesContext = () => useContext(ShellContextValue).updates;
const useServiceUpdatesContext = (service) => { var _a, _b; return (_b = (_a = useContext(ShellContextValue).updates) === null || _a === void 0 ? void 0 : _a.servicesUpdates) === null || _b === void 0 ? void 0 : _b[service]; };
const useShellContext = () => useContext(ShellContextValue);

const PersonalButtons = () => {
    const { roleType, personalButtons } = useContext(HeaderContextValue);
    const freshCount = useServiceUpdatesContext('saved-search');
    return (React.createElement(React.Fragment, null,
        React.createElement(IconLink, { url: getPersonalButtonUrl(roleType, personalButtons === null || personalButtons === void 0 ? void 0 : personalButtons.favorites), dataTest: "favorites", title: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435", iconComponent: React.createElement(M2HeartCircleIcon, null) }),
        React.createElement(IconLink, { url: getPersonalButtonUrl(roleType, personalButtons === null || personalButtons === void 0 ? void 0 : personalButtons.savedSearch), title: "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0438", iconComponent: React.createElement(FreshDot, { isCircleVisible: Boolean(freshCount), variant: "icon-link" },
                React.createElement(M2BookmarkCircleIcon, null)) })));
};

var styles$H = {"closeButton":"_3-172-11qsT-8Qi7O"};

const CloseButton = ({ onClick, dataTest = 'close-button' }) => (React.createElement("button", { className: styles$H.closeButton, onClick: onClick, "data-test": dataTest },
    React.createElement(Icon, { name: "times", size: "m", color: "white" })));

var styles$G = {"burgerButton":"_3-172-11D94-sZJ-2"};

function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
var MenuIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 6h18v2H3V6zm0 5h18v2H3v-2zm18 5H3v2h18v-2z"
}));

const BurgerButton = ({ onClick, dataTest = 'burger-button' }) => (React.createElement("button", { className: styles$G.burgerButton, onClick: onClick, "data-test": dataTest },
    React.createElement(SvgIcon, { iconComponent: React.createElement(MenuIcon, null) })));

const extractSecondLevelDomain = (hostname) => {
    const subdomains = hostname.split('.');
    if (subdomains.length === 1) {
        return hostname;
    }
    else {
        return subdomains.slice(-2).join('.');
    }
};

function useMountedState() {
    const mountedRef = useRef(false);
    const get = useCallback(() => mountedRef.current, [mountedRef.current]);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return get;
}

const formatPhone = (number) => number.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3-$4-$5');

const TEST_KEY = '__test';
function hasStorage(name) {
    try {
        const storage = window[name];
        storage.setItem(TEST_KEY, '1');
        storage.removeItem(TEST_KEY);
        return true;
    }
    catch (e) {
        return false;
    }
}

const TRUSTED_HOSTS = ['rb.m2', 'm2.region.vtb.ru', 'open.m2.ru'];
const INTERNAL_DOMAINS = ['m2.ru', 'test-m2.ru', 'dev-m2.ru', 'stage-m2.ru', 'perf-m2.ru', ...TRUSTED_HOSTS];

const PHONE = '+7 495 136‑28‑18';
const WORK_TIME = 'Круглосуточно';
const FEEDBACK_SURVEY_LINK = 'https://anketolog.ru/s/626678/mScHs49X';
const TRACE_HEADER_NAME = 'x-trace-id';
const CALL_CENTER_EMAIL = 'support@team-m2.ru';
const USER_REGION_ID_DETECTED_COOKIE = 'user_region_id_detected';
const USER_REGION_ID_SELECTED_COOKIE = 'user_region_id_selected';
const USER_REGION_ID_SELECTED_COOKIE_SEPARATOR = '-';
const MESSAGES = {
    offline: 'Отсутствует соединение с интернетом. Подключитесь к интернету и попробуйте ещё раз',
    doNotReloadPage: (React.createElement(React.Fragment, null, "\u0427\u0442\u043E\u0431\u044B \u043D\u0435\u00A0\u043F\u043E\u0442\u0435\u0440\u044F\u0442\u044C \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435, \u043D\u0435\u00A0\u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442 \u0438\u00A0\u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0441\u043D\u043E\u0432\u0430")),
    reloadPage: React.createElement(React.Fragment, null, "\u041F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442 \u0438\u00A0\u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"),
    needScreenshot: (React.createElement(React.Fragment, null,
        "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438\u00A0\u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0435\u0433\u043E \u0432\u00A0\u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043D\u0430\u00A0",
        React.createElement("a", { style: { fontWeight: 'bold' }, href: `mailto:${CALL_CENTER_EMAIL}` }, CALL_CENTER_EMAIL))),
    serviceDown: 'Сервис недоступен',
    forbiddenAccess: 'Доступ запрещён',
    defaultError: 'Произошла ошибка, попробуйте позже',
    unknownError: 'Произошла ошибка',
};
const HEADER_NAMES = {
    grpcStatus: 'grpc-status',
    grpcMessage: 'grpc-message',
    date: 'date',
    varitiCcr: 'x-variti-ccr',
    traceId: 'x-trace-id',
    cfRay: 'cf-ray',
};
var ErrorType;
(function (ErrorType) {
    ErrorType["Other"] = "other";
    ErrorType["Offline"] = "offline network";
    ErrorType[ErrorType["Forbidden"] = 403] = "Forbidden";
    ErrorType[ErrorType["Unauthorized"] = 401] = "Unauthorized";
})(ErrorType || (ErrorType = {}));
const ANONYM_USER_PREFIX = 'anonym#';
var LinkGenerationId;
(function (LinkGenerationId) {
    LinkGenerationId["ClassifiedBuy"] = "classified:buy";
    LinkGenerationId["ClassifiedRent"] = "classified:rent";
    LinkGenerationId["NewBuildings"] = "new-buildings";
    LinkGenerationId["ClassifiedBuySecond"] = "classified:buy:second";
    LinkGenerationId["ClassifiedBuyOneRoom"] = "classified:buy:one-room";
})(LinkGenerationId || (LinkGenerationId = {}));
var HeaderVariant;
(function (HeaderVariant) {
    HeaderVariant["Default"] = "default";
})(HeaderVariant || (HeaderVariant = {}));

const isAnonymousUser = (username) => Boolean(username === null || username === void 0 ? void 0 : username.startsWith(ANONYM_USER_PREFIX));

const clearPhone = (phone) => phone.replace(/[^\d+]/g, '');

const LAST_AUTH_LOCAL_STORAGE_KEY = 'authState-v3';
const setLastAuth = (status) => {
    try {
        localStorage.setItem(LAST_AUTH_LOCAL_STORAGE_KEY, JSON.stringify(status));
    }
    catch (err) {
    }
};

const MOBILE_WIDE_QUERY = '(max-width: 959px)';
const isMobileWide = () => {
    return window.matchMedia(MOBILE_WIDE_QUERY).matches;
};
const TABLET_QUERY = '(max-width: 1024px)';
const isTouchDevice = () => {
    return 'ontouchstart' in window || (navigator === null || navigator === void 0 ? void 0 : navigator.maxTouchPoints) > 0;
};

let windowOffset = 0;
const preventBodyScrollOverlayOpened = (isOpened) => {
    if (!isMobileWide())
        return;
    if (isOpened) {
        windowOffset = window === null || window === void 0 ? void 0 : window.scrollY;
        document.body.classList.add('headerMenuOpened');
        document.body.setAttribute('style', `top: ${-windowOffset}px;`);
    }
    else {
        document.body.classList.remove('headerMenuOpened');
        document.body.removeAttribute('style');
        window.scrollTo(0, windowOffset);
        windowOffset = 0;
    }
};

const isPhoneNumberString = (string) => /^\d+$/.test(string) && string.length === 11;

const getProfileHeaderByRoleType = (roleType) => {
    if (!roleType)
        return null;
    switch (roleType) {
        case 'MAKLER':
        case 'PROFESSIONAL':
            return 'Риелтор';
        case 'CLIENT':
            return 'Частное лицо';
        case 'EMPLOYEE':
            return 'Сотрудник М2';
        default:
            return 'Партнёр';
    }
};

const mapUpdatesToCounter = (updates) => {
    if (!updates)
        return {};
    const counters = {};
    for (const service in updates) {
        const data = updates[service];
        if (!data || typeof data === 'number') {
            counters[service] = data !== null && data !== void 0 ? data : 0;
            continue;
        }
        counters[service] = 0;
    }
    return counters;
};
const mapUpdatesToSidebar = (items, updates) => updates
    ? items.map((item) => {
        var _a;
        let dropdownTotalFreshCount = 0;
        const counters = mapUpdatesToCounter(updates);
        return Object.assign(Object.assign({}, item), { dropdownMenu: (_a = item.dropdownMenu) === null || _a === void 0 ? void 0 : _a.map((subItem) => {
                dropdownTotalFreshCount += counters[subItem.id] || 0;
                return Object.assign(Object.assign({}, subItem), { freshCount: counters[subItem.id] });
            }), freshCount: counters[item.id] || dropdownTotalFreshCount });
    })
    : items;

const isBrowser = () => {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};

const isAutotestUserAgent = (userAgent) => {
    return /auto-?test/.test(userAgent);
};

const useHeaderVariant = (isSticky, offsetY = 42) => {
    const [isShort, setIsShort] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [iconTransform, setIconTransform] = useState('');
    const handleScroll = () => {
        if (!isSticky)
            return;
        const scrollY = window.scrollY < 0 ? 0 : window.scrollY;
        if (scrollY > 0 && !isScrolled) {
            setIsScrolled(true);
        }
        if (scrollY === 0 && isScrolled) {
            setIsScrolled(false);
        }
        if (scrollY < offsetY) {
            let scl = (offsetY - scrollY) / offsetY;
            let tp = scrollY;
            if (scl < 0.6154)
                scl = 0.6154;
            if (tp > 34)
                tp = 34;
            setIconTransform(`scale(${scl}) translateY(${tp}px)`);
        }
        if (scrollY >= offsetY && !isShort) {
            setIsShort(true);
            setIconTransform('scale(0.6154) translateY(34px)');
        }
        if (scrollY < offsetY && isShort) {
            setIsShort(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isShort, isScrolled, isSticky]);
    return { isShort, isScrolled, iconTransform };
};

const useActiveTab = () => {
    const { items, pathname } = useContext(HeaderContextValue);
    const filteredItems = useMemo(() => getFilteredMenuItems(items, 'desktop'), [items]);
    const activeTabId = getActiveTabId(filteredItems, pathname);
    return filteredItems.find((item) => item.id === activeTabId);
};

const eventBus$2 = EventBus.getInstance();
const useMenuToggle = (initialState) => {
    const [isMenuOpened, setIsMenuOpened] = useState(initialState);
    useEffect(() => {
        const subscription = eventBus$2.subscribe('app:menu:toggle', (event) => setIsMenuOpened(event.data.isOpen));
        return () => {
            subscription.unsubscribe();
        };
    }, []);
    return { isMenuOpened, setIsMenuOpened };
};

var styles$F = {"logo":"_3-172-11F-v-OR7mL","logoDesktop":"_3-172-11dGe-n07Lp","logoTouch":"_3-172-11omR-VP7wv"};

function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
var avitoDesktop = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$l({
  width: "251",
  height: "52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M31.383 47.5C37.8 47.5 43 42.3 43 35.883c0-6.415-5.201-11.616-11.617-11.616s-11.617 5.2-11.617 11.616c0 6.416 5.201 11.617 11.617 11.617z",
  fill: "#97CF26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.547 41.29a5.407 5.407 0 100-10.814 5.407 5.407 0 000 10.815z",
  fill: "#A169F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.383 21.524a7.477 7.477 0 100-14.954 7.477 7.477 0 000 14.954z",
  fill: "#FF6163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.547 23.594a9.547 9.547 0 100-19.094 9.547 9.547 0 000 19.094z",
  fill: "#0AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.201 41.227h6.03l-11.167-30.41H63.69L52.52 41.229h6.03l2.133-5.804H71.07l2.132 5.804-10.838-10.38 3.513-9.563 3.512 9.562h-7.025l10.838 10.38zm20.98-20.76l-5.55 15.106-5.547-15.107h-5.666l7.628 20.761h7.171l7.627-20.76H94.18m8.036 0h5.666v20.76h-5.666v-20.76zm2.852-2.358a3.648 3.648 0 100-7.296 3.648 3.648 0 000 7.296zm22.819 6.933v-4.575H121.1V14.74h-5.662v5.727h-4.482v4.575h4.482v8.932c0 4.608 2.303 7.683 8.186 7.683 2.271 0 4.263-.834 4.263-.834l-.688-4.483s-1.115.333-2.486.333c-1.681 0-3.613-.724-3.613-3.048v-8.584h6.787m12.994 11.441c-3.159 0-5.719-2.505-5.719-5.594 0-3.086 2.56-5.591 5.718-5.591 3.16 0 5.718 2.505 5.718 5.592 0 3.089-2.558 5.594-5.717 5.594v-.001zm0-16.546c-6.141 0-11.122 4.872-11.122 10.877 0 6.008 4.981 10.877 11.121 10.877 6.138 0 11.119-4.87 11.119-10.877 0-6.005-4.981-10.876-11.119-10.876",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#746D93",
  fillOpacity: ".5",
  d: "M171.999 0h1v52h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.999 0h41v41h-17v11h-41V11h17V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.156 27.392v-2.739h-6.558v-.023c2.313-1.029 6.349-2.783 6.349-6.43 0-2.882-2.395-5.343-5.777-5.343-3.383 0-5.11 2.331-5.871 4.433l2.503.98c.565-1.753 1.56-2.823 3.391-2.823 1.6 0 2.917 1.193 2.787 2.776-.169 2.042-2.352 3.522-4.361 4.626-1.534.843-3.909 2.04-3.909 2.04v2.503h11.446zm-32.105-2.729v13.694h2.956v-10.27l4.23 10.27h2.242l4.154-10.27v10.27h2.981V24.663h-4.306l-3.975 9.822-4.001-9.822h-4.281z",
  fill: "#fff"
}));

function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
var avitoTouch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$k({
  width: "157",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.706 29.5a7.294 7.294 0 100-14.589 7.294 7.294 0 000 14.59z",
  fill: "#97CF26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.995 25.601a3.395 3.395 0 100-6.79 3.395 3.395 0 000 6.79z",
  fill: "#A169F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.706 13.19a4.695 4.695 0 100-9.39 4.695 4.695 0 000 9.39z",
  fill: "#FF6163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.995 14.49a5.995 5.995 0 100-11.99 5.995 5.995 0 000 11.99z",
  fill: "#0AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.964 25.561h3.786L42.738 6.467H39.99l-7.014 19.095h3.787l1.34-3.645h6.52l1.34 3.645-6.806-6.518 2.206-6.005 2.205 6.005h-4.41l6.805 6.517zm13.173-13.036l-3.485 9.486-3.483-9.486h-3.558l4.79 13.036h4.503l4.789-13.036h-3.557m5.046 0h3.558v13.036h-3.558V12.525zm1.791-1.48a2.29 2.29 0 100-4.581 2.29 2.29 0 000 4.581zm14.328 4.353v-2.872H76.04V8.929h-3.556v3.596H69.67v2.873h2.814v5.609c0 2.893 1.447 4.824 5.14 4.824 1.427 0 2.677-.524 2.677-.524l-.432-2.815s-.7.21-1.56.21c-1.056 0-2.27-.455-2.27-1.914v-5.39h4.262m8.159 7.184c-1.984 0-3.591-1.573-3.591-3.512 0-1.938 1.607-3.511 3.59-3.511 1.984 0 3.591 1.573 3.591 3.51 0 1.94-1.606 3.513-3.59 3.513zm0-10.39c-3.856 0-6.983 3.06-6.983 6.83 0 3.773 3.127 6.83 6.983 6.83 3.854 0 6.98-3.057 6.98-6.83 0-3.77-3.126-6.83-6.98-6.83",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#746D93",
  fillOpacity: ".5",
  d: "M107.441 0h1v32h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.441 0h25v25h-11v7h-25V7h11V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.615 16.857V15.17h-4.036v-.014c1.424-.633 3.907-1.713 3.907-3.957 0-1.773-1.473-3.288-3.555-3.288s-3.145 1.435-3.613 2.728l1.541.603c.347-1.079.959-1.737 2.086-1.737.985 0 1.795.734 1.715 1.708-.104 1.256-1.447 2.167-2.683 2.847a95.748 95.748 0 01-2.406 1.255v1.54h7.044zm-19.757-1.68v8.428h1.819v-6.32l2.603 6.32h1.38l2.556-6.32v6.32h1.835v-8.428h-2.65l-2.447 6.045-2.462-6.045h-2.634z",
  fill: "#fff"
}));

function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
var sravniruDesktop = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$j({
  width: "395",
  height: "52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("image", {
  width: "395",
  height: "52",
  xlinkHref: "data:image/png;base64,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"
}));

function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
var sravniruTouch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$i({
  width: "243",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("image", {
  width: "243",
  height: "32",
  xlinkHref: "data:image/png;base64,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"
}));

function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
var groupDesktop = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$h({
  width: "169",
  height: "52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 0h41v41H41v11H0V11h17V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.157 27.392v-2.739H37.6v-.023c2.313-1.029 6.349-2.783 6.349-6.43 0-2.882-2.395-5.343-5.778-5.343-3.382 0-5.11 2.331-5.87 4.433l2.503.98c.565-1.753 1.56-2.823 3.39-2.823 1.6 0 2.918 1.193 2.787 2.776-.169 2.042-2.352 3.522-4.36 4.626-1.534.843-3.91 2.04-3.91 2.04v2.503h11.446zm-32.105-2.729v13.694h2.956v-10.27l4.23 10.27h2.243l4.153-10.27v10.27h2.982V24.663H24.31l-3.976 9.822-4-9.822h-4.282z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F78A1",
  fillOpacity: ".4",
  d: "M70 0h1v52h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83 10.528v8.064h1.376V11.76h3.936v6.832h1.376v-8.064H83zm13.062-.176c-1.392 0-2.256.656-2.64 1.328v-1.152h-1.328v11.12h1.376V17.6c.384.608 1.248 1.168 2.544 1.168 1.856 0 3.68-1.36 3.68-4.208 0-2.832-1.808-4.208-3.632-4.208zm-.176 7.168c-1.488 0-2.464-1.136-2.464-2.928v-.064c0-1.792.976-2.928 2.464-2.928 1.44 0 2.4 1.2 2.4 2.96s-.96 2.96-2.4 2.96zM105 10.352c-2.352 0-3.872 1.76-3.872 4.208 0 2.448 1.52 4.208 3.872 4.208s3.872-1.76 3.872-4.208c0-2.448-1.52-4.208-3.872-4.208zm0 7.168c-1.52 0-2.464-1.2-2.464-2.96s.944-2.96 2.464-2.96 2.464 1.2 2.464 2.96-.944 2.96-2.464 2.96zm12.628-2.544v-.704c0-2.4-1.376-3.92-3.52-3.92-2.208 0-3.792 1.6-3.792 4.208 0 2.592 1.568 4.208 3.904 4.208 2.096 0 3.104-1.312 3.312-2.256h-1.392c-.144.416-.784 1.024-1.904 1.024-1.488 0-2.48-1.088-2.48-2.528v-.032h5.872zm-3.552-3.392c1.296 0 2.096.832 2.16 2.224h-4.464c.112-1.312.96-2.224 2.304-2.224zm6.846 7.008v-3.888l3.504 3.888h1.776l-3.84-4.304 3.792-3.76h-1.744l-3.488 3.456v-3.456h-1.376v8.064h1.376zm6.03-6.832h2.704v6.832h1.376V11.76h2.72v-1.232h-6.8v1.232zM90.184 28.64v-1.312h-6.976v11.264h1.424V28.64h5.552zm4.003 1.712c-1.392 0-2.256.656-2.64 1.328v-1.152h-1.328v11.12h1.376V37.6c.384.608 1.248 1.168 2.544 1.168 1.856 0 3.68-1.36 3.68-4.208 0-2.832-1.808-4.208-3.632-4.208zm-.176 7.168c-1.488 0-2.464-1.136-2.464-2.928v-.064c0-1.792.976-2.928 2.464-2.928 1.44 0 2.4 1.2 2.4 2.96s-.96 2.96-2.4 2.96zm10.943-6.992l-2.416 6.288-2.432-6.288h-1.488l3.168 7.968-1.248 3.152h1.488l4.416-11.12h-1.488zm2.921 0v8.064h1.376V31.76h3.936v6.832h1.376v-8.064h-6.688zm9.094 0v8.064h1.376V31.76h3.936v6.832h1.376v-8.064h-6.688zm10.469 0h-1.376v8.064h3.168c1.728 0 2.848-1.184 2.848-2.752 0-1.568-1.12-2.704-2.832-2.704h-1.808v-2.608zm7.185 0h-1.376v8.064h1.376v-8.064zm-5.553 3.824c1.056 0 1.632.624 1.632 1.488s-.576 1.536-1.632 1.536h-1.632v-3.024h1.632zm11.669 4.24h4.272c2.288 0 3.712-1.296 3.712-3.184 0-1.648-1.104-2.48-1.904-2.704.704-.288 1.472-1.088 1.472-2.464 0-1.632-1.2-2.912-3.376-2.912h-4.176v11.264zm4.256-5.168c1.392 0 2.272.752 2.272 1.952 0 1.232-.944 1.936-2.352 1.936h-2.768v-3.888h2.848zm-.256-4.816c1.328 0 2.112.672 2.112 1.776 0 1.008-.656 1.776-2.016 1.776h-2.688v-3.552h2.592zm5.074.032h3.712v9.952h1.424V28.64h3.712v-1.312h-8.848v1.312zm17.697 0v-1.312h-6.88v11.264h4.08c2.192 0 3.584-1.456 3.584-3.424 0-2-1.36-3.392-3.616-3.392h-2.624V28.64h5.456zm-3.008 4.432c1.44 0 2.336.784 2.336 2.096s-.896 2.128-2.336 2.128h-2.448v-4.224h2.448z",
  fill: "#6E6A81"
}));

function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var groupTouch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$g({
  width: "123",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 0h25v25H25v7H0V7h11V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.174 16.857V15.17h-4.036v-.014c1.424-.633 3.907-1.713 3.907-3.957 0-1.773-1.473-3.288-3.555-3.288-2.081 0-3.145 1.435-3.613 2.728l1.54.603c.348-1.079.96-1.737 2.087-1.737.985 0 1.796.734 1.715 1.708-.104 1.256-1.447 2.167-2.683 2.847-.944.519-2.406 1.255-2.406 1.255v1.54h7.044zm-19.757-1.68v8.428h1.819v-6.32l2.603 6.32h1.38l2.556-6.32v6.32h1.835v-8.428h-2.65l-2.447 6.045-2.462-6.045H7.417z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F78A1",
  fillOpacity: ".4",
  d: "M45 0h1v32h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 4.866v6.12h1.368v-4.92h2.592v4.92h1.368v-6.12H55zm10.4-.144c-.972 0-1.596.444-1.896.936v-.792h-1.32v8.412h1.368v-2.976c.288.444.912.828 1.812.828 1.452 0 2.748-1.104 2.748-3.204S66.828 4.722 65.4 4.722zm-.264 5.196c-.972 0-1.62-.768-1.62-1.968v-.048c0-1.2.648-1.968 1.62-1.968.96 0 1.596.804 1.596 1.992 0 1.2-.636 1.992-1.596 1.992zm7.143-5.196c-1.8 0-3.012 1.308-3.012 3.204 0 1.896 1.212 3.204 3.012 3.204s3.012-1.308 3.012-3.204c0-1.896-1.212-3.204-3.012-3.204zm0 5.196c-1.008 0-1.62-.816-1.62-1.992 0-1.176.612-1.992 1.62-1.992s1.62.816 1.62 1.992c0 1.176-.612 1.992-1.62 1.992zm9.884-1.596v-.564c0-1.848-1.092-3.036-2.772-3.036-1.728 0-2.94 1.224-2.94 3.216 0 1.98 1.212 3.192 3.024 3.192 1.668 0 2.46-1.02 2.616-1.8h-1.344c-.096.276-.516.66-1.248.66-.984 0-1.644-.72-1.644-1.644v-.024h4.308zm-2.784-2.46c.852 0 1.38.54 1.416 1.428h-2.928c.084-.864.648-1.428 1.512-1.428zm5.656 5.124V8.13l2.352 2.856h1.656l-2.676-3.252 2.64-2.868h-1.62L85.035 7.41V4.866h-1.368v6.12h1.368zm4.68-4.92h1.956v4.92h1.368v-4.92h1.956v-1.2h-5.28v1.2zM60.544 17.822v-1.284h-5.4v8.448h1.428v-7.164h3.972zm3.603.9c-.973 0-1.597.444-1.897.936v-.792h-1.32v8.412H62.3v-2.976c.288.444.912.828 1.812.828 1.451 0 2.747-1.104 2.747-3.204s-1.283-3.204-2.711-3.204zm-.265 5.196c-.971 0-1.62-.768-1.62-1.968v-.048c0-1.2.649-1.968 1.62-1.968.96 0 1.597.804 1.597 1.992 0 1.2-.637 1.992-1.597 1.992zm8.346-5.052l-1.608 4.38-1.608-4.38h-1.476l2.352 6.012-.948 2.4h1.464l3.3-8.412h-1.476zm2.626 0v6.12h1.368v-4.92h2.592v4.92h1.368v-6.12h-5.328zm7.184 0v6.12h1.368v-4.92h2.592v4.92h1.368v-6.12h-5.328zm8.54 0h-1.355v6.12h2.58c1.368 0 2.244-.924 2.244-2.148 0-1.212-.864-2.112-2.244-2.112h-1.224v-1.86zm5.605 0h-1.356v6.12h1.356v-6.12zm-4.548 3.012c.672 0 1.056.396 1.056.96s-.384 1.008-1.056 1.008h-1.056v-1.968h1.056zm9.358 3.108h3.372c1.74 0 2.82-.996 2.82-2.4 0-1.224-.804-1.836-1.428-2.016.54-.228 1.104-.828 1.104-1.836 0-1.224-.888-2.196-2.604-2.196h-3.264v8.448zm3.264-3.744c.9 0 1.476.48 1.476 1.26 0 .804-.612 1.26-1.524 1.26h-1.788v-2.52h1.836zm-.204-3.48c.864 0 1.368.432 1.368 1.152 0 .648-.42 1.152-1.308 1.152h-1.692v-2.304h1.632zm4.076.06h2.664v7.164h1.428v-7.164h2.652v-1.284h-6.744v1.284zm13.663 0v-1.284h-5.352v8.448h3.216c1.68 0 2.748-1.116 2.748-2.604 0-1.548-1.044-2.58-2.76-2.58h-1.776v-1.98h3.924zm-2.34 3.192c.936 0 1.5.516 1.5 1.356 0 .84-.564 1.368-1.5 1.368h-1.584v-2.724h1.584z",
  fill: "#6E6A81"
}));

function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var m2Desktop = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$f({
  width: "58",
  height: "52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 0h41v41H41v11H0V11h17V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.157 27.392v-2.739H37.6v-.023c2.312-1.029 6.348-2.783 6.348-6.43 0-2.882-2.394-5.343-5.777-5.343-3.382 0-5.11 2.331-5.87 4.433l2.503.98c.564-1.753 1.559-2.823 3.39-2.823 1.6 0 2.918 1.193 2.787 2.776-.169 2.042-2.352 3.522-4.36 4.626-1.534.843-3.91 2.04-3.91 2.04v2.503h11.446zM12.052 24.663v13.694h2.956v-10.27l4.23 10.27h2.243l4.153-10.27v10.27h2.982V24.663h-4.307l-3.975 9.822-4-9.822h-4.282z",
  fill: "#fff"
}));

function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var m2Touch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$e({
  width: "36",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 0h25v25H25v7H0V7h11V0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.174 16.857V15.17h-4.035v-.014c1.423-.633 3.906-1.713 3.906-3.957 0-1.773-1.473-3.288-3.555-3.288-2.081 0-3.144 1.435-3.613 2.728l1.54.603c.348-1.079.96-1.737 2.087-1.737.985 0 1.796.734 1.715 1.708-.104 1.256-1.447 2.167-2.683 2.847a95.885 95.885 0 01-2.406 1.255v1.54h7.044zM7.417 15.177v8.428h1.82v-6.32l2.602 6.32h1.38l2.556-6.32v6.32h1.835v-8.428h-2.65l-2.447 6.045-2.461-6.045H7.417z",
  fill: "#6C44F8"
}));

function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
var m2ProTouch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$d({
  width: "36",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M36 17.059v-3.116h-7.522v-.029c2.658-1.175 7.296-3.174 7.296-7.328C35.774 3.305 33.02.5 29.134.5c-3.891 0-5.88 2.654-6.75 5.05l2.88 1.118c.645-1.999 1.795-3.217 3.898-3.217 1.837 0 3.36 1.358 3.202 3.163-.197 2.321-2.704 4.012-5.008 5.273-1.766.96-4.499 2.324-4.499 2.324v2.848H36zM0 1.12v15.939h3.439V5.095L8.4 17.06h2.636l4.869-11.964V17.06h3.51V1.119H14.37l-4.66 11.43L5.022 1.12H0z",
  fill: "#fff"
}));

function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var vtbDesktop = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$c({
  width: "200",
  height: "52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.86 8l-1.716 4.71H28.93L30.646 8H6.86zm-2.573 7.062L2.57 19.771h23.785l1.716-4.709H4.288zm-2.57 7.063L0 26.833h23.785l1.715-4.708H1.716z",
  fill: "#0AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.565 28.628v.1c1.087.399 2.126 1.098 2.67 1.546 1.68 1.398 2.423 3.244 2.423 5.64 0 3.944-2.077 6.787-5.488 7.686-1.039.3-2.126.399-4.153.399h-10.33V15.153h9.145c1.88 0 3.164.1 4.3.398 3.313.899 5.488 3.195 5.488 6.837 0 1.947-.692 3.595-1.829 4.692-.494.499-1.186 1.098-2.224 1.547h-.002zm-9.145 3.044v7.586h3.955c1.186 0 2.274-.1 3.065-.849.79-.748 1.136-1.697 1.136-2.944 0-.947-.248-1.846-.741-2.495-.84-1.048-1.88-1.298-3.658-1.298h-3.758zm-.05-4.991h3.213c.989 0 1.483 0 1.977-.15 1.336-.4 2.176-1.595 2.176-3.243 0-1.946-.89-2.795-2.176-3.193-.544-.15-1.087-.2-2.175-.2h-3.016v6.787-.001zm22.889 17.32V19.993h-8.256v-4.84h22.94l-1.631 4.84h-7.318V44H64.26zm16.463 0V15.153h18.59l-1.632 4.84H86.408v6.389h4.598c3.708 0 5.636.899 6.971 2.045 1.04.9 2.818 2.894 2.818 6.839 0 3.892-1.828 6.037-3.362 7.136C95.654 43.649 93.775 44 89.968 44h-9.246zm5.685-4.843h4.301c1.631 0 2.62-.399 3.312-1.298.345-.448.84-1.248.84-2.745s-.495-2.545-1.483-3.294c-.592-.448-1.384-.697-2.72-.697h-4.25v8.034z",
  fill: "#0A2896"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#746D93",
  fillOpacity: ".5",
  d: "M120.795 0h1v52h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.795 0h41v41h-17v11h-41V11h17V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.952 27.392v-2.739h-6.557v-.023c2.313-1.029 6.349-2.783 6.349-6.43 0-2.882-2.395-5.343-5.777-5.343-3.383 0-5.111 2.331-5.872 4.433l2.504.98c.565-1.753 1.559-2.823 3.391-2.823 1.599 0 2.917 1.193 2.786 2.776-.168 2.042-2.351 3.522-4.36 4.626-1.534.843-3.909 2.04-3.909 2.04v2.503h11.445zm-32.104-2.729v13.694h2.956v-10.27l4.23 10.27h2.242l4.154-10.27v10.27h2.981V24.663h-4.306l-3.976 9.822-4-9.822h-4.281z",
  fill: "#fff"
}));

function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var vtbTouch = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  width: "126",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.383 4.5L3.287 7.509h15.196L19.579 4.5H4.383zM2.74 9.012L1.642 12.02h15.196l1.097-3.008H2.739zm-1.642 4.512L0 16.532h15.196l1.096-3.008H1.097z",
  fill: "#0AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.305 17.679v.064a6.4 6.4 0 011.706.988c1.074.893 1.548 2.072 1.548 3.603 0 2.52-1.326 4.336-3.506 4.91-.664.192-1.358.255-2.653.255h-6.6V9.07h5.843c1.2 0 2.02.064 2.747.254 2.116.575 3.506 2.041 3.506 4.368 0 1.244-.442 2.297-1.168 2.998a4.434 4.434 0 01-1.421.988h-.002zm-5.842 1.945v4.846h2.527c.757 0 1.453-.063 1.958-.542.505-.478.726-1.084.726-1.88 0-.606-.158-1.18-.474-1.595-.537-.67-1.2-.83-2.337-.83h-2.401zm-.032-3.189h2.053c.631 0 .947 0 1.263-.095.853-.256 1.39-1.02 1.39-2.073 0-1.243-.568-1.785-1.39-2.04-.348-.096-.695-.127-1.39-.127H26.43v4.336zM41.053 27.5V12.163H35.78V9.07h14.656l-1.042 3.092h-4.675V27.5h-3.665zm10.518 0V9.07H63.45l-1.042 3.093h-7.202v4.082h2.938c2.369 0 3.6.574 4.454 1.306.663.575 1.8 1.85 1.8 4.37 0 2.486-1.168 3.857-2.148 4.559-1.137.796-2.337 1.02-4.77 1.02h-5.907zm3.633-3.093h2.748c1.042 0 1.673-.255 2.115-.83.221-.286.537-.797.537-1.753 0-.956-.316-1.627-.947-2.105-.379-.286-.885-.445-1.738-.445h-2.716v5.133z",
  fill: "#0A2896"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#746D93",
  fillOpacity: ".5",
  d: "M76.397 0h1v32h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.397 0h25v25h-11v7h-25V7h11V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.571 16.857V15.17h-4.036v-.014c1.424-.633 3.907-1.713 3.907-3.957 0-1.773-1.473-3.288-3.555-3.288-2.081 0-3.145 1.435-3.613 2.728l1.541.603c.347-1.079.959-1.737 2.086-1.737.985 0 1.796.734 1.715 1.708-.104 1.256-1.447 2.167-2.683 2.847a95.748 95.748 0 01-2.406 1.255v1.54h7.044zm-19.757-1.68v8.428h1.819v-6.32l2.603 6.32h1.38l2.556-6.32v6.32h1.835v-8.428h-2.65l-2.447 6.045-2.462-6.045h-2.634z",
  fill: "#fff"
}));

function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var aeonLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: "120",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.274.187a19.99 19.99 0 0113.052 2.684 20.013 20.013 0 01.32 34.07 20.025 20.025 0 01-23.657-1.75A19.992 19.992 0 013.136 9.252C6.226 4.366 11.53.943 17.274.187z",
  fill: "#2C456E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.6 29.83c-.877.713-1.153 1.897-1.177 2.976 1.023-.082 2.145-.302 2.86-1.11.647-.701.784-1.69.806-2.604-.87.05-1.797.16-2.49.738zm-5.687-.743c.054.9.17 1.865.794 2.568.713.84 1.863 1.074 2.912 1.146-.065-1.023-.273-2.132-1.064-2.845-.69-.694-1.717-.808-2.642-.87zm9.59.562c-.683.717-.853 1.745-.922 2.697.986-.067 2.07-.25 2.781-1.001.711-.695.892-1.73.904-2.683-.99 0-2.073.216-2.764.987zm-13.767-.98c.056.852.17 1.773.733 2.467.697.903 1.902 1.153 2.982 1.206-.09-1-.27-2.1-1.047-2.819-.706-.682-1.724-.853-2.668-.853v-.001zm9.693-3.092c-.762.71-.966 1.8-1.007 2.797.951-.067 1.98-.24 2.693-.93.764-.682.965-1.765.972-2.75-.943.01-1.967.185-2.658.883zm-5.515-.88c.06.883.17 1.84.783 2.534.716.837 1.865 1.1 2.922 1.132-.07-.973-.261-2.022-.974-2.745-.712-.723-1.76-.92-2.727-.921h-.004zm-4.178-.466c.06.936.19 1.953.88 2.655.717.773 1.81.974 2.818 1.05-.05-1.015-.263-2.116-1.039-2.835-.702-.682-1.722-.834-2.66-.87zm13.945.817c-.813.721-1.047 1.852-1.086 2.89.916-.088 1.894-.23 2.614-.852.832-.69 1.052-1.83 1.052-2.857-.906.055-1.876.188-2.58.824v-.005zm4.33-1.31c-.774.72-.994 1.817-1.057 2.831 1.056-.042 2.217-.288 2.92-1.137.618-.7.723-1.663.79-2.558-.934.039-1.95.179-2.653.852v.012zm-22.62-.864c.02.92.182 1.91.82 2.62.724.799 1.846 1.024 2.874 1.08-.069-.992-.261-2.067-1.008-2.788-.7-.711-1.737-.863-2.687-.913zm14.054-1.733c-.768.725-.98 1.821-1.023 2.833.922-.096 1.914-.244 2.635-.886.802-.695 1.023-1.813 1.023-2.83-.936.044-1.955.194-2.649.883h.014zm-5.529-.882c.065.926.19 1.932.852 2.633.716.798 1.833.993 2.85 1.08-.062-1.061-.29-2.236-1.162-2.94-.7-.608-1.655-.735-2.547-.773h.007zm9.779.367c-.808.718-1.057 1.842-1.095 2.878 1.023-.046 2.159-.276 2.866-1.093.64-.692.79-1.668.808-2.572-.909 0-1.875.15-2.58.787zm-13.956-.785c.07.878.17 1.834.786 2.523.71.852 1.864 1.103 2.92 1.13-.064-.97-.259-2.014-.966-2.728-.708-.715-1.765-.935-2.74-.92v-.005zm18.272-.527c-.78.723-.985 1.823-1.067 2.838 1.023-.044 2.133-.264 2.856-1.049.663-.706.815-1.705.852-2.631-.936.012-1.94.17-2.648.842h.007zM7.39 18.472c.035.946.19 1.987.901 2.68.72.761 1.81.934 2.803 1.024-.089-.994-.262-2.087-1.023-2.805-.695-.705-1.727-.882-2.676-.894l-.005-.005zm14.245-1.912c-.893.703-1.18 1.898-1.205 2.985 1.002-.065 2.086-.282 2.807-1.043.674-.699.853-1.705.853-2.646-.853.03-1.771.14-2.457.704h.002zm-5.71-.7c.048.954.2 2.01.938 2.695.715.739 1.78.928 2.764.984-.075-.984-.26-2.046-.994-2.774-.704-.713-1.746-.898-2.708-.904zm9.684.424c-.766.721-.958 1.814-1.023 2.819.999-.075 2.08-.273 2.804-1.024.682-.706.866-1.73.878-2.677-.94.029-1.964.19-2.657.885l-.002-.003zm-13.872-.88c.056.958.21 2.007.936 2.708.723.73 1.786.905 2.767.994-.058-1.023-.273-2.13-1.054-2.86-.713-.656-1.705-.827-2.65-.842zm18.287-.512c-.806.711-1.006 1.833-1.077 2.853 1.023-.065 2.143-.281 2.857-1.085.674-.694.793-1.705.853-2.62-.921.056-1.939.17-2.63.852h-.003zm-22.64-.853c.01 1.024.24 2.164 1.064 2.857.725.63 1.705.784 2.634.853-.075-1-.266-2.083-1.023-2.806-.7-.702-1.728-.853-2.675-.905v.001zm13.98-1.656c-.718.72-.897 1.774-.957 2.75.965-.072 2.012-.251 2.728-.962.742-.695.946-1.755.945-2.73-.967.02-2.026.195-2.715.94l-.001.002zm-5.455-.94c.057.916.189 1.91.843 2.61.721.798 1.835 1.008 2.86 1.086-.06-1-.263-2.069-.998-2.8-.706-.71-1.746-.887-2.705-.896zm9.887.253c-.902.7-1.174 1.902-1.214 2.986 1.006-.061 2.094-.278 2.817-1.038.682-.708.852-1.725.852-2.668-.852.063-1.768.16-2.456.72h.001zm-14.071-.72c.054.918.17 1.927.852 2.621.71.814 1.835 1.024 2.86 1.082-.067-1.024-.286-2.14-1.085-2.853-.692-.683-1.705-.793-2.622-.853l-.005.003zm7.007-1.081c-.06-1.04.577-1.953 1.278-2.657.633.682 1.22 1.485 1.258 2.444.038 1.062-.586 1.995-1.275 2.744-.614-.722-1.217-1.549-1.261-2.531zm-.357-7.492A17.674 17.674 0 0136.8 14.488a17.692 17.692 0 01-7.659 20.666 17.674 17.674 0 01-21.847-2.85 17.688 17.688 0 01-2.104-21.94c2.888-4.47 7.875-7.516 13.185-7.961zm-.8-1.248A19.002 19.002 0 0134.491 7.72a19.019 19.019 0 013.702 17.772 19.151 19.151 0 01-7.905 10.482 18.988 18.988 0 01-21.821-.884A18.964 18.964 0 013.154 11.23C5.96 5.799 11.514 1.89 17.585 1.15l-.012.004z",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.155 7.109h1.054v1.854c.602-.614 1.21-1.223 1.793-1.854h1.385c-.616.616-1.245 1.22-1.869 1.83.687.936 1.363 1.876 2.043 2.816h-1.365c-.477-.681-.954-1.363-1.422-2.054l-.565.556v1.498h-1.054V7.11zm8.65.011c.94-.29 2.113-.06 2.698.77.301.455.463.986.466 1.528a2.797 2.797 0 01-.45 1.534c-.885 1.304-3.224 1.2-3.948-.21-.657-1.246-.276-3.184 1.238-3.623l-.005.001zm.337.843c-.859.4-.943 1.552-.62 2.32.29.764 1.46.956 1.98.313a2.035 2.035 0 00.054-2.257c-.293-.453-.93-.56-1.414-.376zm6.191-.854c.965.058 1.97-.142 2.907.143 1.15.372 1.19 2.197.108 2.673-.616.263-1.308.174-1.96.192v1.647h-1.055V7.109zm1.056.86V9.25c.43.018.859.005 1.286-.038.519-.143.543-.971.037-1.152-.425-.135-.883-.076-1.321-.093h-.002zm6.029-.86h4.047v4.651H74.37V8.015h-1.855v3.744h-1.096V7.107v.002zm8.82.046c.903-.314 2.037-.165 2.68.58.69.808.733 2.035.293 2.963-.71 1.482-3.153 1.56-4.011.181-.771-1.211-.444-3.197 1.039-3.729v.005zm.368.841c-.823.483-.888 1.672-.46 2.43.37.66 1.439.758 1.908.154a2.049 2.049 0 00.126-2.12c-.153-.257-.4-.449-.693-.535a1.23 1.23 0 00-.88.071zm6.241-.884c.956.043 1.94-.117 2.878.115 1.128.313 1.258 2.034.31 2.614-.631.357-1.393.256-2.092.278v1.646h-1.096V7.112zm1.098.856v1.285a5.487 5.487 0 001.557-.124c.088-.339.21-.823-.169-1.042-.433-.181-.922-.096-1.381-.119h-.007zm6.797-.86h1.114c.598 1.552 1.202 3.101 1.811 4.65h-1.144l-.374-1.03H94.44l-.39 1.03h-1.107c.597-1.554 1.207-3.1 1.804-4.65h-.005zm.552 1.221c-.192.543-.393 1.082-.59 1.624h1.18c-.199-.539-.398-1.079-.588-1.619l-.002-.005zm5.384-1.22h1.096v3.746h1.855V7.109h1.097v3.744h.506v2.096h-1.054v-1.194h-3.495V7.104l-.005.005zm7.716 0h1.097v3.117c.576-1.04 1.155-2.079 1.735-3.117h1.218v4.651h-1.096V8.62c-.592 1.044-1.164 2.098-1.756 3.145h-1.198V7.11zm7.614 1.89c-.258-.74.16-1.661.981-1.811.964-.165 1.95-.038 2.923-.074v4.651h-1.054v-1.81h-.585c-.46.602-.914 1.213-1.378 1.81h-1.361c.477-.614.951-1.233 1.444-1.839-.409-.197-.866-.444-.97-.919V9zm1.133-.863c-.241.292-.184.79.179.962.506.127 1.026.054 1.538.07v-1.24c-.568.035-1.207-.101-1.717.208zm-26.757 7.981c2.306-.42 4.847-.102 6.774 1.275 1.916 1.338 3.01 3.576 3.235 5.833.283 2.455-.22 5.105-1.856 7.059-1.334 1.629-3.425 2.547-5.532 2.682-2.516.214-5.212-.588-6.903-2.481-1.687-1.85-2.276-4.446-2.082-6.87.139-1.94.857-3.882 2.233-5.314a7.785 7.785 0 014.134-2.184h-.003zm.998 3.448c-1.575.291-2.654 1.719-2.933 3.198-.337 1.724-.246 3.657.766 5.161 1.16 1.73 3.964 2.037 5.487.607 1.091-1.007 1.43-2.544 1.467-3.952.012-1.482-.308-3.11-1.454-4.17-.872-.824-2.169-1.068-3.333-.839v-.005zM49.003 32.558c2.068-5.434 4.26-10.84 6.378-16.261 1.585-.014 3.17-.014 4.756 0 1.972 5.064 3.921 10.146 5.88 15.217.136.346.263.695.366 1.054-1.533.05-3.07.008-4.605.025-.405-.936-.727-1.902-1.123-2.838-1.967 0-3.934-.027-5.904.014-.377.942-.757 1.885-1.151 2.819-1.534-.017-3.069.04-4.6-.033l.003.003zm6.985-6.092a48.2 48.2 0 003.484 0c-.553-1.718-1.165-3.419-1.737-5.13-.56 1.713-1.199 3.404-1.747 5.125v.005zm12.95-9.814c-.044-.456.484-.362.79-.372 3.902.022 7.804-.02 11.705.022.025 1.09.057 2.181-.017 3.271-2.491.012-4.98 0-7.472 0-.194.037-.646-.077-.614.244-.022.86-.035 1.726 0 2.587l.125.189c2.15.07 4.306 0 6.46.031a18.55 18.55 0 010 3.254c-2.102 0-4.205-.02-6.307 0-.261-.038-.308.283-.296.468.016.976-.056 1.96.059 2.937 2.685.011 5.372-.021 8.057.02.027 1.086.054 2.181-.015 3.268-3.897.017-7.793 0-11.687.008a4.236 4.236 0 01-.752-.05 5.867 5.867 0 01-.051-1.061c.012-4.94 0-9.88.01-14.819l.005.003zm34.454-.36c1.42 0 2.843-.032 4.263.016.063 1.986 0 3.972.029 5.956.009.221.038.442.086.658 2.618-.028 5.239.03 7.857-.033.079-2.165-.034-4.337.055-6.503.223-.155.52-.075.776-.1 1.169.017 2.34-.024 3.51.025.057 5.401.02 10.803.019 16.204-1.442.051-2.89.061-4.33 0-.052-2.084.078-4.182-.064-6.257-2.53-.089-5.069-.02-7.602-.033-.282-.06-.319.272-.307.458-.012 1.95.012 3.894-.01 5.842a55.82 55.82 0 01-4.328 0c-.015-4.734 0-9.468 0-14.2-.025-.676-.01-1.354.046-2.028v-.005z",
  fill: "#24292F"
}));

const LogoImages = {
    avito: {
        desktop: avitoDesktop,
        touch: avitoTouch,
    },
    sravniru: {
        desktop: sravniruDesktop,
        touch: sravniruTouch,
    },
    group: {
        desktop: groupDesktop,
        touch: groupTouch,
    },
    m2: {
        desktop: m2Desktop,
        touch: m2Touch,
    },
    'm2-light': {
        desktop: m2Desktop,
        touch: m2Touch,
    },
    'm2-pro': {
        desktop: m2Desktop,
        touch: m2ProTouch,
    },
    vtb: {
        desktop: vtbDesktop,
        touch: vtbTouch,
    },
    aeon: {
        desktop: m2Desktop,
        touch: aeonLogo,
    },
    samolet: {
        desktop: m2Desktop,
        touch: m2Touch,
    },
};

const Logo = ({ variant, transform }) => {
    const logo = LogoImages[variant] || LogoImages.m2;
    const { desktop: LogoDesktop, touch: LogoTouch } = logo;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: cn(styles$F.logo, styles$F.logoDesktop), style: { transform } },
            React.createElement(LogoDesktop, null)),
        React.createElement("span", { className: cn(styles$F.logo, styles$F.logoTouch) },
            React.createElement(LogoTouch, null))));
};

var styles$E = {"iframe":"_3-172-11bEr-OhSmJ"};

const Survey = () => {
    const { currentSurvey, closeCurrentSurvey } = useSurveyContext();
    const [opened, setOpened] = useState(!!currentSurvey);
    useEffect(() => {
        setOpened(true);
    }, [currentSurvey]);
    const handleCloseCurrentSurvey = useCallback(() => {
        setOpened(false);
        closeCurrentSurvey === null || closeCurrentSurvey === void 0 ? void 0 : closeCurrentSurvey();
    }, []);
    if (!currentSurvey) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { opened: opened, size: "l", onClose: handleCloseCurrentSurvey, dataTest: "feedback-survey" },
            React.createElement("iframe", { className: styles$E.iframe, name: "survey", src: currentSurvey.link, "data-scroll-lock-ignore": true }))));
};

var styles$D = {"detectRegionModal":"_3-172-11USt--lQh5","detectRegionModalClose":"_3-172-113rd-s83w2","detectRegionModalIn":"_3-172-118tp-FbblT","detectRegionModalContent":"_3-172-11mwc-seuwa","modal-in":"_3-172-111Xz-NFu3R","detectRegionModalOut":"_3-172-11bs6-Qug1S","modal-out":"_3-172-116k9-sNPD0","detectRegionModalOverlay":"_3-172-11iEC-Tes0R","regionLabel":"_3-172-11upK-1eVlc","regionValue":"_3-172-11xZ5-7xtyi","regionControls":"_3-172-11G7r-weiR7","regionControlsLink":"_3-172-11eli-f9Te2"};

const closingTimeout = 400;
const DetectRegionContent = ({ regionName, onAccept, onDecline }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: styles$D.regionLabel }, "\u0412\u0430\u0448 \u0440\u0435\u0433\u0438\u043E\u043D"),
        React.createElement("div", { className: styles$D.regionValue },
            regionName,
            "?"),
        React.createElement("div", { className: styles$D.regionControls },
            React.createElement(Button$1, { onClick: onAccept, size: "s", dataTest: "detect-region-modal-accept" }, "\u0414\u0430, \u0432\u0435\u0440\u043D\u043E"),
            React.createElement("span", { className: styles$D.regionControlsLink },
                React.createElement(Button$1, { size: "s", variant: "transparent", onClick: onDecline, fullWidth: true, dataTest: "detect-region-modal-decline" }, "\u041D\u0435\u0442, \u0434\u0440\u0443\u0433\u043E\u0439")))));
};
const DetectRegionModal = ({ regionName, opened, onClose, onAccept, onDecline, }) => {
    const [state, close] = useTransitionState(opened, { duration: closingTimeout });
    const handleClose = useCallback(async () => {
        if (state !== 'show')
            return;
        await close();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose, state, close]);
    return (React.createElement("div", { className: cn(styles$D.detectRegionModal, {
            [styles$D.detectRegionModalIn]: state === 'show',
            [styles$D.detectRegionModalOut]: state === 'exit',
        }), "data-test": "detect-region-modal" },
        React.createElement("div", { className: styles$D.detectRegionModalOverlay }),
        React.createElement("div", { className: styles$D.detectRegionModalContent },
            React.createElement("div", { className: styles$D.detectRegionModalClose, onClick: handleClose },
                React.createElement(Icon, { name: "times", size: "s" })),
            React.createElement(DetectRegionContent, { regionName: regionName, onAccept: onAccept, onDecline: onDecline }))));
};

var styles$C = {"title":"_3-172-11aOR-6Cchc","header":"_3-172-11GFJ-c6NXq","form":"_3-172-11jTn-bPNrv","formInput":"_3-172-111sM-RenQq","formButton":"_3-172-11xF0-HjqKq","defaultRegions":"_3-172-11e0V-SRT1C","defaultRegionsCol":"_3-172-11yGI-9JN-2","defaultRegionItem":"_3-172-11hvh-ubkCJ","defaultRegionItemButton":"_3-172-11GFt-if7HQ","defaultRegionItemButtonMain":"_3-172-11f7c-muh5-"};

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const handler = debounce(setDebouncedValue, delay);
    useEffect(() => {
        handler(value);
        return handler.cancel;
    }, [value, delay]);
    return debouncedValue;
};

class GeoApiService {
    constructor(name = 'root') {
        this.transport = axios.create({
            baseURL: `/api/${name}-bff/`,
        });
    }
    async getGeoSuggest(text, cancelToken) {
        return this.transport.get('/api/get-geo-suggest', { params: { text }, cancelToken });
    }
    async getGeoObjectById(regionId) {
        return this.transport.get('/api/get-geo-object-by-id', { params: { regionId } });
    }
    async getGeoObjectByIdV2(regionId) {
        return this.transport.get('/api/get-geo-object-by-id-v2', { params: { regionId } });
    }
    async detectRegion() {
        return this.transport.get('/api/detect-region');
    }
}
const geoApiService = new GeoApiService();

var styles$B = {"suggestions":"_3-172-110Wq--gLyk","suggestion":"_3-172-11yoC-aHqTd","suggestionTitle":"_3-172-113xb-lcBO6","suggestionDescription":"_3-172-11Bn--xZFAL"};

const FETCH_DELAY = 300;
const InputControl = ({ value, onChange, onReset, hasSuggestions }) => {
    const { toggle, opened, control } = useSelectCustomControl();
    const [isVisible, setIsVisible] = useState(false);
    const handleFocus = () => {
        setIsVisible(true);
    };
    const handleBlur = () => {
        setIsVisible(false);
    };
    useEffect(() => {
        if (!isVisible && opened) {
            toggle();
        }
        else if (hasSuggestions && isVisible && !opened) {
            toggle();
        }
        else if (!hasSuggestions && opened) {
            toggle();
        }
    }, [hasSuggestions, opened, isVisible]);
    return (React.createElement("div", { ref: control },
        React.createElement(Input, { size: "l", value: value, placeholder: "\u0413\u043E\u0440\u043E\u0434", dataTest: "change-region-modal-input", onChange: onChange, onReset: onReset, onBlur: handleBlur, onFocus: handleFocus })));
};
const RegionSuggest = ({ value, onChange }) => {
    const [suggestions, setSuggestions] = useState();
    const [inputValue, setInputValue] = useState('');
    const debouncedInputValue = useDebounce(inputValue, FETCH_DELAY);
    const handleInputChange = (inputValue) => {
        value && onChange(undefined);
        setInputValue(inputValue);
    };
    const handleInputReset = () => {
        value && onChange(undefined);
        setSuggestions(undefined);
    };
    useEffect(() => {
        const source = axios.CancelToken.source();
        if (!debouncedInputValue)
            return;
        geoApiService
            .getGeoSuggest(debouncedInputValue, source.token)
            .then(({ data }) => {
            setSuggestions(data);
        })
            .catch((error) => {
            if (axios.isCancel(error))
                return;
        });
        return source.cancel;
    }, [debouncedInputValue]);
    return (React.createElement(Select, null,
        React.createElement(InputControl, { value: (value === null || value === void 0 ? void 0 : value.label) || inputValue, onChange: handleInputChange, onReset: handleInputReset, hasSuggestions: Boolean(suggestions && suggestions.length) }),
        React.createElement(Select.Content, { bounds: true },
            React.createElement("div", { className: styles$B.suggestions, "data-test": "change-region-modal-suggest-list" }, suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((item, index) => (React.createElement("div", { key: item.value, className: styles$B.suggestion, "data-test": `change-region-modal-suggest-item-${index}`, onClick: () => {
                    onChange(item);
                    setSuggestions(undefined);
                } },
                React.createElement("div", { className: styles$B.suggestionTitle }, item.label),
                item.narrowRegion && (React.createElement("div", { className: styles$B.suggestionDescription }, item.narrowRegion.name)))))))));
};

const DEFAULT_REGIONS = [
    {
        id: 3,
        displayName: 'Москва',
    },
    {
        id: 444,
        displayName: 'Санкт-Петербург',
    },
    {
        id: 108,
        displayName: 'Московская область',
    },
    {
        id: 886,
        displayName: 'Ленинградская область',
    },
];
const LEFT_COL = DEFAULT_REGIONS.slice(0, 2);
const RIGHT_COL = DEFAULT_REGIONS.slice(2);
const DefaultRegionItem = ({ region: { id, displayName }, selectedRegionId, onClick }) => {
    const handleClick = () => {
        onClick({
            label: displayName,
            value: id,
        });
    };
    return selectedRegionId === id ? (React.createElement("span", { className: cn(styles$C.defaultRegionItemButton, styles$C.defaultRegionItemButtonMain) }, displayName)) : (React.createElement("button", { className: styles$C.defaultRegionItemButton, onClick: handleClick }, displayName));
};
const ChangeRegionModal = (props) => {
    const [value, setValue] = useState();
    const handleSuggestChange = (suggestion) => {
        setValue(suggestion);
    };
    const handleButtonClick = () => {
        value && props.onRegionSelect(value);
    };
    const handleDefaultRegionItemClick = (suggestion) => {
        props.onRegionSelect(suggestion);
    };
    return (React.createElement(Modal, Object.assign({}, props, { size: "m", dataTest: "change-region-modal" }),
        React.createElement("div", { className: styles$C.header },
            React.createElement(Modal.Header, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u043E\u043D")),
        React.createElement("div", { className: styles$C.title },
            React.createElement(Modal.Title, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u043E\u043D")),
        React.createElement("div", { className: styles$C.form },
            React.createElement("span", { className: styles$C.formInput },
                React.createElement(RegionSuggest, { value: value, onChange: handleSuggestChange })),
            React.createElement("span", { className: styles$C.formButton },
                React.createElement(Button$1, { size: "l", fullWidth: true, onClick: handleButtonClick, dataTest: "change-region-modal-select" }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"))),
        React.createElement("div", { className: styles$C.defaultRegions },
            React.createElement("div", { className: styles$C.defaultRegionsCol }, LEFT_COL.map((region) => (React.createElement("div", { className: styles$C.defaultRegionItem, key: region.id },
                React.createElement(DefaultRegionItem, { region: region, onClick: handleDefaultRegionItemClick, selectedRegionId: props.selectedRegionId }))))),
            React.createElement("div", { className: styles$C.defaultRegionsCol }, RIGHT_COL.map((region) => (React.createElement("div", { className: styles$C.defaultRegionItem, key: region.id },
                React.createElement(DefaultRegionItem, { region: region, onClick: handleDefaultRegionItemClick, selectedRegionId: props.selectedRegionId }))))))));
};

const RegionModals = () => {
    const { userRegionName, userRegionSelectedId, userRegionDetectedId, isDetectRegionModalVisible, isSelectRegionModalVisible, setUserRegion, hideDetectRegionModal, showSelectRegionModal, hideSelectRegionModal, } = useUserRegionContext();
    useEffect(() => {
        preventBodyScrollOverlayOpened(Boolean(isDetectRegionModalVisible || isSelectRegionModalVisible));
    }, [isDetectRegionModalVisible, isSelectRegionModalVisible]);
    const handleDetectRegionModalAccept = () => {
        setUserRegion === null || setUserRegion === void 0 ? void 0 : setUserRegion({ userRegionId: userRegionDetectedId });
        hideDetectRegionModal === null || hideDetectRegionModal === void 0 ? void 0 : hideDetectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_YES);
    };
    const handleDetectRegionModalDecline = () => {
        hideDetectRegionModal === null || hideDetectRegionModal === void 0 ? void 0 : hideDetectRegionModal();
        showSelectRegionModal === null || showSelectRegionModal === void 0 ? void 0 : showSelectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_NO);
    };
    const handleDetectRegionModalClose = () => {
        hideDetectRegionModal === null || hideDetectRegionModal === void 0 ? void 0 : hideDetectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_CROSS);
    };
    const handleSelectRegionModalClose = () => {
        hideSelectRegionModal === null || hideSelectRegionModal === void 0 ? void 0 : hideSelectRegionModal();
    };
    const handleRegionSelect = (region) => {
        const { label, value, narrowRegion } = region;
        if (value !== userRegionSelectedId) {
            setUserRegion === null || setUserRegion === void 0 ? void 0 : setUserRegion({ userRegionId: value, userRegionIdNarrow: narrowRegion === null || narrowRegion === void 0 ? void 0 : narrowRegion.id, userRegionName: label });
        }
        hideSelectRegionModal === null || hideSelectRegionModal === void 0 ? void 0 : hideSelectRegionModal();
        hideDetectRegionModal === null || hideDetectRegionModal === void 0 ? void 0 : hideDetectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_CHANGE);
    };
    useEffect(() => {
        const sub = EventBus.getInstance().subscribe('userRegion:modal:toggle', () => (isSelectRegionModalVisible ? hideSelectRegionModal === null || hideSelectRegionModal === void 0 ? void 0 : hideSelectRegionModal() : showSelectRegionModal === null || showSelectRegionModal === void 0 ? void 0 : showSelectRegionModal()));
        return () => {
            sub.unsubscribe();
        };
    }, [isSelectRegionModalVisible]);
    return (React.createElement(React.Fragment, null,
        isSelectRegionModalVisible && (React.createElement(ChangeRegionModal, { mobile: true, overflow: false, opened: true, onClose: handleSelectRegionModalClose, onRegionSelect: handleRegionSelect, selectedRegionId: userRegionSelectedId })),
        isDetectRegionModalVisible && userRegionName && (React.createElement(DetectRegionModal, { regionName: userRegionName, opened: true, onClose: handleDetectRegionModalClose, onAccept: handleDetectRegionModalAccept, onDecline: handleDetectRegionModalDecline }))));
};

class CookieApiServiceConstructor {
    constructor(name = 'root') {
        this.transport = axios.create({
            baseURL: `/api/${name}-bff/`,
        });
    }
    async setCookieConsent(value) {
        return this.transport.post('/api/set-cookie-consent', { value });
    }
    async setCookieAgreement(userId) {
        return this.transport.post('/api/set-cookie-agreement', { userId });
    }
    async setCookieHeaderPartner(partner) {
        return this.transport.post('/api/set-cookie-header-partner', { partner });
    }
}
const cookieApiService = new CookieApiServiceConstructor();

var styles$A = {"cookie-consent-wrapper":"_3-172-11LyJ-j2bkz","cookie-consent-wrapper-autotest":"_3-172-114la-g7vEf","cookie-consent-content":"_3-172-11QNt-DnVil","cookie-consent-content-modal":"_3-172-11T4I-BIrL9","cookie-consent-collapse-modal":"_3-172-11RR--11xBG","cookie-consent-button":"_3-172-11aE9-2MWRZ","cookie-concent-title":"_3-172-11HTs-Pc-nA","cookie-consent-text":"_3-172-11GIi-S5lkm","cookie-consent-link":"_3-172-11Ipl-GrZT-","headerMenuOpened":"_3-172-11ein-oobEZ","cookie-consent-wrapper-with-navbar":"_3-172-114oF-htQbY","chatWidgetSpecificSelector":"_3-172-11JT3-BRHGa","chatWidget":"_3-172-11WfY-lZrNi","chatWidgetAboveCookie":"_3-172-11uia-rbjb8","chatListButton":"_3-172-119Is-qFHj0","chatWidgetButton":"_3-172-11j37-L1vZd","usedesk-messenger":"_3-172-111BI-pKX5H","control":"_3-172-11Rg6-aALGp"};

const CloseControl = ({ closeToast, notificationType = 'default', onClick }) => {
    const controlCls = cn({
        [styles$A.control]: true,
        [styles$A[notificationType] || styles$A.default]: !!notificationType,
    });
    const handleClick = (event) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        closeToast === null || closeToast === void 0 ? void 0 : closeToast();
    };
    return (React.createElement("button", { className: controlCls, type: "button", "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", "data-test": "close-notification-control", onClick: handleClick },
        React.createElement(Icon, { name: "times", size: "s" })));
};

var styles$z = {"cookie-consent-wrapper":"_3-172-11MVV-bQflQ","cookie-consent-wrapper-autotest":"_3-172-113dU-DoQ-a","cookie-consent-content":"_3-172-11zWq-owbLY","cookie-consent-content-modal":"_3-172-11YW0-fHXJ-","cookie-consent-collapse-modal":"_3-172-11GfK-eLLwj","cookie-consent-button":"_3-172-11aQx-v8Xzi","cookie-concent-title":"_3-172-11u5W-IDq8L","cookie-consent-text":"_3-172-11oF2-RM3aR","cookie-consent-link":"_3-172-1134F-odsD-","headerMenuOpened":"_3-172-11AL4-lX1Oy","cookie-consent-wrapper-with-navbar":"_3-172-119h2-xyBEa","chatWidgetSpecificSelector":"_3-172-11GfN-7w81j","chatWidget":"_3-172-11EBt-yj-Vx","chatWidgetAboveCookie":"_3-172-11YIz-NlG7P","chatListButton":"_3-172-11prJ-ajGdL","chatWidgetButton":"_3-172-11xWL-HuQFh","usedesk-messenger":"_3-172-11Usg-gX6SL","enter":"_3-172-11lxM-cOatC","slideInDown":"_3-172-11yx0-kb-b5","exit":"_3-172-11hIr-W8nRV","slideOutUp":"_3-172-11pRm-gdlxU"};

cssTransition({
    enter: styles$z.enter,
    exit: styles$z.exit,
    duration: [500, 500],
    appendPosition: false,
    collapse: false,
    collapseDuration: 0,
});

const TOAST_CONFIG = {
    autoClose: 4000,
};

var styles$y = {"cookie-consent-wrapper":"_3-172-11hwQ-MBBHx","cookie-consent-wrapper-autotest":"_3-172-11SBU-Hq7RH","cookie-consent-content":"_3-172-11UQb-F3yep","cookie-consent-content-modal":"_3-172-110Pc-TB2pY","cookie-consent-collapse-modal":"_3-172-113V1-Zl8gO","cookie-consent-button":"_3-172-11aPz-TCnTz","cookie-concent-title":"_3-172-11iDz-PLZvQ","cookie-consent-text":"_3-172-1164C-bEKiv","cookie-consent-link":"_3-172-11AmY-P809w","headerMenuOpened":"_3-172-114ol-p-Xud","cookie-consent-wrapper-with-navbar":"_3-172-116TE-6wIQ5","chatWidgetSpecificSelector":"_3-172-11DBM-zQ7el","chatWidget":"_3-172-112Ns-0MTzE","chatWidgetAboveCookie":"_3-172-11V5q-NFmKx","chatListButton":"_3-172-11-TW-eDMO1","chatWidgetButton":"_3-172-11o3y-xrB5F","usedesk-messenger":"_3-172-11zpq-6sQ0M","container":"_3-172-11Jg7-szjAo","withTitle":"_3-172-11iPE-P2MS2","header":"_3-172-1174W-iNY9s","message":"_3-172-113qz-tZXgb","footer":"_3-172-11NfT--TpeU"};

const ToasterContent = (props) => {
    const { title, children, footerFn, closeToast } = props;
    return (React.createElement("div", { className: cn(styles$y.container, title && styles$y.withTitle) },
        title && React.createElement("p", { className: styles$y.header }, title),
        React.createElement("div", { className: styles$y.message }, children),
        footerFn && React.createElement("div", { className: styles$y.footer }, footerFn({ closePopup: closeToast }))));
};

const handleInvalidMessage = (payload) => {
    const errorMessage = 'Root NotificationToaster: Received content is not valid ReactNode!';
    console.error(errorMessage, 'Received payload:', payload);
    Sentry === null || Sentry === void 0 ? void 0 : Sentry.withScope((scope) => {
        scope.setExtras({ receivedNotificationPayload: payload });
        Sentry === null || Sentry === void 0 ? void 0 : Sentry.captureMessage(errorMessage, 'warning');
    });
};
function showToasterNotification({ type = 'default', message, options = {} }) {
    try {
        if (typeof message !== 'string' && !React.isValidElement(message)) {
            handleInvalidMessage({ type, message, options });
            return;
        }
        if (type === 'error' &&
            (window === null || window === void 0 ? void 0 : window.sessionStorage) &&
            window.sessionStorage.getItem('disable-error-notifications')) {
            console.debug('ignored error message', message);
            return;
        }
        const toastOptions = Object.assign(Object.assign(Object.assign({}, TOAST_CONFIG), { className: `root_toaster--${type}`, closeButton: React.createElement(CloseControl, { onClick: options.onClickCloseButton, notificationType: type }) }), options);
        return toast(React.createElement(ToasterContent, { title: options.title, footerFn: options.footerFn }, message), toastOptions);
    }
    catch (err) {
        throw new Error('Root NotificationToaster: something went wrong: ' + err);
    }
}

const parseErrorType = (status) => {
    if (!navigator.onLine) {
        return ErrorType.Offline;
    }
    if (status === 403) {
        return ErrorType.Forbidden;
    }
    if (status === 401) {
        return ErrorType.Unauthorized;
    }
    return ErrorType.Other;
};
const getTrivialErrorTypesMessage = (errorType) => {
    if (errorType === ErrorType.Offline || !navigator.onLine) {
        return MESSAGES.offline;
    }
    if (errorType === ErrorType.Forbidden) {
        return MESSAGES.forbiddenAccess;
    }
    return MESSAGES.defaultError;
};
const isServiceCrashed = (response) => {
    const is500 = (response === null || response === void 0 ? void 0 : response.status) === 500;
    const grpcStatus = response === null || response === void 0 ? void 0 : response.headers[HEADER_NAMES.grpcStatus];
    const grpcMessage = response === null || response === void 0 ? void 0 : response.headers[HEADER_NAMES.grpcMessage];
    const hasNoGrpcHeaders = grpcStatus === undefined && grpcMessage === undefined;
    return is500 && hasNoGrpcHeaders;
};
const isGrpcServiceError = (error) => {
    if (typeof error.code !== 'number') {
        return false;
    }
    return typeof error.details === 'string' || typeof error.message === 'string' || typeof error.metadata === 'object';
};
const extractAxiosErrorMotives = (response, config) => {
    const headers = (response === null || response === void 0 ? void 0 : response.headers) || {};
    if (isServiceCrashed(response)) {
        if ((config === null || config === void 0 ? void 0 : config.method) && ['get', 'delete'].includes(config.method.toLowerCase())) {
            return {
                message: MESSAGES.reloadPage,
                title: MESSAGES.serviceDown,
            };
        }
        else {
            return {
                message: MESSAGES.doNotReloadPage,
                title: MESSAGES.serviceDown,
            };
        }
    }
    const isVaritiBug = headers[HEADER_NAMES.varitiCcr] && (response === null || response === void 0 ? void 0 : response.status) === 502;
    if (isVaritiBug) {
        return {
            message: MESSAGES.needScreenshot,
            title: MESSAGES.unknownError,
            shouldRenderTechDetails: true,
        };
    }
    return { title: MESSAGES.unknownError };
};
const extractAxiosErrorData = (response) => {
    var _a, _b, _c;
    const headers = (response === null || response === void 0 ? void 0 : response.headers) || {};
    const traceId = headers[HEADER_NAMES.traceId];
    const varitiCcr = headers[HEADER_NAMES.varitiCcr];
    const cfRay = headers[HEADER_NAMES.cfRay];
    const headersDate = new Date(String(headers[HEADER_NAMES.date] || ''));
    const date = isValid(headersDate) ? headersDate : new Date();
    const grpcStatus = Number(headers[HEADER_NAMES.grpcStatus] || '');
    const httpStatus = (response === null || response === void 0 ? void 0 : response.status) && Number(response === null || response === void 0 ? void 0 : response.status);
    const grpcMessage = headers[HEADER_NAMES.grpcMessage] && decodeURIComponent(String(headers[HEADER_NAMES.grpcMessage]));
    const httpMessage = (response === null || response === void 0 ? void 0 : response.statusText) || ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.error);
    const reasonMessage = grpcMessage || httpMessage;
    const requestUri = (_b = response === null || response === void 0 ? void 0 : response.config) === null || _b === void 0 ? void 0 : _b.url;
    const location = (_c = window.location) === null || _c === void 0 ? void 0 : _c.toString();
    const userAgent = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
    const parsedType = parseErrorType(httpStatus);
    return {
        traceId,
        grpcStatus,
        httpStatus,
        date,
        varitiCcr,
        cfRay,
        reasonMessage,
        requestUri,
        location,
        userAgent,
        parsedType,
    };
};
const extractErrorData = (error) => {
    var _a;
    let data = {};
    try {
        const parsedMessage = JSON.parse(error.message);
        data = parsedMessage;
    }
    catch (err) {
        data = { message: error.message };
    }
    const status = data.statusCode || data.status;
    const httpStatus = status && Number(status);
    const message = data.message || data.error;
    const reasonMessage = (message === null || message === void 0 ? void 0 : message.startsWith('<html>')) ? 'some HTML (removed)' : message;
    return {
        httpStatus,
        location: (_a = window.location) === null || _a === void 0 ? void 0 : _a.toString(),
        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
        reasonMessage,
        requestUri: data.path,
        date: new Date(),
        parsedType: parseErrorType(httpStatus),
    };
};
const extractGrpcServiceErrorData = (error) => {
    var _a;
    const headers = error.metadata;
    const grpcStatus = (error.code && Number(error.code)) ||
        ((headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.grpcStatus]) && Number(headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.grpcStatus]));
    const httpStatus = error.status;
    const reasonMessage = (error.details || error.message || (headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.grpcMessage]));
    const headersDate = (headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.date]) && new Date(headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.date]);
    const date = isValid(headersDate) ? headersDate : new Date();
    const traceId = headers === null || headers === void 0 ? void 0 : headers[HEADER_NAMES.traceId];
    return {
        httpStatus,
        grpcStatus,
        traceId,
        location: (_a = window.location) === null || _a === void 0 ? void 0 : _a.toString(),
        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
        reasonMessage,
        date,
        parsedType: parseErrorType(httpStatus),
    };
};
const extractNotificationPayloadErrorData = (payload) => {
    var _a, _b, _c;
    return {
        message: payload.message,
        title: ((_a = payload.options) === null || _a === void 0 ? void 0 : _a.title) || '',
        footerFn: (_b = payload === null || payload === void 0 ? void 0 : payload.options) === null || _b === void 0 ? void 0 : _b.footerFn,
        additionalMessage: (_c = payload.options) === null || _c === void 0 ? void 0 : _c.additionalMessage,
    };
};
const mergeErrorDataWithNotificationPayload = (extractedData, payload) => {
    const { title, message, additionalMessage, footerFn } = extractNotificationPayloadErrorData(payload);
    if (!extractedData.ui) {
        extractedData.ui = {};
    }
    if (message) {
        extractedData.ui.message = message;
    }
    if (title) {
        extractedData.ui.title = title;
    }
    if (footerFn) {
        extractedData.ui.footerFn = footerFn;
    }
    if (additionalMessage) {
        extractedData.ui.additionalMessage = additionalMessage;
    }
    return extractedData;
};
const extractErrorDataByType = (rawError) => {
    var _a, _b;
    let extractedData = {};
    if (rawError) {
        if (rawError.isAxiosError) {
            const { response, config } = rawError;
            extractedData = {
                data: extractAxiosErrorData(response),
                ui: extractAxiosErrorMotives(response, config),
            };
        }
        else if (isGrpcServiceError(rawError)) {
            extractedData = {
                data: extractGrpcServiceErrorData(rawError),
                ui: { title: MESSAGES.unknownError },
            };
        }
        else if (rawError instanceof Error) {
            extractedData = {
                data: extractErrorData(rawError),
                ui: { title: MESSAGES.unknownError },
            };
        }
        else if (typeof rawError === 'string') {
            extractedData = { data: { reasonMessage: rawError } };
        }
    }
    if (!((_a = extractedData.ui) === null || _a === void 0 ? void 0 : _a.message)) {
        extractedData.ui = Object.assign(Object.assign({}, extractedData.ui), { message: getTrivialErrorTypesMessage((_b = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _b === void 0 ? void 0 : _b.parsedType) });
    }
    return extractedData;
};

const shouldSendToSentry = (type) => {
    if (Cookies.get('accept_outdated_browser')) {
        return false;
    }
    switch (type) {
        case ErrorType.Offline:
        case ErrorType.Unauthorized:
            return false;
        case ErrorType.Other:
        default:
            return true;
    }
};
const defineEventLevel = (type) => {
    if (type === ErrorType.Forbidden) {
        return 'warning';
    }
    return 'error';
};
const getReasonTag = (extractedData, error) => {
    var _a, _b, _c;
    switch (true) {
        case ((_a = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _a === void 0 ? void 0 : _a.httpStatus) === 403 && isBlockedByQrator(error):
            return 'BLOCKED_BY_QRATOR';
        case ((_b = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _b === void 0 ? void 0 : _b.cfRay) && !extractedData.data.traceId && extractedData.data.httpStatus === 503:
            return 'BLOCKED_BY_CLOUDFLARE';
        case ((_c = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _c === void 0 ? void 0 : _c.cfRay) && !extractedData.data.traceId && extractedData.data.httpStatus === 520:
            return 'NETWORK_ERROR';
        default:
            return undefined;
    }
};
const report = ({ error, extra: receivedExtra, extractedData, description, level, tags: externalTags = {}, fingerprint: externalFingerprint = [], contexts, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!shouldSendToSentry((_a = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _a === void 0 ? void 0 : _a.parsedType)) {
        return;
    }
    const errorData = Object.assign(Object.assign({}, extractedData), { ui: Object.assign(Object.assign({}, extractedData === null || extractedData === void 0 ? void 0 : extractedData.ui), { message: renderToStaticMarkup((_b = extractedData === null || extractedData === void 0 ? void 0 : extractedData.ui) === null || _b === void 0 ? void 0 : _b.message), additionalMessage: renderToStaticMarkup((_c = extractedData === null || extractedData === void 0 ? void 0 : extractedData.ui) === null || _c === void 0 ? void 0 : _c.additionalMessage) }) });
    const extra = Object.assign(Object.assign({ description,
        errorData }, receivedExtra), { error });
    const fingerprint = ['{{ default }}'];
    const tags = Object.assign({ [HEADER_NAMES.traceId]: (_d = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _d === void 0 ? void 0 : _d.traceId, requestUri: (_e = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _e === void 0 ? void 0 : _e.requestUri, statusCode: (_f = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _f === void 0 ? void 0 : _f.httpStatus, reason: getReasonTag(extractedData, error) }, externalTags);
    if (tags.reason) {
        extra.response = error.response;
    }
    if (tags.requestUri && tags.statusCode) {
        fingerprint.push(String(tags.requestUri), String(tags.statusCode));
    }
    const userScope = ((_h = (_g = Sentry === null || Sentry === void 0 ? void 0 : Sentry.getCurrentHub()) === null || _g === void 0 ? void 0 : _g.getScope()) === null || _h === void 0 ? void 0 : _h.getUser()) || {};
    const errorMessage = (typeof error === 'string' ? error : error === null || error === void 0 ? void 0 : error.message) || 'unknown error ' + Date.now();
    const context = {
        user: Object.assign(Object.assign({}, userScope), { ip_address: ((_j = extractedData === null || extractedData === void 0 ? void 0 : extractedData.additionalData) === null || _j === void 0 ? void 0 : _j.deviceIp) || '' }),
        level: level || defineEventLevel((_k = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _k === void 0 ? void 0 : _k.parsedType),
        extra,
        tags,
        fingerprint: (externalFingerprint === null || externalFingerprint === void 0 ? void 0 : externalFingerprint.length) > 0 ? externalFingerprint : fingerprint,
        contexts,
    };
    if (!isError(error)) {
        return Sentry.captureMessage(errorMessage, context);
    }
    return (_l = Sentry.getCurrentHub()
        .getClient()) === null || _l === void 0 ? void 0 : _l.eventFromException(error, {
        captureContext: context,
    }).then((event) => {
        event.message = errorMessage;
        return Sentry.getCurrentHub().captureEvent(event, { captureContext: context });
    }, (error) => {
        if (context.extra) {
            context.extra.eventParseError = error;
        }
        return Sentry.captureMessage(errorMessage, context);
    });
};
async function reportErrorToSentry({ error, extra, level, additionalData = {}, description, notificationPayload, tags, fingerprint, contexts, }) {
    let extractedData = Object.assign(Object.assign({}, extractErrorDataByType(error)), { additionalData });
    if (notificationPayload) {
        extractedData = mergeErrorDataWithNotificationPayload(extractedData, notificationPayload);
    }
    const sentryEventId = await report({
        error,
        extra,
        level,
        extractedData,
        description,
        tags,
        fingerprint,
        contexts,
    });
    return { sentryEventId, extractedData };
}
const restartSentryReplay = async () => {
    const hub = Sentry.getCurrentHub();
    const replay = hub.getIntegration(Sentry.Replay);
    if (replay) {
        await replay.flush();
        await replay.stop();
        replay.start();
    }
};

const DetailedErrorContent = (props) => {
    const { data = {}, ui = {}, additionalData = {}, sentryEventId } = props;
    const { traceId, reasonMessage, date } = data;
    const { deviceIp } = additionalData;
    const { message, shouldRenderTechDetails, additionalMessage } = ui;
    return (React.createElement(React.Fragment, null,
        message && (React.createElement(React.Fragment, null,
            React.createElement("div", null, message),
            " ",
            React.createElement("br", null))),
        React.createElement("div", null, format(date || new Date(), 'dd.MM.yyyy, HH:mm:ss [zzzz]', { locale: ru })),
        traceId && React.createElement("div", null,
            "x-trace-id: ",
            traceId),
        !traceId && deviceIp && React.createElement("div", null,
            "device IP: ",
            deviceIp),
        !traceId && sentryEventId && React.createElement("div", null,
            "sentryEventId: ",
            sentryEventId),
        shouldRenderTechDetails && React.createElement(React.Fragment, null, reasonMessage && React.createElement("div", null, reasonMessage)),
        additionalMessage));
};

const ReportErrorControl = (props) => {
    const { data = {}, ui = {}, additionalData = {}, sentryEventId } = props;
    const { traceId, varitiCcr, reasonMessage, date, requestUri, httpStatus, grpcStatus, location, userAgent } = data;
    const { deviceIp, deviceIpRequestState } = additionalData;
    const { title, message, additionalMessage } = ui;
    const content = '\uFEFF' +
        'Мы скопировали для вас полную информацию об ошибке, чтобы наш сотрудник поддержки смог детально разобраться в проблеме:\n' +
        '----\n' +
        `Заголовок: ${title}\n` +
        `Сообщение: ${renderToStaticMarkup(message)}\n` +
        `Дата: ${date === null || date === void 0 ? void 0 : date.toISOString()}\n` +
        `reason: ${reasonMessage}\n` +
        `x-trace-id: ${traceId || 'не определено'}\n` +
        `sentryEventId: ${sentryEventId || 'не определено'}\n` +
        `requestUri: ${requestUri || 'не определено'}\n` +
        `https-status: ${httpStatus || 'не определено'}\n` +
        `grpc-status: ${grpcStatus || 'не определено'}\n` +
        `x-variti-ccr: ${varitiCcr || 'не определено'}\n` +
        `device IP: ${deviceIp || deviceIpRequestState}\n` +
        `location: ${location || 'не определено'}\n` +
        `userAgent: ${userAgent || 'не определено'}\n` +
        `additionalMessage: ${renderToStaticMarkup(additionalMessage)}\n` +
        '----';
    const link = `mailto:${CALL_CENTER_EMAIL}?Content-Type=text/html&charset=utf-8&body=${encodeURIComponent(content)}`;
    return (React.createElement("a", { href: link },
        React.createElement(Button$1, { variant: "primary-alt-bg", size: "s", block: true, onClick: () => copyToClipboard(content, props.onClose) }, "\u0421\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0435")));
};

const fallbackCopyTextToClipboard = (content) => {
    const textArea = document.createElement('textarea');
    textArea.value = content;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const isSuccessful = document.execCommand('copy');
    document.body.removeChild(textArea);
    if (!isSuccessful) {
        throw new Error('Copying has failed in fallback');
    }
};
const copyToClipboard = async (content, onSuccess) => {
    try {
        if (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) {
            await navigator.clipboard.writeText(content);
        }
        else {
            fallbackCopyTextToClipboard(content);
        }
        const notification = {
            type: 'app:notification',
            data: {
                type: 'info',
                message: 'Информация об ошибке скопирована в буфер обмена',
            },
            category: 'simple',
        };
        EventBus.getInstance().publish(notification);
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    }
    catch (error) {
        Sentry.captureMessage('Copying to clipboard has failed', {
            level: 'warning',
            extra: { error, contentToCopy: content },
        });
    }
};

const composeNotification = (comprehensiveErrorData, sentryEventId) => {
    var _a;
    const notification = {
        type: 'error',
        message: getTrivialErrorTypesMessage((_a = comprehensiveErrorData === null || comprehensiveErrorData === void 0 ? void 0 : comprehensiveErrorData.data) === null || _a === void 0 ? void 0 : _a.parsedType),
        options: { autoClose: false },
    };
    if (comprehensiveErrorData) {
        const { data = {}, ui = {} } = comprehensiveErrorData;
        notification.message = React.createElement(DetailedErrorContent, Object.assign({}, comprehensiveErrorData, { sentryEventId: sentryEventId }));
        const { httpStatus } = data;
        const { title, footerFn } = ui;
        const options = {
            title: `${httpStatus ? httpStatus + ': ' : ''}${title || MESSAGES.unknownError}`,
            footerFn: footerFn ||
                (({ closePopup }) => (React.createElement(ReportErrorControl, Object.assign({}, comprehensiveErrorData, { sentryEventId: sentryEventId, onClose: closePopup })))),
        };
        notification.options = Object.assign(Object.assign({}, notification.options), options);
    }
    return notification;
};
const composeSentryReplayNotification = (notificationPayload, sentryEventId) => {
    var _a, _b;
    const link = `https://sentry.m2.ru/organizations/sentry/issues/?query=${sentryEventId}`;
    return {
        type: (_a = notificationPayload.type) !== null && _a !== void 0 ? _a : 'debug',
        message: (React.createElement(React.Fragment, null,
            React.createElement(Link, { href: link, variant: "text-alt-bg", target: "blank" },
                "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 event \u0432 Sentry: ",
                link),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Button$1, { variant: "primary-alt-bg", size: "xs", fullWidth: true, onClick: () => copyToClipboard(link) }, "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"))),
        options: {
            autoClose: false,
            title: (_b = notificationPayload.options) === null || _b === void 0 ? void 0 : _b.title,
        },
    };
};

const showQratorBlockReportModal = (extractedData, extra, sentryEventId, error) => {
    var _a, _b;
    const ip = (_a = extractedData.additionalData) === null || _a === void 0 ? void 0 : _a.deviceIp;
    const traceId = (_b = extractedData.data) === null || _b === void 0 ? void 0 : _b.traceId;
    const userId = extra === null || extra === void 0 ? void 0 : extra.userStore.user.userId;
    const emailBody = `ip: ${ip}\r\n` +
        `traceId: ${traceId}\r\n` +
        `sentryEventId: ${sentryEventId}\r\n` +
        `userId: ${userId}` +
        `qratorTransactionID: ${extractQratorTransactionId(error)}`;
    const event = {
        type: 'reportModal:show',
        category: 'simple',
        data: {
            email: {
                to: 'helpdesk@mail-m2.ru',
                subject: 'Блокировка Qrator',
                body: encodeURIComponent(emailBody),
            },
            message: `Что-то пошло не&nbsp;так. Запрос заблокирован.<br> IP адрес пользователя: ${ip} <br> Transaction ID: ${extractQratorTransactionId(error)} `,
        },
    };
    EventBus.getInstance().publish(event);
};

const isGtmError = (error) => { var _a; return (_a = error === null || error === void 0 ? void 0 : error.stack) === null || _a === void 0 ? void 0 : _a.includes('googletagmanager.com/gtm.js'); };
const isBlockedByQrator = (error) => {
    const { response } = error || {};
    const { data, status } = response || {};
    return status === 403 && typeof data === 'string' && data.includes('Reason or support ID');
};
const extractQratorTransactionId = (error) => {
    var _a;
    const data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (typeof data === 'string') {
        const regExp = /.*support ID: (\S*)\..*/i;
        const matchResult = data.match(regExp);
        return matchResult && matchResult.length > 0 ? matchResult[1] : null;
    }
    return null;
};
const configureUnhandledErrorsNotification = (additionalClientDataService, extra, displayToasterNotification) => {
    const unhandledPromiseRejectionHandler = async (event) => {
        var _a, _b, _c, _d, _e;
        const axiosRequestBaseUrl = ((_b = (_a = event.reason) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.baseUrl) || ((_d = (_c = event.reason) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.url);
        const isTypeError = event.reason instanceof TypeError;
        const isFetchError = ((_e = event.reason) === null || _e === void 0 ? void 0 : _e.message) === 'Failed to fetch';
        if (!axiosRequestBaseUrl && (!isTypeError || isFetchError)) {
            return;
        }
        const linkRegexp = new RegExp(/(https?:\/\/[^\s]+)/g);
        if (linkRegexp.test(axiosRequestBaseUrl)) {
            const host = new URL(axiosRequestBaseUrl).host;
            if (!host.includes(window.location.host)) {
                return;
            }
        }
        const { sentryEventId, extractedData } = await reportErrorToSentry({
            error: event.reason,
            extra,
            additionalData: additionalClientDataService === null || additionalClientDataService === void 0 ? void 0 : additionalClientDataService.getData(),
            description: 'A promise rejection handled by `window.addEventListener("unhandledrejection")`. See the additional data for more details.',
        });
        if (isBlockedByQrator(event.reason)) {
            showQratorBlockReportModal(extractedData, extra, sentryEventId, event.reason);
            return;
        }
        if (displayToasterNotification && !isGtmError(event.reason)) {
            showToasterNotification(composeNotification(extractedData, sentryEventId));
        }
    };
    const unknownErrorHandler = async (event) => {
        var _a, _b, _c, _d, _e;
        const isCaptchaError = (_b = (_a = event.error) === null || _a === void 0 ? void 0 : _a.stack) === null || _b === void 0 ? void 0 : _b.includes('https://smartcaptcha.yandexcloud.net/captcha.js');
        const isResizeObserverError = event.message === 'ResizeObserver loop completed with undelivered notifications.';
        const { extractedData } = await reportErrorToSentry({
            error: event.error || event,
            extra,
            additionalData: additionalClientDataService === null || additionalClientDataService === void 0 ? void 0 : additionalClientDataService.getData(),
            description: 'An error handled by `window.addEventListener("error")`. See the attached event for more details.',
        });
        const isActionableError = !isGtmError(event.error) &&
            !isCaptchaError &&
            !isResizeObserverError &&
            ((_c = extractedData.ui) === null || _c === void 0 ? void 0 : _c.message) !== MESSAGES.defaultError;
        if (displayToasterNotification && isActionableError) {
            showToasterNotification({
                type: 'error',
                message: (_d = extractedData.ui) === null || _d === void 0 ? void 0 : _d.message,
                options: { toastId: `unknown_error_${(_e = extractedData === null || extractedData === void 0 ? void 0 : extractedData.data) === null || _e === void 0 ? void 0 : _e.parsedType}` },
            });
        }
    };
    window.addEventListener('unhandledrejection', unhandledPromiseRejectionHandler);
    window.addEventListener('error', unknownErrorHandler);
    if (typeof navigator !== 'undefined' && typeof navigator.serviceWorker !== 'undefined') {
        navigator.serviceWorker.addEventListener('message', async (event) => {
            if (typeof event.data === 'object' && event.data.type === 'SENTRY') {
                reportErrorToSentry({
                    error: event.data.error,
                    extra: {
                        tags: event.data.tags,
                    },
                });
            }
        });
    }
};

const daysToMilliseconds = (days) => {
    return days * 24 * 60 * 60 * 1000;
};

const getFirebaseConfig = (appEnv) => {
    if (appEnv === 'production') {
        return {
            apiKey: 'AIzaSyB8lTfF-gqFhq1zyglpytpCcC6xG0GbS2M',
            authDomain: 'm2-web-prod.firebaseapp.com',
            projectId: 'm2-web-prod',
            storageBucket: 'm2-web-prod.appspot.com',
            messagingSenderId: '778643000064',
            appId: '1:778643000064:web:83b495e0a8bd85f10741e5',
        };
    }
    return {
        apiKey: 'AIzaSyDiztlV0cEN8KexD3Sh1R3CfWZ4CSRd0LY',
        authDomain: 'm2-web-test.firebaseapp.com',
        projectId: 'm2-web-test',
        storageBucket: 'm2-web-test.appspot.com',
        messagingSenderId: '551919811727',
        appId: '1:551919811727:web:21384f491cfafb29dc44fa',
        measurementId: 'G-YF9CY37NN8',
    };
};

class FeatureManager {
    constructor(initialState) {
        var _a, _b, _c, _d;
        const environment = (_a = initialState.configStore) === null || _a === void 0 ? void 0 : _a.appEnvironment;
        this.initialTargetingAttributes = (_c = (_b = initialState.growthBookData) === null || _b === void 0 ? void 0 : _b.targetingAttributes) !== null && _c !== void 0 ? _c : {};
        this.client = new GrowthBook({
            enableDevMode: environment !== 'production',
        });
        const payload = (_d = initialState.growthBookData) === null || _d === void 0 ? void 0 : _d.payload;
        if (payload) {
            this.client.initSync({
                streaming: false,
                payload,
            });
        }
        else {
            const error = 'FeatureManager: Payload is empty. Unable to initialize.';
            console.error(error);
            reportErrorToSentry({ error });
        }
        this.initAttributes();
    }
    getFeatureValue(featureName, defaultValue) {
        var _a;
        const featureResult = this.client.evalFeature(featureName);
        if (featureResult.source === 'experiment' && featureResult.experiment && featureResult.experimentResult) {
            window.dataLayer.push({
                event: 'experiment_viewed',
                experiment_id: featureResult.experiment.key,
                variation_id: featureResult.experimentResult.key,
                hash_attribute: featureResult.experimentResult.hashAttribute,
                hash_value: featureResult.experimentResult.hashValue,
            });
        }
        if (this.client.inDevMode()) {
            console.debug('featureManager.getFeatureValue', {
                client: this.client,
                featureName,
                defaultValue,
                featureResult,
            });
        }
        return (_a = featureResult.value) !== null && _a !== void 0 ? _a : defaultValue;
    }
    getExperimentHash(featureName) {
        const featureResult = this.client.evalFeature(featureName);
        if (!featureResult.experiment || !featureResult.experimentResult) {
            return undefined;
        }
        return (featureResult.experimentResult.hashAttribute +
            featureResult.experimentResult.hashValue +
            featureResult.experiment.key +
            featureResult.experimentResult.variationId);
    }
    async updateAttributes(updateAttributes) {
        const growthBookAttributes = transformToGrowthBookAttributes(updateAttributes);
        await this.client.updateAttributes(growthBookAttributes);
        if (this.client.inDevMode()) {
            console.debug('featureManager.updateAttributes', {
                client: this.client,
                initialTargetingAttributes: this.initialTargetingAttributes,
                transformed: growthBookAttributes,
            });
        }
    }
    initAttributes() {
        const growthBookAttributes = transformToGrowthBookAttributes(this.initialTargetingAttributes);
        if (this.client.inDevMode()) {
            console.debug('featureManager.initAttributes', {
                client: this.client,
                initialTargetingAttributes: this.initialTargetingAttributes,
                transformed: growthBookAttributes,
            });
            if (!growthBookAttributes['anonymousUserId']) {
                console.debug('FeatureManager: anonymousUserId targeting attribute is empty.');
            }
        }
        this.client.updateAttributes(growthBookAttributes);
    }
}

function userToUpdateTargetingAttributes(user) {
    var _a;
    let updateAttributes = {
        user: {
            id: undefined,
            currentRoleType: undefined,
            permissions: undefined,
            companyId: undefined,
            franchise: undefined,
        },
    };
    if (user && !isAnonymousUser(user.userId) && user.userId) {
        updateAttributes = {
            user: {
                id: { value: user.userId },
                currentRoleType: { value: user.currentRoleType },
                permissions: { value: user.permissions },
                companyId: { value: (_a = user.companyId) !== null && _a !== void 0 ? _a : undefined },
                franchise: { value: user.franchise },
            },
        };
    }
    return updateAttributes;
}

const useFeatureManagerContext = () => { var _a; return (_a = useContext(ShellConfigContextValue)) === null || _a === void 0 ? void 0 : _a.featureManager; };
function useFeatureValue(featureName, defaultValue, deps = []) {
    const featureManager = useFeatureManagerContext();
    if (!featureManager) {
        console.error('FeatureManager either used in wrong context or not initialized yet');
    }
    const experimentHash = featureManager === null || featureManager === void 0 ? void 0 : featureManager.getExperimentHash(featureName);
    return useMemo(() => {
        var _a;
        return (_a = featureManager === null || featureManager === void 0 ? void 0 : featureManager.getFeatureValue(featureName, defaultValue)) !== null && _a !== void 0 ? _a : defaultValue;
    }, [experimentHash, featureName, defaultValue, featureManager, ...deps]);
}

const sendAnalyticsEvent$1 = (eventAction) => {
    window === null || window === void 0 ? void 0 : window.dataLayer.push({
        event: 'banner-cookies',
        eventCategory: 'cookies',
        eventAction,
        eventLabel: '',
    });
};
const CookieConsentHeaderReactive$1 = () => {
    const { opened } = useCollapseItem();
    return React.createElement(Typography, { variant: "secondary" }, opened ? 'Скрыть' : 'Подробнее');
};
const CookieConsent = ({ hasNavbarOnMobile }) => {
    const [isAutotest, setIsAutotest] = useState(false);
    const featureManager = useFeatureManagerContext();
    const acceptCookies = useCallback(() => {
        cookieApiService
            .setCookieConsent()
            .catch((error) => {
            reportErrorToSentry({
                error,
                extra: { when: 'Failed to set cookie consent' },
                level: 'warning',
            });
        })
            .finally(() => {
            window.__hideCookiesModal();
            featureManager === null || featureManager === void 0 ? void 0 : featureManager.getFeatureValue('discovery-cookie_consent-test_accept', false);
            sendAnalyticsEvent$1('accept');
        });
    }, [featureManager]);
    const rejectCookies = useCallback(() => {
        cookieApiService
            .setCookieConsent('rejected')
            .catch((error) => {
            reportErrorToSentry({
                error,
                extra: { when: 'Failed to set cookie consent' },
                level: 'warning',
            });
        })
            .finally(() => {
            window.__hideCookiesModal();
            sendAnalyticsEvent$1('reject');
        });
    }, []);
    const onCollapseToggle = useCallback((isOpened) => {
        sendAnalyticsEvent$1(isOpened ? 'open_more' : 'close_more');
    }, []);
    useEffect(() => {
        if (typeof navigator !== 'undefined') {
            const isTest = isAutotestUserAgent(window.navigator.userAgent);
            setIsAutotest(isTest);
            if (window.__isCookieModalVisible && !isTest) {
                featureManager === null || featureManager === void 0 ? void 0 : featureManager.getFeatureValue('discovery-cookie_consent-test_show', false);
                sendAnalyticsEvent$1('show');
            }
        }
    }, [featureManager]);
    return (React.createElement("div", { className: cn('cookie-consent-wrapper', isAutotest && 'cookie-consent-wrapper-autotest', hasNavbarOnMobile && 'cookie-consent-wrapper-with-navbar') },
        React.createElement("div", { className: "cookie-consent-content" },
            React.createElement(Collapse, { transparent: true },
                React.createElement(Collapse.Item, { onToggle: onCollapseToggle },
                    React.createElement(Collapse.Title, null,
                        React.createElement("div", { className: "cookie-concent-title" },
                            React.createElement(Typography, { variant: "secondary", color: "secondary" }, "\u041C\u044B\u00A0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u0444\u0430\u0439\u043B\u044B cookie \u0438\u00A0\u0441\u0435\u0440\u0432\u0438\u0441\u044B \u0432\u0435\u0431-\u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438."),
                            React.createElement(CookieConsentHeaderReactive$1, null)),
                        React.createElement(Collapse.TitleAddon, null)),
                    React.createElement(Typography, { variant: "secondary", className: "cookie-consent-text" },
                        "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u00AB\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0435\u00BB \u0432\u044B\u00A0\u0434\u0430\u0451\u0442\u0435",
                        ' ',
                        React.createElement(Link, { href: "https://m2.ru/doc/clients/soglasiya/personal-data-agreement-cookie/", target: "blank" }, "\u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430\u00A0\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 cookie-\u0444\u0430\u0439\u043B\u043E\u0432"),
                        ' ',
                        "(\u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u0432\u00A0",
                        React.createElement(Link, { href: "https://cdn.m2.ru/assets/pdfs/privacy-policy.pdf", target: "blank" }, "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435"),
                        "). \u041C2\u00A0\u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 cookie, \u0432\u00A0\u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u044B \u0432\u0435\u0431-\u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 \u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u0438\u00A0MyTracker \u0441\u00A0\u0446\u0435\u043B\u044C\u044E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0430\u0439\u0442\u0430, \u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043D\u0430\u00A0\u0441\u0430\u0439\u0442\u0435 \u0438\u00A0\u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F. ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("br", null),
                        "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u00AB\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0432\u0441\u0435\u00BB \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442 \u041C2\u00A0\u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 cookie-\u0444\u0430\u0439\u043B\u044B, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u0430\u0439\u0442\u0430. \u0427\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442\u00A0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F cookie-\u0444\u0430\u0439\u043B\u043E\u0432 (\u0432\u00A0\u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445), \u0432\u0430\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442."))),
            React.createElement("div", { className: "cookie-consent-button" },
                React.createElement(Button$1, { dataTest: "reject-cookie-button", fullWidth: true, onClick: rejectCookies, size: "s" }, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0432\u0441\u0435"),
                React.createElement(Button$1, { dataTest: "accept-cookie-button", fullWidth: true, onClick: acceptCookies, size: "s" }, "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0435")))));
};

const sendAnalyticsEvent = (eventAction) => {
    window === null || window === void 0 ? void 0 : window.dataLayer.push({
        event: 'banner-cookies',
        eventCategory: 'cookies',
        eventAction,
        eventLabel: '',
    });
};
const CookieConsentHeaderReactive = () => {
    const { opened } = useCollapseItem();
    return React.createElement(Typography, { variant: "primary" }, opened ? 'Скрыть' : 'Подробнее');
};
const CookieConsentModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const acceptCookies = useCallback(() => {
        cookieApiService
            .setCookieConsent()
            .catch((error) => {
            reportErrorToSentry({
                error,
                extra: { when: 'Failed to set cookie consent' },
                level: 'warning',
            });
        })
            .finally(() => {
            window.__hideCookiesModal();
            sendAnalyticsEvent('accept');
            window.location.reload();
        });
    }, []);
    const rejectCookies = useCallback(() => {
        cookieApiService
            .setCookieConsent('rejected')
            .catch((error) => {
            reportErrorToSentry({
                error,
                extra: { when: 'Failed to set cookie consent' },
                level: 'warning',
            });
        })
            .finally(() => {
            window.__hideCookiesModal();
            sendAnalyticsEvent('reject');
            setIsModalOpen(false);
        });
    }, []);
    const onCollapseToggle = useCallback((isOpened) => {
        sendAnalyticsEvent(isOpened ? 'open_more' : 'close_more');
    }, []);
    useEffect(() => {
        if (typeof navigator !== 'undefined') {
            const isTest = isAutotestUserAgent(window.navigator.userAgent);
            if (window.__isCookieModalVisible && !isTest) {
                setIsModalOpen(true);
                sendAnalyticsEvent('show');
            }
        }
    }, []);
    return (React.createElement(Modal, { size: "m", opened: isModalOpen, closable: false },
        React.createElement("div", { className: "cookie-consent-content-modal" },
            React.createElement(Modal.Title, null, "\u041C\u044B\u00A0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u0444\u0430\u0439\u043B\u044B cookie \u0438\u00A0\u0441\u0435\u0440\u0432\u0438\u0441\u044B \u0432\u0435\u0431\u2011\u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438"),
            "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u00AB\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0435\u00BB \u0432\u044B\u00A0\u0434\u0430\u0451\u0442\u0435",
            ' ',
            React.createElement(Link, { href: "https://cdn.m2.ru/assets/pdfs/personal-data-agreement-cookie.pdf", target: "blank" }, "\u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430\u00A0\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 cookie-\u0444\u0430\u0439\u043B\u043E\u0432"),
            ' ',
            "(\u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u0432\u00A0",
            React.createElement(Link, { href: "https://cdn.m2.ru/assets/pdfs/privacy-policy.pdf", target: "blank" }, "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435"),
            "). \u041C2\u00A0\u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 cookie, \u0432\u00A0\u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u044B \u0432\u0435\u0431-\u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 \u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u0438\u00A0MyTracker \u0441\u00A0\u0446\u0435\u043B\u044C\u044E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0430\u0439\u0442\u0430, \u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043D\u0430\u00A0\u0441\u0430\u0439\u0442\u0435 \u0438\u00A0\u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F.",
            React.createElement("div", { className: "cookie-consent-collapse-modal" },
                React.createElement(Collapse, { transparent: true },
                    React.createElement(Collapse.Item, { onToggle: onCollapseToggle },
                        React.createElement(Collapse.Title, null,
                            React.createElement(CookieConsentHeaderReactive, null),
                            React.createElement(Collapse.TitleAddon, null)),
                        React.createElement(Typography, null, "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u00AB\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0432\u0441\u0435\u00BB \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442, \u041C2\u00A0\u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 cookie-\u0444\u0430\u0439\u043B\u044B, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u0430\u0439\u0442\u0430. \u0427\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442\u00A0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F cookie-\u0444\u0430\u0439\u043B\u043E\u0432 (\u0432\u00A0\u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445), \u0432\u0430\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442.")))),
            React.createElement(Modal.Actions, null,
                React.createElement(Button$1, { dataTest: "accept-cookie-button", fullWidth: true, onClick: acceptCookies, size: "m" }, "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0435"),
                React.createElement(Button$1, { variant: "secondary", dataTest: "reject-cookie-button", fullWidth: true, onClick: rejectCookies, size: "m" }, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0432\u0441\u0435")))));
};

const CookieConsentMain = ({ hasNavbarOnMobile, }) => {
    const { features = [] } = useConfigContext();
    const shouldUseModal = features.some((item) => item.name === 'cookie-consent-required');
    return shouldUseModal ? React.createElement(CookieConsentModal, null) : React.createElement(CookieConsent, { hasNavbarOnMobile: hasNavbarOnMobile });
};

var styles$x = {"button":"_3-172-11MIc-Z5INf","popup":"_3-172-11iL6-QW9F4","closeButton":"_3-172-11A0V-5IfnB","contacts":"_3-172-11qe1-BiCCB","contactsButton":"_3-172-11G0Z--KW4B","icon":"_3-172-11K3C-9v0Ul","text":"_3-172-11eCE-5l6wo"};

const ChatStub = () => {
    const [isOpen, setIsOpen] = useState(false);
    const openPopup = useCallback(() => setIsOpen(true), []);
    const closePopup = useCallback(() => setIsOpen(false), []);
    const { supportPhone = '' } = useConfigContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "chatWidgetButton", onClick: openPopup, "data-gtm": "bank-chat-stub" },
            React.createElement(Icon, { name: "question" })),
        isOpen && (React.createElement("div", { className: styles$x.popup },
            React.createElement("div", { onClick: closePopup, className: cn(styles$x.button, styles$x.closeButton) },
                React.createElement(Icon, { name: "times-circle", size: "s" })),
            React.createElement("p", { className: styles$x.text },
                "\u0415\u0441\u043B\u0438 \u0443\u00A0\u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0438 ",
                React.createElement("br", null),
                "\u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441\u00A0\u043D\u0430\u043C\u0438:"),
            React.createElement("ul", { className: styles$x.contacts },
                React.createElement("li", null,
                    React.createElement("a", { className: styles$x.contactsButton, href: "//wa.me/79917773233", target: "_blank", rel: "noreferrer noopener" },
                        React.createElement("span", { className: styles$x.icon },
                            React.createElement(Icon, { name: "whatsapp" })),
                        "79917773233")),
                React.createElement("li", null,
                    React.createElement("a", { className: styles$x.contactsButton, href: "//telegram.me/M2_b2b_bot", target: "_blank", rel: "noreferrer noopener" },
                        React.createElement("span", { className: styles$x.icon },
                            React.createElement(Icon, { name: "telegram" })),
                        "@M2_b2b_bot")),
                React.createElement("li", null,
                    React.createElement("a", { className: styles$x.contactsButton, href: "mailto:support@team-m2.ru" },
                        React.createElement("span", { className: styles$x.icon },
                            React.createElement(Icon, { name: "envelope" })),
                        "support@team-m2.ru")),
                React.createElement("li", null,
                    React.createElement("a", { className: styles$x.contactsButton, href: `tel:${clearPhone(supportPhone)}` },
                        React.createElement("span", { className: styles$x.icon },
                            React.createElement(Icon, { name: "phone" })),
                        supportPhone)))))));
};

const DEFAULT_REGION_ID = 3;
const SELECTED_COOKIE_MAX_AGE = 365;
const EMPTY_REGION_EXCEPTION_NAME = 'EMPTY_REGION_EXCEPTION';
class EmptyRegionException extends Error {
    constructor() {
        super();
        this.message = 'Could not find region with passed id';
        this.name = EMPTY_REGION_EXCEPTION_NAME;
    }
}
const userRegionInit = (userRegionId, userRegionIdNarrow) => {
    var _a;
    const userRegionInitEvent = {
        type: 'userRegion:init',
        category: 'behavior',
        data: {
            userRegionId,
            userRegionIdNarrow,
        },
    };
    (_a = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.publish(userRegionInitEvent);
};
const userRegionUpdate = ({ userRegionId, userRegionIdNarrow, userRegionName }) => {
    var _a;
    const userRegionUpdateEvent = {
        type: 'userRegion:update',
        category: 'behavior',
        data: {
            userRegionId,
            userRegionIdNarrow,
            userRegionName,
        },
    };
    (_a = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.publish(userRegionUpdateEvent);
};
const userRegionChange = ({ userRegionId, userRegionIdNarrow, userRegionName }) => {
    var _a;
    const userRegionChangeEvent = {
        type: 'userRegion:change',
        category: 'simple',
        data: {
            userRegionId,
            userRegionIdNarrow,
            userRegionName,
        },
    };
    (_a = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.publish(userRegionChangeEvent);
};
const getCookieDomain = (hostname) => {
    if (hostname === 'localhost')
        return;
    if (hostname.includes('ingress'))
        return `.${hostname.substring(hostname.indexOf('ingress'))}`;
    return `.${extractSecondLevelDomain(hostname)}`;
};
const saveUserRegionSelectedCookie = (userRegionId, userRegionIdNarrow) => {
    if (!userRegionId)
        return;
    const userRegionIdSelected = `${userRegionId}${userRegionIdNarrow ? `${USER_REGION_ID_SELECTED_COOKIE_SEPARATOR}${userRegionIdNarrow}` : ''}`;
    Cookies.remove(USER_REGION_ID_SELECTED_COOKIE);
    Cookies.set(USER_REGION_ID_SELECTED_COOKIE, userRegionIdSelected.toString(), {
        expires: SELECTED_COOKIE_MAX_AGE,
        domain: getCookieDomain(location.hostname),
    });
};
const useUserRegion = () => {
    var _a;
    const userRegionSelected = (_a = Cookies.get(USER_REGION_ID_SELECTED_COOKIE)) === null || _a === void 0 ? void 0 : _a.split(USER_REGION_ID_SELECTED_COOKIE_SEPARATOR);
    const userRegionDetectedId = parseInt(Cookies.get(USER_REGION_ID_DETECTED_COOKIE) || '') || DEFAULT_REGION_ID;
    const [userRegionSelectedId, setUserRegionSelectedId] = useState(parseInt((userRegionSelected === null || userRegionSelected === void 0 ? void 0 : userRegionSelected[0]) || ''));
    const [userRegionSelectedIdNarrow, setUserRegionSelectedIdNarrow] = useState(parseInt((userRegionSelected === null || userRegionSelected === void 0 ? void 0 : userRegionSelected[1]) || ''));
    const [userRegionName, setUserRegionName] = useState();
    const userRegionId = useMemo(() => userRegionSelectedId || userRegionDetectedId, [userRegionSelectedId, userRegionDetectedId]);
    const callInitEvent = useCallback(() => userRegionInit(userRegionSelectedId || userRegionDetectedId, userRegionSelectedIdNarrow), [userRegionSelectedId, userRegionDetectedId, userRegionSelectedIdNarrow]);
    const [isDetectRegionModalVisible, setIsDetectRegionModalVisible] = useState(false);
    const [isSelectRegionModalVisible, setIsSelectRegionModalVisible] = useState(false);
    const fetchUserRegion = useCallback(() => {
        geoApiService
            .getGeoObjectByIdV2(userRegionId)
            .then(({ data }) => {
            if (!data)
                throw new EmptyRegionException();
            setUserRegionName(data.displayName);
        })
            .catch((error) => {
            if (!(error instanceof EmptyRegionException)) {
                reportErrorToSentry({ error, extra: { userRegionId } });
            }
            geoApiService
                .detectRegion()
                .then(({ data }) => {
                setUserRegionName(data.displayName);
                setUserRegionSelectedId(undefined);
                setUserRegionSelectedIdNarrow(undefined);
            })
                .catch((error) => {
                reportErrorToSentry({ error });
            });
        });
    }, [userRegionId]);
    const callSubscribe = useCallback(() => {
        var _a;
        const disposables = [
            (_a = EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.subscribe('userRegion:update', ({ data }) => {
                let hasChanged = false;
                if (userRegionId !== data.userRegionId) {
                    setUserRegionSelectedId(data.userRegionId);
                    hasChanged = true;
                }
                if (userRegionSelectedIdNarrow !== data.userRegionIdNarrow) {
                    setUserRegionSelectedIdNarrow(data.userRegionIdNarrow);
                    hasChanged = true;
                }
                if (data.userRegionName && userRegionName !== data.userRegionName) {
                    setUserRegionName(data.userRegionName);
                }
                if (hasChanged) {
                    saveUserRegionSelectedCookie(data.userRegionId, data.userRegionIdNarrow);
                }
            }, {
                eventCategory: 'behavior',
            }),
        ];
        return () => {
            disposables.forEach((disposable) => disposable === null || disposable === void 0 ? void 0 : disposable.unsubscribe());
        };
    }, [
        userRegionId,
        setUserRegionSelectedId,
        userRegionSelectedIdNarrow,
        setUserRegionSelectedIdNarrow,
        userRegionName,
        setUserRegionName,
    ]);
    useEffect(() => {
        var _a;
        const disposables = [
            (_a = EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.subscribe('userRegion:change', ({ data: { userRegionId, userRegionIdNarrow, userRegionName } }) => {
                setUserRegionSelectedId(userRegionId);
                setUserRegionSelectedIdNarrow(userRegionIdNarrow);
                if (userRegionName)
                    setUserRegionName(userRegionName);
                saveUserRegionSelectedCookie(userRegionId, userRegionIdNarrow);
            }),
        ];
        return () => {
            disposables.forEach((disposable) => disposable === null || disposable === void 0 ? void 0 : disposable.unsubscribe());
        };
    }, [
        userRegionId,
        setUserRegionSelectedId,
        userRegionSelectedIdNarrow,
        setUserRegionSelectedIdNarrow,
        userRegionName,
        setUserRegionName,
    ]);
    useEffect(() => {
        if (userRegionId && userRegionName) {
            userRegionUpdate({
                userRegionId,
                userRegionName,
                userRegionIdNarrow: userRegionSelectedIdNarrow,
            });
        }
    }, [userRegionId, userRegionName, userRegionSelectedIdNarrow]);
    return {
        userRegionDetectedId,
        userRegionSelectedId,
        userRegionSelectedIdNarrow,
        userRegionName,
        userRegionId,
        isDetectRegionModalVisible,
        isSelectRegionModalVisible,
        callInitEvent,
        callSubscribe,
        fetchUserRegion,
        setUserRegion: userRegionChange,
        updateUserRegion: userRegionUpdate,
        showDetectRegionModal: useCallback(() => setIsDetectRegionModalVisible(true), []),
        hideDetectRegionModal: useCallback(() => setIsDetectRegionModalVisible(false), []),
        showSelectRegionModal: useCallback(() => setIsSelectRegionModalVisible(true), []),
        hideSelectRegionModal: useCallback(() => setIsSelectRegionModalVisible(false), []),
    };
};

const useSurvey = () => {
    const { user } = useAuthorizeContext();
    const [surveys, setSurveys] = useState([]);
    const closeCurrentSurvey = useCallback(() => setSurveys((surveys) => surveys.slice(1)), [surveys]);
    const authIdQuery = (user === null || user === void 0 ? void 0 : user.userId) ? `ap_auth_id=${user.userId}&` : '';
    useEffect(() => {
        const sub = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance().subscribe('survey:show', (event) => {
            const survey = {
                type: event.data.type,
                link: `${event.data.link}?${authIdQuery}${querystring.stringify(event.data.query)}`,
            };
            setSurveys((surveys) => [...surveys, survey]);
        });
        return () => {
            sub.unsubscribe();
        };
    }, [user === null || user === void 0 ? void 0 : user.userId]);
    return {
        currentSurvey: surveys[0],
        closeCurrentSurvey,
    };
};

const useCheckAuthState = (disableCheckAuthState) => {
    const { isAuthorized } = useAuthorizeContext();
    const [, setPageHidden] = useState(false);
    const handleVisibilityChange = () => {
        setPageHidden((prevPageHiddenState) => {
            var _a;
            if (!document.hidden && prevPageHiddenState && isAuthorized && !disableCheckAuthState) {
                const checkIfSessionExpiredEvent = {
                    type: 'auth:checkIfSessionExpired',
                    category: 'simple',
                    data: {},
                };
                (_a = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.publish(checkIfSessionExpiredEvent);
            }
            return document.hidden;
        });
    };
    useEffect(() => {
        if (typeof document.hidden !== 'undefined') {
            const visibilityChangeEventName = 'visibilitychange';
            document.addEventListener(visibilityChangeEventName, handleVisibilityChange);
            return () => {
                document.removeEventListener(visibilityChangeEventName, handleVisibilityChange);
            };
        }
        return () => {
        };
    }, [isAuthorized, disableCheckAuthState]);
};

class UpdatesApiService {
    constructor(name = 'root') {
        this.transport = axios.create({
            baseURL: `/api/${name}-bff/`,
            retriesConfig: {
                retries: 0,
            },
        });
    }
    async getUpdates(services, signal) {
        return this.transport.get('/api/get-updates', { params: { services }, signal });
    }
}
const updatesApiService = new UpdatesApiService();

const eventBus$1 = EventBus.getInstance();
const UPDATES_POLL_INTERVAL_MS = 20 * 1000;
const useUpdates = () => {
    const { user, isAuthorized } = useAuthorizeContext();
    const [servicesUpdates, setServicesUpdates] = useState({});
    const refresh = useCallback((services) => {
        const event = {
            type: 'updates:refresh',
            category: 'simple',
            data: {
                services,
            },
        };
        eventBus$1.publish(event);
    }, []);
    useEffect(() => {
        if (!isAuthorized)
            return;
        let abortController;
        const broadcastChannel = typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel('updates');
        const refreshData = async (services) => {
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
            const controller = typeof AbortController !== 'undefined' ? new AbortController() : undefined;
            abortController = controller;
            try {
                const { data } = await updatesApiService.getUpdates(services, controller === null || controller === void 0 ? void 0 : controller.signal);
                setServicesUpdates((servicesUpdates) => (Object.assign(Object.assign({}, servicesUpdates), data)));
            }
            catch (error) {
                if (controller === null || controller === void 0 ? void 0 : controller.signal.aborted)
                    return;
                reportErrorToSentry({ error });
            }
        };
        refreshData();
        const sub = eventBus$1.subscribe('updates:refresh', ({ data }) => {
            if (!isAuthorized)
                return;
            const { services } = data;
            refreshData(services);
            broadcastChannel === null || broadcastChannel === void 0 ? void 0 : broadcastChannel.postMessage({ services });
        });
        const handleBroadcastChannelMessage = (event) => {
            refreshData(event.data.services);
        };
        let pollIntervalId;
        if (broadcastChannel) {
            broadcastChannel.addEventListener('message', handleBroadcastChannelMessage);
        }
        else {
            pollIntervalId = setInterval(() => refreshData(), UPDATES_POLL_INTERVAL_MS);
        }
        return () => {
            sub.unsubscribe();
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
            if (broadcastChannel) {
                broadcastChannel.removeEventListener('message', handleBroadcastChannelMessage);
                broadcastChannel.close();
            }
            else if (pollIntervalId) {
                clearInterval(pollIntervalId);
            }
        };
    }, [isAuthorized, user === null || user === void 0 ? void 0 : user.userId]);
    return { servicesUpdates, refresh };
};

const useReportModal = () => {
    const [reportModal, setReportModal] = useState({ isOpened: false });
    useEffect(() => {
        const sub = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance().subscribe('reportModal:show', (event) => {
            setReportModal(Object.assign(Object.assign({}, event.data), { isOpened: true }));
        });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    return reportModal;
};

var styles$w = {"image":"_3-172-11yr--YrHM7","title":"_3-172-11DMX-k-KVJ","text":"_3-172-11rCC-g0z5k","actions":"_3-172-11qhZ-zkneN"};

const defaultMessage = `Что-то пошло не\u00a0так. Обновите страницу или зайдите позже.`;
const ReportModal = () => {
    const { reportModal } = useShellContext();
    const { cdnUrl } = useConfigContext();
    const { email: { to = 'sales@team-m2.ru', subject = 'Ошибка на сайте m2.ru', body = '' } = {}, message } = reportModal;
    return (React.createElement(Modal, { opened: Boolean(reportModal.isOpened), size: "s", closable: false },
        React.createElement("img", { className: styles$w.image, src: `${cdnUrl}/assets/file-upload-server/632415a85d1bd46cb9f4a3a18258431d.svg` }),
        React.createElement("div", { className: styles$w.title },
            React.createElement(Modal.Title, null, "\u041E\u0448\u0438\u0431\u043A\u0430")),
        message ? (React.createElement("p", { className: styles$w.text, dangerouslySetInnerHTML: { __html: message } })) : (React.createElement("p", { className: styles$w.text }, defaultMessage)),
        React.createElement("div", { className: styles$w.actions },
            React.createElement(Button$1, { fullWidth: true, onClick: () => window.location.reload() }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"),
            React.createElement(Button$1, { fullWidth: true, href: `mailto:${to}?subject=${subject}&body=${body}`, variant: "secondary" }, "\u0421\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0435"))));
};

const useSyncAuthState = () => {
    const { user } = useAuthorizeContext();
    useEffect(() => {
        setLastAuth({
            username: user === null || user === void 0 ? void 0 : user.username,
            isAuthorized: Boolean(user === null || user === void 0 ? void 0 : user.isAuthenticated),
            currentRoleType: user === null || user === void 0 ? void 0 : user.currentRoleType,
            userId: user === null || user === void 0 ? void 0 : user.userId,
        });
    }, [user]);
};

function executeWithCaptcha({ payload, retryCount = 0, }) {
    const eventBus = EventBus.getInstance();
    return new Promise((resolve) => {
        var _a;
        const subscriptions = [
            eventBus.subscribe('captcha:challenge-passed', async ({ data }) => {
                var _a, _b, _c;
                (_a = payload.onCapthaPassed) === null || _a === void 0 ? void 0 : _a.call(payload);
                subscriptions.forEach((s) => s.unsubscribe());
                try {
                    const response = await payload.callback(data.token);
                    const resolvedEvent = {
                        type: 'captcha:execute:resolved',
                        category: 'simple',
                        data: {
                            resolvedData: response,
                        },
                    };
                    eventBus.publish(resolvedEvent);
                }
                catch (err) {
                    const status = (_b = err.response) === null || _b === void 0 ? void 0 : _b.status;
                    if (status === 422 && retryCount < 2) {
                        executeWithCaptcha({ payload, retryCount: retryCount + 1 });
                    }
                    else {
                        (_c = payload.onError) === null || _c === void 0 ? void 0 : _c.call(payload, err);
                    }
                }
                finally {
                    resolve();
                }
            }),
            eventBus.subscribe('captcha:challenge-hidden', () => {
                var _a;
                (_a = payload.onCaptchaChallengeClosed) === null || _a === void 0 ? void 0 : _a.call(payload);
                subscriptions.forEach((s) => s.unsubscribe());
                resolve();
            }),
            eventBus.subscribe('captcha:challenge-visible', () => {
                var _a;
                (_a = payload.onCaptchaChallengeVisible) === null || _a === void 0 ? void 0 : _a.call(payload);
            }),
        ];
        const showCaptchaEvent = {
            type: 'captcha:show',
            category: 'simple',
            data: { useTrustToken: true },
        };
        eventBus.publish(showCaptchaEvent);
        (_a = payload.onCaptchaShow) === null || _a === void 0 ? void 0 : _a.call(payload);
    });
}

const Captcha = () => {
    const { yandexCaptcha, features = [] } = useConfigContext();
    const [visible, setVisible] = useState(false);
    const [hideShield, setHideShield] = useState(true);
    const [testMode, setTestMode] = useState(false);
    const [captchaEnabled, setCaptchaEnabled] = useState(false);
    useEffect(() => {
        const isCaptchaEnabled = features.some((item) => item.name === 'yandex-captcha');
        const isAutotest = isAutotestUserAgent(navigator.userAgent);
        const captchaEnabled = !TRUSTED_HOSTS.includes(document.location.hostname) && isCaptchaEnabled && !isAutotest;
        setCaptchaEnabled(captchaEnabled);
    }, [features]);
    const handleChallengeHidden = useCallback(() => {
        setVisible(false);
        setHideShield(true);
        const event = {
            type: 'captcha:challenge-hidden',
            category: 'simple',
            data: {},
        };
        EventBus.getInstance().publish(event);
    }, []);
    const handleChallengeVisible = useCallback(() => {
        const event = {
            type: 'captcha:challenge-visible',
            category: 'simple',
            data: {},
        };
        EventBus.getInstance().publish(event);
    }, []);
    const handleCaptchaChallengePassed = useCallback((token) => {
        setVisible(false);
        setHideShield(true);
        const event = {
            type: 'captcha:challenge-passed',
            category: 'simple',
            data: {
                token,
            },
        };
        EventBus.getInstance().publish(event);
    }, []);
    useEffect(() => {
        const eventBus = (window.eventBus = EventBus.getInstance());
        const subscriptions = [
            eventBus.subscribe('captcha:show', ({ data }) => {
                const trustTokenCookieName = 'trust_token';
                const isTrustedUser = (data === null || data === void 0 ? void 0 : data.useTrustToken) && Boolean(Cookies.get(trustTokenCookieName));
                if (!captchaEnabled || isTrustedUser) {
                    handleCaptchaChallengePassed('');
                    return;
                }
                setTestMode(Boolean(data.test));
                setHideShield(false);
                setVisible(true);
            }),
            eventBus.subscribe('captcha:execute', ({ data }) => {
                executeWithCaptcha({ payload: data });
            }),
        ];
        return () => {
            subscriptions.forEach((subscription) => subscription.unsubscribe());
        };
    }, [captchaEnabled, handleCaptchaChallengePassed]);
    if (captchaEnabled) {
        if (!(yandexCaptcha === null || yandexCaptcha === void 0 ? void 0 : yandexCaptcha.clientKey)) {
            reportErrorToSentry({ error: new Error('yandex captcha client key was not configured') });
            return null;
        }
        return (React.createElement(InvisibleSmartCaptcha, { language: "ru", sitekey: yandexCaptcha.clientKey, test: testMode, hideShield: hideShield, onSuccess: handleCaptchaChallengePassed, visible: visible, onChallengeHidden: handleChallengeHidden, onChallengeVisible: handleChallengeVisible }));
    }
    return null;
};

const OfflineEventListener = () => {
    const toastId = useRef(null);
    const handleOffline = useCallback(() => {
        toastId.current = showToasterNotification({
            type: 'info',
            message: (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "h4", bold: true }, "\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A\u00A0\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443"),
                React.createElement(Typography, { variant: "primary" }, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u00A0\u0432\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u0432\u0438\u0430\u0440\u0435\u0436\u0438\u043C"))),
            options: {
                autoClose: false,
            },
        });
    }, []);
    const handleOnline = useCallback(() => {
        if (toastId.current) {
            toast.dismiss(toastId.current);
            toastId.current = null;
            showToasterNotification({
                type: 'info',
                message: React.createElement(React.Fragment, null, "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u00A0\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E"),
            });
        }
    }, []);
    useEffect(() => {
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        return () => {
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
        };
    }, [handleOffline, handleOnline]);
    return null;
};

const checkCaptchaResourcesAvailable = async () => {
    try {
        const response = await axios.get('https://smartcaptcha.yandexcloud.net/captcha.js?withoutProxy=true', {
            timeout: 3000,
        });
        if (String(response.headers['Content-Type'] || '').includes('html')) {
            return Sentry.setTag('load-captcha-error', true);
        }
        return Sentry.setTag('load-captcha-error', false);
    }
    catch (error) {
        Sentry.setTag('load-captcha-error', true);
    }
};

const noop = () => { };
function on(obj, ...args) {
    if (obj && obj.addEventListener) {
        obj.addEventListener(...args);
    }
}
function off(obj, ...args) {
    if (obj && obj.removeEventListener) {
        obj.removeEventListener(...args);
    }
}
const isNavigator = typeof navigator !== 'undefined';
const usePermission = (permissionDesc) => {
    const [state, setState] = useState('');
    useEffect(() => {
        let mounted = true;
        let permissionStatus = null;
        const onChange = () => {
            if (!mounted) {
                return;
            }
            setState(() => { var _a; return (_a = permissionStatus === null || permissionStatus === void 0 ? void 0 : permissionStatus.state) !== null && _a !== void 0 ? _a : ''; });
        };
        if (isNavigator && navigator.permissions) {
            navigator.permissions
                .query(permissionDesc)
                .then((status) => {
                permissionStatus = status;
                on(permissionStatus, 'change', onChange);
                onChange();
            })
                .catch(noop);
        }
        return () => {
            permissionStatus && off(permissionStatus, 'change', onChange);
            mounted = false;
            permissionStatus = null;
        };
    }, [permissionDesc]);
    return state;
};

const useNotifications = () => {
    const { appEnvironment } = useConfigContext();
    const { user } = useAuthorizeContext();
    const firebaseAppRef = useRef();
    const notificationsState = usePermission({ name: 'notifications' });
    const registerToken = useCallback(async () => {
        var _a;
        const serviceWorkerRegistration = await ((_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.ready);
        const isSupportedFirebaseApi = await isSupported();
        if (isSupportedFirebaseApi) {
            const messaging = getMessaging();
            const token = await getToken(messaging, {
                serviceWorkerRegistration: serviceWorkerRegistration,
            });
            if (token !== localStorage.getItem('push_subscription') ||
                (user === null || user === void 0 ? void 0 : user.userId) !== localStorage.getItem('push_subscription_user_id')) {
                await register({
                    data: {
                        token: {
                            value: token,
                            tokenProvider: 'TOKEN_PROVIDER_FIREBASE',
                            browser: {
                                description: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                            },
                        },
                    },
                });
                localStorage.setItem('push_subscription', token);
                localStorage.setItem('push_subscription_user_id', (user === null || user === void 0 ? void 0 : user.userId) || '');
            }
        }
    }, [user]);
    useEffect(() => {
        firebaseAppRef.current = initializeApp(getFirebaseConfig(appEnvironment || 'test'));
    }, []);
    useEffect(() => {
        if (typeof navigator !== 'undefined') {
            if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
                const messaging = getMessaging();
                onMessage(messaging, (payload) => {
                    var _a, _b, _c;
                    const notificationTitle = ((_a = payload.notification) === null || _a === void 0 ? void 0 : _a.title) || ((_b = payload.data) === null || _b === void 0 ? void 0 : _b.title) || '';
                    (_c = navigator.serviceWorker) === null || _c === void 0 ? void 0 : _c.ready.then((res) => {
                        var _a, _b;
                        if (!(document === null || document === void 0 ? void 0 : document.hidden)) {
                            res.showNotification(notificationTitle, Object.assign(Object.assign({}, payload), { body: ((_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.body) || '', icon: (_b = payload === null || payload === void 0 ? void 0 : payload.data) === null || _b === void 0 ? void 0 : _b.icon }));
                        }
                    });
                });
            }
        }
    }, []);
    useEffect(() => {
        if ((user === null || user === void 0 ? void 0 : user.isAuthenticated) && notificationsState === 'granted') {
            registerToken();
        }
    }, [notificationsState, registerToken, user]);
    const subscribe = useCallback(async (closeModal) => {
        var _a;
        const permission = await (Notification === null || Notification === void 0 ? void 0 : Notification.requestPermission());
        if (permission === 'granted') {
            const serviceWorkerRegistration = await ((_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.ready);
            const isSupportedFirebaseApi = await isSupported();
            if (isSupportedFirebaseApi) {
                const messaging = await getMessaging(firebaseAppRef.current);
                closeModal();
                const token = await getToken(messaging, {
                    serviceWorkerRegistration: serviceWorkerRegistration,
                });
                register({
                    data: {
                        token: {
                            value: token,
                            tokenProvider: 'TOKEN_PROVIDER_FIREBASE',
                            browser: {
                                description: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                            },
                        },
                    },
                });
                localStorage.setItem('push_subscription', token);
                localStorage.setItem('push_subscription_user_id', (user === null || user === void 0 ? void 0 : user.userId) || '');
            }
            else {
                closeModal();
            }
        }
    }, [user]);
    return {
        subscribe,
        shouldShowSubscribeModal: typeof navigator !== 'undefined' && !isAutotestUserAgent(navigator.userAgent),
    };
};

var styles$v = {"imageContainer":"_3-172-11GQ3-LSjN-","buttonsContainer":"_3-172-11OU6-HNzit"};

const webPushAcceptModalName = 'webPushAcceptModal';
const sendAcceptModalAnalyticEvent = (eventName) => {
    return window.dataLayer.push({
        event: 'lk_action',
        page_type: 'lk',
        section: 'all',
        type: eventName,
    });
};
const WebPushAcceptModal = observer(({ modalStore, subscribe }) => {
    const shouldRenderModal = React.useMemo(() => {
        const isNotStandaloneIos = typeof Notification === 'undefined' && osName === 'iOS';
        if (isNotStandaloneIos) {
            return true;
        }
        const isNotificationsUnsupportedOrDenied = typeof Notification === 'undefined' || (Notification === null || Notification === void 0 ? void 0 : Notification.permission) === 'denied';
        const isNotificationSubscribed = typeof Notification !== 'undefined' && (Notification === null || Notification === void 0 ? void 0 : Notification.permission) === 'granted';
        if (isNotificationsUnsupportedOrDenied || isNotificationSubscribed) {
            return false;
        }
        return true;
    }, []);
    useEffect(() => {
        const eventBus = EventBus.getInstance();
        const sub = eventBus.subscribe('webPush:show', () => {
            const webPushAcceptModalInfo = JSON.parse(localStorage.getItem('webPushAcceptModal') || '{}');
            if ((!webPushAcceptModalInfo.lastSeen ||
                new Date(webPushAcceptModalInfo.lastSeen).getTime() +
                    daysToMilliseconds(webPushAcceptModalInfo.closeType === 'CANCELED' ? 90 : 1) <=
                    Date.now()) &&
                shouldRenderModal) {
                localStorage.setItem('webPushAcceptModal', JSON.stringify({
                    lastSeen: new Date().toISOString(),
                }));
                sendAcceptModalAnalyticEvent('pu_show_chat_web_push');
                modalStore === null || modalStore === void 0 ? void 0 : modalStore.openModal(webPushAcceptModalName);
            }
            return () => {
                sub.unsubscribe();
            };
        });
    }, [modalStore, shouldRenderModal]);
    const [shouldShowIosInstruction, setShouldShowIosInstruction] = useState(false);
    const [isSubscribeBtnDisabled, setIsSubscribeBtnDisabled] = useState(false);
    const closeModal = useCallback(() => {
        modalStore === null || modalStore === void 0 ? void 0 : modalStore.closeModal(webPushAcceptModalName);
    }, [modalStore]);
    const handleClick = useCallback(() => {
        sendAcceptModalAnalyticEvent('pu_consent_chat_web_push');
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
            window.matchMedia('(display-mode: fullscreen)').matches;
        if (osName === 'iOS' && !isStandalone) {
            return setShouldShowIosInstruction(true);
        }
        setIsSubscribeBtnDisabled(true);
        return subscribe(closeModal);
    }, [closeModal, subscribe]);
    if (!shouldRenderModal) {
        return null;
    }
    return (React.createElement(Modal, { opened: (modalStore === null || modalStore === void 0 ? void 0 : modalStore.isOpen(webPushAcceptModalName)) || false, onClose: () => {
            closeModal();
            localStorage.setItem('webPushAcceptModal', JSON.stringify({
                lastSeen: new Date().toISOString(),
                closeType: 'CLOSE',
            }));
            sendAcceptModalAnalyticEvent('pu_close_chat_web_push');
        }, size: "s", dataTest: "web-push-modal" }, shouldShowIosInstruction ? (React.createElement(React.Fragment, null,
        React.createElement(Modal.Content, null,
            React.createElement("ol", null,
                React.createElement("li", null, "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0435\u0440\u0441\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E iOS, \u043E\u043D\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0432\u044B\u0448\u0435 16.4: \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u2192 \u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u2192 \u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u041F\u041E."),
                React.createElement("li", null, "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u0430\u0439\u0442 m2.ru \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435 Safari"),
                React.createElement("li", null, "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u0430\u0439\u0442 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D\u0430: \u0432 \u043D\u0438\u0436\u043D\u0435\u043C \u043C\u0435\u043D\u044E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043A\u043E\u043D\u043A\u0430 \u00AB\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\u00BB \u2192 \u043D\u0430 \u044D\u043A\u0440\u0430\u043D \u00AB\u0414\u043E\u043C\u043E\u0439\u00BB"),
                React.createElement("li", null, "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u0443\u044E \u0438\u043A\u043E\u043D\u043A\u0443 \u041C2 \u0438 \u0432\u043E\u0439\u0434\u0438\u0442\u0435 \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"),
                React.createElement("li", null, "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E\u043F\u0440\u043E\u0441\u0438\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u00AB\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C\u00BB")),
            React.createElement("b", null, "\u0413\u043E\u0442\u043E\u0432\u043E \u2014 \u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u0441\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438\u0437 \u0447\u0430\u0442\u043E\u0432.")),
        React.createElement(Modal.Actions, null,
            React.createElement("div", { className: styles$v.buttonsContainer },
                React.createElement(Button$1, { onClick: closeModal, fullWidth: true, variant: "secondary" }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))))) : (React.createElement(React.Fragment, null,
        React.createElement(Modal.Content, null,
            React.createElement("div", { className: styles$v.imageContainer },
                React.createElement("img", { src: "https://cdn.m2.ru/assets/file-upload-server/0b8be3f6e7276be5782437a202ecbd8d.png", alt: "https://cdn.m2.ru/assets/file-upload-server/0b8be3f6e7276be5782437a202ecbd8d.png" })),
            React.createElement(Modal.Title, null, "\u0425\u043E\u0442\u0438\u0442\u0435 \u0443\u0437\u043D\u0430\u0432\u0430\u0442\u044C \u043E \u043D\u043E\u0432\u044B\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u0445 \u0432 \u0447\u0430\u0442\u0435? \u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435")),
        React.createElement(Modal.Actions, null,
            React.createElement("div", { className: styles$v.buttonsContainer },
                React.createElement(Button$1, { onClick: handleClick, disabled: isSubscribeBtnDisabled, fullWidth: true, variant: "primary" }, "\u0414\u0430, \u0445\u043E\u0447\u0443 \u0443\u0437\u043D\u0430\u0432\u0430\u0442\u044C"),
                React.createElement(Button$1, { onClick: () => {
                        sendAcceptModalAnalyticEvent('pu_decline_chat_web_push');
                        localStorage.setItem('webPushAcceptModal', JSON.stringify({
                            lastSeen: new Date().toISOString(),
                            closeType: 'CANCELED',
                        }));
                        closeModal();
                    }, fullWidth: true, variant: "secondary" }, "\u041D\u0435\u0442")))))));
});

const useInitServiceWorker = () => {
    const workbox = useRef();
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            const wb = new Workbox('/sw.js');
            workbox.current = wb;
            wb.register().catch((err) => {
                reportErrorToSentry(err);
            });
        }
    }, []);
    return { workbox: workbox.current };
};

async function notificationReplayHandler({ data }) {
    var _a, _b;
    const { sentryEventId } = await reportErrorToSentry(Object.assign(Object.assign({}, data.reportableErrorData), { error: (_a = data.reportableErrorData) === null || _a === void 0 ? void 0 : _a.error, notificationPayload: data, extra: (_b = data.options) === null || _b === void 0 ? void 0 : _b.extra }));
    showToasterNotification(composeSentryReplayNotification(data, sentryEventId));
    if (data === null || data === void 0 ? void 0 : data.restartReplay) {
        await restartSentryReplay();
    }
}
async function notificationRestartReplayHandler() {
    await restartSentryReplay();
    showToasterNotification({
        type: 'success',
        message: 'Sentry Replay перезапущен успешно. Начата новая сессия записи.',
    });
}
const handleMessage = function (event) {
    if (event.data.type !== 'M2_BRO')
        return;
    const eventBus = (window.eventBus = EventBus.getInstance());
    if (event.data.action === 'EVENT_BUS_PUBLISH') {
        eventBus.publish(event.data.data);
    }
};
const useSentryReplay = () => {
    useEffect(() => {
        window === null || window === void 0 ? void 0 : window.addEventListener('message', handleMessage);
        const eventBus = EventBus.getInstance();
        const subs = [
            eventBus.subscribe('app:sentry-replay-notification', notificationReplayHandler),
            eventBus.subscribe('app:sentry-restart-replay', notificationRestartReplayHandler),
        ];
        return () => {
            window === null || window === void 0 ? void 0 : window.removeEventListener('message', handleMessage);
            subs.forEach((sub) => sub.unsubscribe());
        };
    }, []);
};

const ShellContent = ({ shouldDisableRegionModal, shouldAskCookieAgreement, shouldShowChatWidget, disableCheckAuthState, hasNavbarOnMobile, modalStore, children, }) => {
    const survey = useSurvey();
    const reportModal = useReportModal();
    const updates = useUpdates();
    const userRegion = useUserRegion();
    useSentryReplay();
    useEffect(() => {
        userRegion.callInitEvent();
        userRegion.fetchUserRegion();
        checkCaptchaResourcesAvailable();
    }, []);
    const { subscribe, shouldShowSubscribeModal } = useNotifications();
    const { workbox } = useInitServiceWorker();
    useCheckAuthState(Boolean(disableCheckAuthState));
    useSyncAuthState();
    return (React.createElement(ShellContextValue.Provider, { value: {
            survey,
            updates,
            reportModal,
            serviceWorker: {
                workbox,
            },
        } },
        React.createElement(ShellUserRegionContextValue.Provider, { value: {
                userRegion,
            } },
            children,
            React.createElement(Survey, null),
            React.createElement(Captcha, null),
            !shouldDisableRegionModal && React.createElement(RegionModals, null),
            shouldAskCookieAgreement && React.createElement(CookieConsentMain, { hasNavbarOnMobile: hasNavbarOnMobile }),
            React.createElement(ReportModal, null),
            shouldShowSubscribeModal && React.createElement(WebPushAcceptModal, { modalStore: modalStore, subscribe: subscribe }),
            shouldShowChatWidget && (React.createElement(React.Fragment, null,
                React.createElement(ChatStub, null))),
            React.createElement(OfflineEventListener, null))));
};
const Shell = ({ user, children, shouldDisableRegionModal, shouldAskCookieAgreement, shouldShowChatWidget, disableCheckAuthState, hasNavbarOnMobile, config, modalStore, verification, }) => {
    const isAuthorized = Boolean(user && user.isAuthenticated);
    const initialState = isBrowser() ? window.__INITIAL_STATE__ : undefined;
    const featureManagerRef = useRef(initialState ? new FeatureManager(initialState) : undefined);
    useEffect(() => {
        var _a;
        const updateAttributes = userToUpdateTargetingAttributes(user);
        (_a = featureManagerRef.current) === null || _a === void 0 ? void 0 : _a.updateAttributes(updateAttributes);
    }, [user]);
    return (React.createElement(ShellAuthorizeContextValue.Provider, { value: {
            authorize: {
                user,
                isAuthorized,
                verification,
            },
        } },
        React.createElement(ShellConfigContextValue.Provider, { value: {
                config,
                featureManager: featureManagerRef.current,
            } },
            React.createElement(ShellContent, { shouldAskCookieAgreement: shouldAskCookieAgreement, disableCheckAuthState: disableCheckAuthState, shouldShowChatWidget: shouldShowChatWidget, shouldDisableRegionModal: shouldDisableRegionModal, modalStore: modalStore, hasNavbarOnMobile: hasNavbarOnMobile }, children))));
};

function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var PlusCircleIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm-1-12V6h2v5h5v2h-5v5h-2v-5H6v-2h5z"
}));

const styles$u = {
    offerPlacementLinkDesktopMobile: 'offerPlacementLinkDesktopMobile',
    offerPlacementLink: 'offerPlacementLink',
    offerPlacementLinkItem: 'offerPlacementLinkItem',
    offerPlacementLinkItemTransparent: 'offerPlacementLinkItemTransparent',
    offerPlacementLinkText: 'offerPlacementLinkText',
    offerPlacementLinkTablet: 'offerPlacementLinkTablet',
    offerPlacementLinkTabletVisible: 'offerPlacementLinkTabletVisible',
};
const OfferPlacementLink = ({ url }) => {
    const { to, registerControl } = useTooltip();
    const { isPartnerLogoVariant, isTransparent } = useContext(HeaderContextValue);
    if (!url)
        return null;
    return (React.createElement(MenuItemBase, { url: url, className: styles$u.offerPlacementLink },
        !isPartnerLogoVariant && (React.createElement("span", { className: styles$u.offerPlacementLinkDesktopMobile },
            React.createElement("span", { className: cn(styles$u.offerPlacementLinkItem, {
                    [styles$u.offerPlacementLinkItemTransparent]: isTransparent,
                }) },
                React.createElement("span", null,
                    React.createElement(SvgIcon, { iconComponent: React.createElement(PlusCircleIcon, null) })),
                React.createElement("span", { className: styles$u.offerPlacementLinkText }, "\u041D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435")))),
        React.createElement("span", { className: cn(styles$u.offerPlacementLinkTablet, {
                [styles$u.offerPlacementLinkTabletVisible]: isPartnerLogoVariant,
            }), ref: registerControl },
            React.createElement("span", { className: cn(styles$u.offerPlacementLinkItem, {
                    [styles$u.offerPlacementLinkItemTransparent]: isTransparent,
                }) },
                React.createElement("span", null,
                    React.createElement(SvgIcon, { iconComponent: React.createElement(PlusCircleIcon, null) })),
                React.createElement(Tooltip, { to: to, placement: "body", direction: "down" }, "\u041D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435")))));
};

var styles$t = {"menu":"_3-172-11wTl-rqLxB","menuOpened":"_3-172-11g-Q-UHZuQ","menuOpenedAlternative":"_3-172-11Hc7-sQS1J","changeRegionButton":"_3-172-113Tm-WSSky","fixedChangeRegionButton":"_3-172-11Lw--zlhSY","regularTabs":"_3-172-11Bh--zfSph","mobileTabsPublicArea":"_3-172-11USs-niWJZ","infoMenu":"_3-172-11gqP-To6Z4"};

function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var RightCircleIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1C6.262 1 1.55 5.394 1.045 11h10.127L8.879 8.707l1.414-1.414L15 12l-4.707 4.707-1.414-1.414L11.172 13H1.045C1.55 18.607 6.262 23 12 23z",
  fill: "currentColor"
}));

const styles$s = {
    loginButton: 'loginButton',
    loginButtonTransparent: 'loginButtonTransparent',
    loginButtonIcon: 'loginButtonIcon',
    loginButtonText: 'loginButtonText',
};
const LoginButton = ({ text }) => {
    const { isTransparent } = useContext(HeaderContextValue);
    return (React.createElement("button", { className: cn(styles$s.loginButton, { [styles$s.loginButtonTransparent]: isTransparent }) },
        React.createElement("span", { className: styles$s.loginButtonIcon },
            React.createElement(SvgIcon, { iconComponent: React.createElement(RightCircleIcon, null) })),
        React.createElement("span", { className: styles$s.loginButtonText }, text || 'Войти')));
};

var styles$r = {"userInfoMenuButton":"_3-172-11Pdn-m3Vfq","userInfoMenuButtonTransparent":"_3-172-114jt-ChOzR","userInfoMenuButtonContent":"_3-172-11bVy-p8gY2","userInfoMenuButtonText":"_3-172-112Mm-pbOw-","userInfoMenuButtonTextInner":"_3-172-11TH2-jijzy"};

const globalStyles = {
    userInfoMenuButtonIcon: 'userInfoMenuButtonIcon',
    userInfoMenuButtonIconTransparent: 'userInfoMenuButtonIconTransparent',
};
const UserInfoMenuButton = ({ path, url, onClick }) => {
    const { isTransparent } = useContext(HeaderContextValue);
    return (React.createElement(MenuItemBase, { onClick: onClick, path: path, url: url, isCloseMenuDisabled: true, className: cn(styles$r.userInfoMenuButton, {
            [styles$r.userInfoMenuButtonTransparent]: isTransparent,
        }) },
        React.createElement("span", { className: styles$r.userInfoMenuButtonContent },
            React.createElement("span", { className: cn(globalStyles.userInfoMenuButtonIcon, {
                    [globalStyles.userInfoMenuButtonIconTransparent]: isTransparent,
                }) },
                React.createElement(Icon, { name: "person-circle", size: "m" })),
            React.createElement("span", { className: styles$r.userInfoMenuButtonText },
                React.createElement("span", { className: styles$r.userInfoMenuButtonTextInner }, "\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442")))));
};

var styles$q = {"userInfoMenuItem":"_3-172-11x9p-LhvSV","userInfoMenuItemIcon":"_3-172-11Nq3-y3M33","userInfoMenuItemDesktop":"_3-172-11txs-U2aFy","userInfoMenuItemActive":"_3-172-11VeB-dkgQt"};

var styles$p = {"dropdownMenu":"_3-172-114ep-eoZ6i","dropdownMenuMain":"_3-172-11WNP-AyZv3","dropdownMenuContent":"_3-172-11TcO-48Cyu","dropdownMenuTransparent":"_3-172-11L-7-sdBYe","dropdownMenuButton":"_3-172-11IN1-ZscZF","dropdownMenuButtonActive":"_3-172-11eFe-N5CId","dropdownMenuContentInner":"_3-172-11BUD-7aPp7"};

var styles$o = {"dropdownMenuItem":"_3-172-110iI-JYRsA","dropdownMenuItemMain":"_3-172-11zro-1GLtC","dropdownMenuItemActive":"_3-172-116JC-UJThL"};

const DropdownMenuItem = ({ item, pathname, isMainMenu, onClick, dataTest, }) => {
    const { path, url, displayName, id, isSidebarEl } = item;
    const isActive = comparePathname(pathname, item);
    return (React.createElement(MenuItemBase, { dataTest: dataTest, className: cn(styles$o.dropdownMenuItem, {
            [styles$o.dropdownMenuItemActive]: isActive,
            [styles$o.dropdownMenuItemMain]: isMainMenu,
        }), path: path, url: url, onClick: onClick, isActive: isActive, id: id, isSidebarEl: isSidebarEl },
        React.createElement("span", null,
            displayName,
            item.freshCount ? (item.freshCount >= 99 ? ' 99+' : ` +${item.freshCount}`) : null)));
};

var styles$n = {"dropdownMenuButton":"_3-172-111vs-h8V-k","dropdownMenuButtonMain":"_3-172-11XtW-NN-Xg","dropdownMenuButtonIcon":"_3-172-11VrN-7rl-t","dropdownMenuButtonTransparent":"_3-172-11OqP-4-GGP","dropdownMenuButtonContent":"_3-172-11xqI-tLO3w","dropdownMenuButtonIconInner":"_3-172-11o3Q-haZ-W","dropdownMenuButtonText":"_3-172-11bgI-d5a5-","toggler":"_3-172-11XaC-W0aY0"};

const styles$m = {
    menuItemNotification: 'menuItemNotification',
};
const MenuItemNotification = () => React.createElement("span", { className: styles$m.menuItemNotification });

const DropdownMenuButton = ({ label, icon, className, isMainMenu, isOpen, onClick, showNotification, dataTest, }) => {
    const { isTransparent, isTablet } = useContext(HeaderContextValue);
    return (React.createElement(MenuItemBase, { dataTest: dataTest, className: cn(styles$n.dropdownMenuButton, className, {
            [styles$n.dropdownMenuButtonTransparent]: isTransparent,
            [styles$n.dropdownMenuButtonMain]: isMainMenu,
        }), onClick: onClick, isCloseMenuDisabled: true },
        React.createElement("div", { className: styles$n.dropdownMenuButtonContent },
            !isMainMenu && icon && (React.createElement("span", { className: styles$n.dropdownMenuButtonIcon },
                React.createElement("span", { className: styles$n.dropdownMenuButtonIconInner },
                    React.createElement(Icon, { name: icon, size: "m" })))),
            React.createElement("span", { className: styles$n.dropdownMenuButtonText }, label),
            isTablet && (React.createElement("span", { className: styles$n.toggler },
                React.createElement(Icon, { name: isOpen ? 'chevron-up' : 'chevron-down', size: "s" }))),
            showNotification && React.createElement(MenuItemNotification, null))));
};

const DropdownMenu = ({ item, pathname, isMainMenu, onSubItemClick, isOpenByDefault, event, dataTest, }) => {
    const { id, displayName, icon, dropdownMenu, showNotification, isSidebarEl } = item;
    const isActive = comparePathnameWithTab(pathname, item);
    const { isTransparent, isTablet } = useContext(HeaderContextValue);
    const [open, toggleOpen] = useState(isOpenByDefault);
    const activeTab = useActiveTab();
    const freshCount = useServiceUpdatesContext(id);
    return (React.createElement("div", { className: cn(styles$p.dropdownMenu, {
            [styles$p.dropdownMenuTransparent]: isTransparent,
            [styles$p.dropdownMenuMain]: isMainMenu,
        }) },
        React.createElement(DropdownMenuButton, { dataTest: dataTest, icon: icon, isMainMenu: isMainMenu, label: displayName, isOpen: open, onClick: () => {
                if (event && !isSidebarEl) {
                    sendAnalyticsEvent$2({
                        event,
                        user_type: activeTab === null || activeTab === void 0 ? void 0 : activeTab.displayName,
                        product_type: displayName,
                    });
                }
                if (isTablet) {
                    toggleOpen(!open);
                }
            }, showNotification: showNotification || Boolean(freshCount), className: cn(styles$p.dropdownMenuButton, {
                [styles$p.dropdownMenuButtonActive]: isActive,
            }) }),
        open && (React.createElement("div", { className: styles$p.dropdownMenuContent },
            React.createElement("div", { className: styles$p.dropdownMenuContentInner }, dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.map((item) => (React.createElement(DropdownMenuItem, { dataTest: dataTest, key: item.id, item: Object.assign(Object.assign({}, item), { isSidebarEl }), pathname: pathname, onClick: () => {
                    if (event && !isSidebarEl) {
                        sendAnalyticsEvent$2({
                            event,
                            user_type: activeTab === null || activeTab === void 0 ? void 0 : activeTab.displayName,
                            product_type: item.displayName,
                        });
                    }
                    onSubItemClick === null || onSubItemClick === void 0 ? void 0 : onSubItemClick();
                }, isMainMenu: isMainMenu }))))))));
};

const styles$l = {
    menuItem: 'menuItem',
    menuItemActive: 'menuItemActive',
    menuItemTransparent: 'menuItemTransparent',
    menuItemIcon: 'menuItemIcon',
    menuItemIconInner: 'menuItemIconInner',
    menuItemText: 'menuItemText',
    menuItemNotification: 'menuItemNotification',
};
const MenuItem = ({ item, pathname, isMainMenu, onClick, dataTest }) => {
    const { id, path, url, icon, displayName, target, showNotification, isSidebarEl } = item;
    const freshCount = useServiceUpdatesContext(id);
    const shouldShowNotification = showNotification || Boolean(freshCount);
    const { isTransparent } = useContext(HeaderContextValue);
    const isActive = comparePathname(pathname, item);
    return (React.createElement(MenuItemBase, { dataTest: dataTest, className: cn(styles$l.menuItem, {
            [styles$l.menuItemActive]: isActive,
            [styles$l.menuItemTransparent]: isTransparent,
        }), path: path, url: url, onClick: onClick, target: target, isActive: isActive, id: id, isSidebarEl: isSidebarEl },
        !isMainMenu && icon && (React.createElement("span", { className: styles$l.menuItemIcon },
            React.createElement("span", { className: styles$l.menuItemIconInner },
                React.createElement(Icon, { name: icon, size: "m" })))),
        React.createElement("span", { className: styles$l.menuItemText }, displayName),
        shouldShowNotification && React.createElement(MenuItemNotification, null)));
};

const MenuLink = ({ item, pathname, isMainMenu, onClick, isOpenByDefault, event, dataTest, }) => {
    const activeTab = useActiveTab();
    if (item.dropdownMenu) {
        return (React.createElement(DropdownMenu, { dataTest: dataTest, item: item, pathname: pathname, isMainMenu: isMainMenu, onSubItemClick: onClick, isOpenByDefault: isOpenByDefault, event: event || 'header_click' }));
    }
    const onClickWithAnalytics = () => {
        if (!item.isSidebarEl) {
            sendAnalyticsEvent$2({
                event: event || 'header_click',
                user_type: activeTab === null || activeTab === void 0 ? void 0 : activeTab.displayName,
                product_type: item.displayName,
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement(MenuItem, { dataTest: dataTest, item: item, pathname: pathname, isMainMenu: isMainMenu, onClick: onClickWithAnalytics }));
};

const LOGOUT_BUTTON_TO = '/logout';
const UserInfoMenuItem = (props) => {
    const { logoutPath, pathname } = useContext(HeaderContextValue);
    const { path, url, icon, displayName, showInDesktopProfileMenu, id } = props.item;
    const logoutUrl = (path === LOGOUT_BUTTON_TO || url === LOGOUT_BUTTON_TO) && logoutPath;
    const isActive = comparePathname(pathname, props.item);
    const correctPath = logoutUrl || path;
    const correctUrl = logoutUrl || url;
    if (!props.showBaseItem) {
        return React.createElement(MenuLink, Object.assign({}, props, { item: Object.assign(Object.assign({}, props.item), { isSidebarEl: true, path: correctPath, url: correctUrl }) }));
    }
    return (React.createElement(MenuItemBase, { dataTest: props.dataTest, className: cn(styles$q.userInfoMenuItem, {
            [styles$q.userInfoMenuItemDesktop]: showInDesktopProfileMenu,
            [styles$q.userInfoMenuItemActive]: isActive,
        }), path: correctPath, url: correctUrl, isActive: isActive, onClick: props.onClick, id: id, isSidebarEl: true },
        icon && (React.createElement("span", { className: styles$q.userInfoMenuItemIcon },
            React.createElement(Icon, { name: icon, size: "m" }))),
        displayName));
};

var styles$k = {"userInfoMenuContentHeader":"_3-172-116PO-FtXjh","userInfoMenuContentHeaderProfile":"_3-172-11T-X-K18ef","userInfoMenuContentHeaderProfileText":"_3-172-11NIC-kpvhj","userInfoMenuContentHeaderVerification":"_3-172-11mEa-Bmjo3","userInfoMenuVerificationIcon":"_3-172-11GzD-aIovF"};

var styles$j = {"userInfoMenuContentProfileContainer":"_3-172-11n3w-o-a07","userInfoMenuContentProfile":"_3-172-11RGb-rAS6d","userInfoMenuContentProfileSeparator":"_3-172-11OV--PdEFl"};

const UserInfoMenuContentProfile = ({ user }) => {
    const username = user.username && isPhoneNumberString(user.username) ? formatPhone(user.username) : user.username;
    return (React.createElement("div", { className: styles$j.userInfoMenuContentProfileContainer },
        React.createElement("span", { className: styles$j.userInfoMenuContentProfile }, username),
        React.createElement("span", { className: cn(styles$j.userInfoMenuContentProfile, styles$j.userInfoMenuContentProfileSeparator) }, ` · `),
        React.createElement("span", { className: styles$j.userInfoMenuContentProfile }, getProfileHeaderByRoleType(user.currentRoleType))));
};

const useDisplayWallet = () => {
    const { user } = useAuthorizeContext();
    const [walletBalance, setWalletBalance] = useState(null);
    const { currentRoleType, companyId, userId, currentRole, permissions } = user || {};
    const hasWallet = permissions === null || permissions === void 0 ? void 0 : permissions.includes('/billing/wallet/loyalty:read');
    const isRealtorEmpowered = currentRoleType === 'REALTOR' && currentRole === '37';
    const isProf = currentRoleType === 'PROFESSIONAL';
    const shouldDisplayWallet = (isRealtorEmpowered || isProf) && hasWallet;
    const ownerId = isProf ? userId : companyId;
    const zeroBalanceLink = isRealtorEmpowered ? `/billing/${ownerId}` : '/billing';
    const zeroBalanceText = isRealtorEmpowered ? 'Кошельки' : 'Перейти в кошелёк';
    const walletLink = walletBalance === null ? zeroBalanceLink : `/billing/${ownerId}/loyalty/details`;
    const walletText = walletBalance === null ? zeroBalanceText : walletBalance.toLocaleString('ru') + ' ₽';
    useEffect(() => {
        if (shouldDisplayWallet) {
            getWalletBalance({ params: { product: 'LOYALTY', companyId: ownerId } })
                .then((response) => {
                if ('balance' in response) {
                    const numericBalance = Number(response.balance || 0) / 100;
                    setWalletBalance(numericBalance);
                }
            })
                .catch((error) => {
                var _a;
                if (!(error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)) {
                    reportErrorToSentry({ error });
                }
            });
        }
    }, [shouldDisplayWallet, companyId, ownerId]);
    return { shouldDisplayWallet, walletBalance, walletLink, walletText };
};

function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var VerificationPassedIcon = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#3216B5",
  fillRule: "evenodd",
  d: "M10.6 1.55L9.16 3.21a.7.7 0 01-.64.23L6.36 3.1a.7.7 0 00-.8.56L5.15 5.8a.7.7 0 01-.44.52l-2.05.78a.7.7 0 00-.4.88l.7 2.07a.7.7 0 01-.11.67l-1.38 1.7a.7.7 0 00.08.97l1.66 1.44c.18.16.27.4.23.64l-.34 2.16a.7.7 0 00.55.8l2.16.41a.7.7 0 01.52.44l.78 2.05a.7.7 0 00.88.4l2.07-.7a.7.7 0 01.67.11l1.7 1.38c.3.24.73.2.97-.08l1.44-1.66a.7.7 0 01.64-.23l2.16.34a.7.7 0 00.8-.55l.41-2.16a.7.7 0 01.44-.52l2.05-.78a.7.7 0 00.4-.88l-.7-2.07a.7.7 0 01.11-.67l1.38-1.7a.7.7 0 00-.08-.97l-1.66-1.44a.7.7 0 01-.23-.64l.34-2.16a.7.7 0 00-.56-.8l-2.15-.41a.7.7 0 01-.52-.44l-.78-2.05a.7.7 0 00-.88-.4l-2.07.7a.7.7 0 01-.67-.11l-1.7-1.38a.7.7 0 00-.97.08zM7.4 11.8l2.6 2.6 6.6-6.6L18 9.21l-8 8-4-4 1.4-1.42z",
  clipRule: "evenodd"
}));

const UserInfoMenuContentHeader = () => {
    const { user, verification } = useAuthorizeContext();
    const { shouldDisplayWallet, walletLink, walletText, walletBalance } = useDisplayWallet();
    return (React.createElement("div", { className: styles$k.userInfoMenuContentHeader },
        React.createElement("div", { className: styles$k.userInfoMenuContentHeaderProfile },
            React.createElement("div", { className: styles$k.userInfoMenuContentHeaderVerification },
                React.createElement("span", { className: styles$k.userInfoMenuContentHeaderProfileText }, "\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"),
                (verification === null || verification === void 0 ? void 0 : verification.isAlreadyPassedM2ProVerification) && (React.createElement("span", { className: styles$k.userInfoMenuVerificationIcon },
                    React.createElement(VerificationPassedIcon, null)))),
            user && !isAnonymousUser(user.username) && React.createElement(UserInfoMenuContentProfile, { user: user })),
        shouldDisplayWallet && (React.createElement(MenuLink, { dataTest: "user-wallet-link", key: "wallet", item: {
                icon: 'm2-wallet',
                id: 'wallet',
                displayName: walletBalance ? `Баланс: ${walletText}` : 'Баланс',
                path: walletLink,
            }, isOpenByDefault: false }))));
};

class NewsService {
    constructor() {
        this.api = axios.create({ baseURL: '/api/news-express/api/v1' });
    }
    getNews() {
        return this.api.get('/personal-area-news');
    }
}
const newsService = new NewsService();

const parseDate = (date) => parse(date || '', 'dd.MM.yyyy', new Date(), { locale: ru$1 });
const NewsContainer = ({ variant, isSidebarClosed, children }) => {
    const [shouldShowCircle, setShouldShowCircle] = useState(false);
    const [shouldShowNews, setShouldShowNews] = useState(false);
    const isMounted = useMountedState();
    const checkLatestNews = useCallback(async () => {
        var _a;
        try {
            const { data } = await newsService.getNews();
            const news = data === null || data === void 0 ? void 0 : data.news;
            const latestDate = (_a = news === null || news === void 0 ? void 0 : news[0]) === null || _a === void 0 ? void 0 : _a.date;
            const latestViewedDate = localStorage.getItem('latestViewedNewsDateLK');
            if (!latestDate || !isMounted()) {
                return;
            }
            setShouldShowNews(true);
            if (!latestViewedDate) {
                setShouldShowCircle(true);
                return;
            }
            const latestParsed = parseDate(latestDate);
            const latestViewedParsed = parseDate(latestViewedDate);
            if (isValid$1(latestParsed) && isValid$1(latestViewedParsed)) {
                setShouldShowCircle(compareAsc(latestParsed, latestViewedParsed) === 1);
            }
        }
        catch (error) {
            reportErrorToSentry({ error });
        }
    }, []);
    useEffect(() => {
        const eventBus = EventBus.getInstance();
        const sub = eventBus.subscribe('lkNews:read', () => {
            setShouldShowCircle(false);
        });
        checkLatestNews();
        return () => {
            sub.unsubscribe();
        };
    }, []);
    if (!shouldShowNews) {
        return null;
    }
    return (React.createElement(FreshDot, { isCircleVisible: shouldShowCircle, variant: variant, isSidebarClosed: isSidebarClosed }, children));
};

const styles$i = {
    initialUnauthorizedUser: 'initialUnauthorizedUser',
    initialAuthorizedUser: 'initialAuthorizedUser',
    unauthorizedUser: 'unauthorized',
    authorizedUser: 'authorized',
    userInfoDesktop: 'userInfoDesktop',
    userInfoMobile: 'userInfoMobile',
    userInfoMobileGroupTitle: 'userInfoMobileGroupTitle',
    userInfoMobileLogin: 'userInfoMobileLogin',
    userInfo: 'userInfo',
    userInfoMenu: 'userInfoMenu',
    userInfoMenuTransparent: 'userInfoMenuTransparent',
    userInfoMenuButtonDesktop: 'userInfoMenuButtonDesktop',
    userInfoMenuButtonMobile: 'userInfoMenuButtonMobile',
    userInfoMenuContent: 'userInfoMenuContent',
    userInfoMenuContentOpened: 'userInfoMenuContentOpened',
    userInfoMenuContentInner: 'userInfoMenuContentInner',
    separator: 'separator',
};
const userAuthorizationStateStyleId = 'user-authorization-state-style';
const userInfoDataTest = 'user-info-mobile';
const MenuItemComponent = (props) => {
    if (props.item.id == 'news') {
        return (React.createElement(NewsContainer, { variant: "menu" },
            React.createElement(UserInfoMenuItem, Object.assign({}, props))));
    }
    if (props.item.freshCount !== undefined && props.item.freshCount > 0) {
        return (React.createElement(FreshDot, { variant: "menu", isCircleVisible: true },
            React.createElement(UserInfoMenuItem, Object.assign({}, props))));
    }
    return React.createElement(UserInfoMenuItem, Object.assign({}, props));
};
const AuthorizedMobileItemsList = ({ pathname, list }) => {
    return (React.createElement(React.Fragment, null, list.map((item) => (React.createElement("div", { key: item.id, className: styles$i.userInfoMobile },
        React.createElement(MenuItemComponent, { dataTest: userInfoDataTest, item: item, pathname: pathname, isOpenByDefault: true }))))));
};
const AuthorizedDesktopItemsList = ({ pathname, list }) => {
    return (React.createElement(React.Fragment, null, list.map((item) => (React.createElement("div", { key: item.displayName, className: styles$i.userInfoDesktop },
        React.createElement(UserInfoMenuItem, { dataTest: userInfoDataTest, showBaseItem: true, item: item, isOpenByDefault: false, pathname: pathname }))))));
};
const UserInfo = () => {
    var _a;
    const { isAuthorized } = useAuthorizeContext();
    const { isUserInfoMenuOpened, authorizedItems, loginText, mobileLoginText, pathname, isTransparent, loginPath, personalAreaPath, } = useContext(HeaderContextValue);
    const [isBrowser, setBrowser] = useState(false);
    useEffect(() => {
        const initialAuthorizationStyles = document.querySelector(`#${userAuthorizationStateStyleId}`);
        initialAuthorizationStyles === null || initialAuthorizationStyles === void 0 ? void 0 : initialAuthorizationStyles.remove();
        setBrowser(true);
    }, []);
    const { servicesUpdates } = useUpdatesContext();
    const authorizedItemsMapped = useMemo(() => {
        var _a;
        return ({
            items: mapUpdatesToSidebar((authorizedItems === null || authorizedItems === void 0 ? void 0 : authorizedItems.items) || [], servicesUpdates),
            footerItems: mapUpdatesToSidebar((authorizedItems === null || authorizedItems === void 0 ? void 0 : authorizedItems.footerItems) || [], servicesUpdates),
            grouped: (_a = authorizedItems === null || authorizedItems === void 0 ? void 0 : authorizedItems.groupedItems) === null || _a === void 0 ? void 0 : _a.map((groupedItem) => ({
                name: groupedItem.name,
                items: mapUpdatesToSidebar(groupedItem.items || [], servicesUpdates),
            })),
        });
    }, [authorizedItems, servicesUpdates]);
    const desktopAuthorizedItems = useMemo(() => {
        var _a;
        const allItems = {
            top: [...authorizedItemsMapped.items],
            bottom: [...authorizedItemsMapped.footerItems],
        };
        (_a = authorizedItemsMapped.grouped) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            allItems.top.push(...item.items);
        });
        for (const [key, value] of Object.entries(allItems)) {
            allItems[key] = value
                .reduce((arr, item) => {
                if (item.dropdownMenu) {
                    arr.push(...item.dropdownMenu);
                    return arr;
                }
                arr.push(item);
                return arr;
            }, [])
                .filter((item) => item.showInDesktopProfileMenu);
        }
        return allItems;
    }, [authorizedItemsMapped]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: cn(styles$i.initialUnauthorizedUser, {
                [styles$i.unauthorizedUser]: isBrowser && !isAuthorized,
            }) },
            React.createElement("span", { className: styles$i.userInfoDesktop, "data-test": "desktop-login" },
                React.createElement("a", { className: styles$i.userInfo, href: loginPath },
                    React.createElement(LoginButton, { text: loginText }))),
            React.createElement("span", { className: styles$i.userInfoMobileLogin, "data-test": "mobile-login" },
                React.createElement(Link, { href: loginPath },
                    React.createElement(Button$1, { variant: "secondary", fullWidth: true }, mobileLoginText)))),
        React.createElement("div", { className: cn(styles$i.userInfoMenu, styles$i.initialAuthorizedUser, {
                [styles$i.userInfoMenuTransparent]: isTransparent,
                [styles$i.authorizedUser]: isBrowser && isAuthorized,
            }), "data-test": "user-info-menu" },
            React.createElement("div", { className: styles$i.userInfoMenuButtonDesktop },
                React.createElement(UserInfoMenuButton, { path: personalAreaPath, url: personalAreaPath })),
            React.createElement(UserInfoMenuContentHeader, null),
            React.createElement("div", { className: cn(styles$i.userInfoMenuContent, {
                    [styles$i.userInfoMenuContentOpened]: isUserInfoMenuOpened,
                }) },
                React.createElement("div", { className: styles$i.userInfoMenuContentInner },
                    React.createElement(AuthorizedMobileItemsList, { list: authorizedItemsMapped.items, pathname: pathname }), (_a = authorizedItemsMapped.grouped) === null || _a === void 0 ? void 0 :
                    _a.map((groupedItem) => (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { className: styles$i.userInfoMobileGroupTitle, bold: true, variant: "secondary", color: "secondary" }, groupedItem.name),
                        React.createElement(AuthorizedMobileItemsList, { list: groupedItem.items, pathname: pathname })))),
                    React.createElement(AuthorizedDesktopItemsList, { pathname: pathname, list: desktopAuthorizedItems.top }),
                    React.createElement("hr", { className: styles$i.separator }),
                    React.createElement(AuthorizedDesktopItemsList, { pathname: pathname, list: desktopAuthorizedItems.bottom }),
                    React.createElement(AuthorizedMobileItemsList, { pathname: pathname, list: authorizedItemsMapped.footerItems }))))));
};

const styles$h = {
    infoMenu: 'infoMenu',
    infoMenuIconControls: 'infoMenuIconControls',
    infoMenuIconControlsDesktop: 'infoMenuIconControlsDesktop',
    infoMenuUserControls: 'infoMenuUserControls',
};
const InfoMenu = () => {
    const { isAuthorized } = useAuthorizeContext();
    const { isPartnerLogoVariant, isPersonalButtonsVisible, personalButtons } = useContext(HeaderContextValue);
    return (React.createElement("div", { className: styles$h.infoMenu },
        isPersonalButtonsVisible && (React.createElement("div", { className: cn(styles$h.infoMenuIconControls, {
                [styles$h.infoMenuIconControlsDesktop]: isPartnerLogoVariant,
            }) },
            React.createElement(PersonalButtons, null),
            React.createElement(OfferPlacementLink, { url: getOfferPlacementButtonUrl(isAuthorized, personalButtons === null || personalButtons === void 0 ? void 0 : personalButtons.offerPlacement) }))),
        React.createElement("div", { className: styles$h.infoMenuUserControls },
            React.createElement(UserInfo, null))));
};

var styles$g = {"changeRegionButton":"_3-172-11Q-r-de3ZF","changeRegionButtonText":"_3-172-11evZ-LS6KS","changeRegionButtonTextTransparent":"_3-172-11xRL-4UjMZ","changeRegionButtonIcon":"_3-172-11Bxn-EMxBj","changeRegionButtonIconTransparent":"_3-172-11Oo6-DtUaT","changeRegionButtonTransparent":"_3-172-11Xbd-52BZx","changeRegionButtonMobile":"_3-172-114O2-Fc73M","changeRegionButtonMobileControl":"_3-172-11ATx-y80md","changeRegionButtonMobileText":"_3-172-11Jw3-wit-b","changeRegionButtonInnerContainer":"_3-172-11LE7-TAfyg"};

const ChangeRegionButton$1 = ({ onClick, regionName }) => {
    const { isTransparent } = useContext(HeaderContextValue);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: styles$g.changeRegionButton, onClick: onClick, "data-test": "detect-region-btn" },
            React.createElement("span", { className: cn(styles$g.changeRegionButtonIcon, {
                    [styles$g.changeRegionButtonIconTransparent]: isTransparent,
                }) },
                React.createElement(Icon, { name: "placemark", size: "s" })),
            React.createElement("span", { className: cn(styles$g.changeRegionButtonText, {
                    [styles$g.changeRegionButtonTextTransparent]: isTransparent,
                }) }, regionName)),
        React.createElement("button", { className: styles$g.changeRegionButtonMobile, onClick: onClick, "data-test": "detect-region-btn-mobile" },
            React.createElement("div", { className: styles$g.changeRegionButtonInnerContainer },
                React.createElement("span", { className: styles$g.changeRegionButtonIcon },
                    React.createElement(Icon, { name: "placemark", size: "m" })),
                React.createElement("span", { className: styles$g.changeRegionButtonMobileText }, regionName)),
            React.createElement("span", { className: styles$g.changeRegionButtonMobileControl }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"))));
};

var styles$f = {"tabsItems":"_3-172-11XSk-jA9yo","tabsItemsRieltors":"_3-172-11K-O-I-EXd","tabsItemsContainer":"_3-172-11HuI-Eo9-M","tabsItemsDevelopers":"_3-172-11Q6Y-iZm0b","tabsItemsContent":"_3-172-11Rwj-ObuTq","tabs":"_3-172-11uF6-rk-y8","tabItem":"_3-172-11xgS-0U9OE","tabItemActive":"_3-172-11YMi-iC0Cp","tabItemTransparent":"_3-172-11TiP-ysEhF","tabsContentItem":"_3-172-113l1-BvEFf","tabsContentItemMobile":"_3-172-11njC-uHC9n"};

const styles$e = {
    partnersButton: 'partnersButton',
    partnersButtonLogoTransparent: 'partnersButtonLogoTransparent',
    partnersButtonLogoWhiteTransparent: 'partnersButtonLogoWhiteTransparent',
};
const PartnersButton = ({ partners, activePartner, onPartnerClick }) => {
    const [partnerName, setPartnerName] = useState(activePartner);
    const { isTransparent, activeRegionPartner } = useContext(HeaderContextValue);
    useEffect(() => {
        if (activePartner && activePartner === partnerName)
            return;
        setPartnerName(activePartner || activeRegionPartner);
    }, [activePartner, activeRegionPartner]);
    if (!partnerName || !partners[partnerName]) {
        return null;
    }
    const { logo, logoWhite, path, url, analyticsDataClick } = partners[partnerName];
    const onClickHandler = () => {
        if (analyticsDataClick) {
            sendAnalyticsEvent$2(analyticsDataClick);
        }
        if (onPartnerClick) {
            onPartnerClick(partnerName);
        }
    };
    return (React.createElement(MenuItemBase, { "data-test": "header-partner-button", className: cn(styles$e.partnersButton), path: path, url: url, onClick: onClickHandler },
        React.createElement("img", { src: logo, alt: "partner logo", className: cn(isTransparent && styles$e.partnersButtonLogoTransparent) }),
        isTransparent && (React.createElement("img", { src: logoWhite, alt: "partner logo", className: styles$e.partnersButtonLogoWhiteTransparent }))));
};

const getActiveClassname = (activeTabId) => {
    switch (activeTabId) {
        case TabsIds.REALTORS:
            return styles$f.tabsItemsRieltors;
        case TabsIds.DEVELOPERS:
            return styles$f.tabsItemsDevelopers;
    }
};
const Tabs = () => {
    const { isAuthorized } = useAuthorizeContext();
    const { items, partners, activePartner, onPartnerClick, pathname, personalButtons, isTransparent, isTablet } = useContext(HeaderContextValue);
    const activeTab = useActiveTab();
    const activeTabId = activeTab === null || activeTab === void 0 ? void 0 : activeTab.id;
    const currentTabMenu = activeTab === null || activeTab === void 0 ? void 0 : activeTab.dropdownMenu;
    const offerPlacementUrl = getOfferPlacementButtonUrl(isAuthorized, personalButtons === null || personalButtons === void 0 ? void 0 : personalButtons.offerPlacement);
    const filteredItems = useMemo(() => getFilteredMenuItems(items, 'desktop'), [items]);
    return (React.createElement("div", { className: styles$f.tabs, "data-test": "header-tabs" },
        React.createElement("div", { className: cn(styles$f.tabsItems, getActiveClassname(activeTabId)) }, filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map((tab) => (React.createElement("div", { className: styles$f.tabsItemsContainer, key: tab.id, "data-test": "header-tab-container" },
            React.createElement(MenuItemBase, { dataTest: "header-tab-base", className: cn(styles$f.tabItem, {
                    [styles$f.tabItemActive]: tab.id === activeTabId,
                    [styles$f.tabItemTransparent]: isTransparent,
                }), path: tab.path, url: tab.url, onClick: () => {
                    sendAnalyticsEvent$2({
                        event: 'header_click',
                        user_type: tab.displayName,
                        product_type: tab.displayName,
                    });
                } }, tab.displayName),
            activeTabId === tab.id && (React.createElement("div", { className: styles$f.tabsItemsContent },
                activeTabId !== TabsIds.DEVELOPERS && offerPlacementUrl && (React.createElement("div", { className: cn(styles$f.tabsContentItem, styles$f.tabsContentItemMobile), "data-test": "header-tab-item" },
                    React.createElement(MenuLink, { item: {
                            id: offerPlacementUrl,
                            displayName: 'Новое объявление',
                            url: offerPlacementUrl,
                        }, isOpenByDefault: false }))), currentTabMenu === null || currentTabMenu === void 0 ? void 0 :
                currentTabMenu.map((item) => (React.createElement("div", { key: item.displayName, className: styles$f.tabsContentItem, "data-test": "header-tab-item" },
                    React.createElement(MenuLink, { item: item, pathname: pathname, isMainMenu: true, isOpenByDefault: !isAuthorized || !isTablet })))),
                activeTabId === TabsIds.DEFAULT && partners && (React.createElement("div", { className: styles$f.tabsContentItem, "data-test": "header-tab-item" },
                    React.createElement(PartnersButton, { partners: partners, activePartner: activePartner, onPartnerClick: onPartnerClick })))))))))));
};

var styles$d = {"tabs":"_3-172-11ADR-6EBhq","menuContainer":"_3-172-11nyA-nViKs"};

function useAccordion(detailsRef, duration = 400) {
    const stateRef = useRef('idle');
    const summaryRef = useRef();
    const contentRef = useRef();
    const animationRef = useRef(null);
    const animationConfig = useMemo(() => ({
        duration,
        easing: 'cubic-bezier(0.24, 0.1, 0.24, 1)',
    }), [duration]);
    const onFinish = useCallback((openState) => {
        if (!detailsRef.current) {
            return;
        }
        const el = detailsRef.current;
        el.open = openState;
        animationRef.current = null;
        stateRef.current = 'idle';
        el.style.height = el.style.overflow = '';
        delete el.dataset.animating;
    }, [detailsRef]);
    const cancelAnimation = useCallback(() => {
        stateRef.current = 'idle';
    }, []);
    const completion = useMemo(() => ({
        open: onFinish.bind(null, true),
        close: onFinish.bind(null, false),
    }), [onFinish]);
    const expand = useCallback(() => {
        var _a;
        if (!detailsRef.current || !summaryRef.current || !contentRef.current) {
            return;
        }
        const el = detailsRef.current;
        const sum = summaryRef.current;
        const content = contentRef.current;
        stateRef.current = 'expanding';
        const styleEl = window.getComputedStyle(el);
        const padding = parseInt(styleEl.padding);
        const marginTop = parseInt(window.getComputedStyle(content).marginTop);
        const border = parseInt(styleEl.borderTopWidth) + parseInt(styleEl.borderBottomWidth);
        const startHeight = `${sum.offsetHeight + padding * 2 + border}px`;
        const endHeight = `${sum.offsetHeight + content.offsetHeight + marginTop + padding * 2 + border}px`;
        (_a = animationRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        animationRef.current = el.animate({
            height: [startHeight, endHeight],
        }, animationConfig);
        animationRef.current.onfinish = completion.open;
        animationRef.current.oncancel = cancelAnimation;
    }, [detailsRef, animationConfig, cancelAnimation, completion]);
    const open = useCallback(() => {
        if (!detailsRef.current) {
            return;
        }
        const el = detailsRef.current;
        el.style.height = `${el.offsetHeight}px`;
        el.open = true;
        window.requestAnimationFrame(expand);
    }, [detailsRef, expand]);
    const shrink = useCallback(() => {
        var _a;
        if (!detailsRef.current || !summaryRef.current || !contentRef.current) {
            return;
        }
        const el = detailsRef.current;
        const sum = summaryRef.current;
        const content = contentRef.current;
        stateRef.current = 'closing';
        const styleEl = window.getComputedStyle(el);
        const padding = parseInt(styleEl.padding);
        const marginTop = parseInt(window.getComputedStyle(content).marginTop);
        const border = parseInt(styleEl.borderTopWidth) + parseInt(styleEl.borderBottomWidth);
        const startHeight = `${sum.offsetHeight + content.offsetHeight + marginTop + padding * 2 + border}px`;
        const endHeight = `${sum.offsetHeight + padding * 2 + border}px`;
        (_a = animationRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        animationRef.current = el.animate({
            height: [startHeight, endHeight],
        }, animationConfig);
        animationRef.current.onfinish = completion.close;
        animationRef.current.oncancel = cancelAnimation;
    }, [detailsRef, animationConfig, cancelAnimation, completion]);
    const toggle = useCallback(() => {
        if (!detailsRef.current || stateRef.current !== 'idle') {
            return;
        }
        const el = detailsRef.current;
        if (!('animate' in el)) {
            el.open = !el.open;
            return;
        }
        el.style.overflow = 'hidden';
        el.dataset.animating = '';
        if (el.open) {
            shrink();
        }
        else {
            open();
        }
    }, [detailsRef, open, shrink]);
    useEffect(() => {
        if (!detailsRef.current) {
            return;
        }
        const el = detailsRef.current;
        summaryRef.current = el.querySelector('summary');
        contentRef.current = el.querySelector('[data-content]');
    }, [detailsRef]);
    return { toggle, stateRef };
}

var styles$c = {"menuItem":"_3-172-11m1u-yhs8P","menuItemHeading":"_3-172-11E-0-SFnez","menuItemLinkActive":"_3-172-11-ae-Us7ps","menuItemDropdown":"_3-172-11qgl-ytpvZ","menuItemDropdownItem":"_3-172-11w0l-AxZtf","menuItemDropdownItemActive":"_3-172-119z2-J-JJ7","icon":"_3-172-11yX--apKOx","iconRotated":"_3-172-11cuB-yWiId"};

const MenuItemForTabsPublicMobile = ({ item, pathname, parentTabTitle }) => {
    const { displayName, displayNameMobile, url, path, dropdownMenu } = item;
    const href = path || url;
    const detailsRef = useRef(null);
    const { toggle } = useAccordion(detailsRef);
    const [isOpen, setIsOpen] = useState(false);
    const displayTitle = displayNameMobile || displayName;
    const isParentActive = isActivePath(pathname, href);
    const hasActiveSubItem = useMemo(() => {
        if (!dropdownMenu)
            return false;
        return dropdownMenu.some((subItem) => {
            const subHref = subItem.path || subItem.url;
            return isActivePath(pathname, subHref);
        });
    }, [dropdownMenu, pathname]);
    useEffect(() => {
        if (hasActiveSubItem && detailsRef.current) {
            detailsRef.current.open = true;
            setIsOpen(true);
        }
    }, [hasActiveSubItem]);
    const handleClickItemWithDropdown = useCallback((e) => {
        e.preventDefault();
        setIsOpen((prev) => !prev);
        toggle();
    }, [toggle]);
    const handleClickItemWithoutDropdown = useCallback(() => {
        sendAnalyticsEvent$2({
            event: 'header_click',
            user_type: parentTabTitle,
            product_type: displayTitle,
        });
    }, [displayTitle, parentTabTitle]);
    const handleClickSubItem = useCallback((subItem) => () => {
        const subTitle = subItem.displayNameMobile || subItem.displayName;
        sendAnalyticsEvent$2({
            event: 'header_click',
            user_type: parentTabTitle,
            product_type: subTitle,
        });
    }, [parentTabTitle]);
    if (!dropdownMenu || dropdownMenu.length === 0) {
        return (React.createElement("div", { className: styles$c.menuItem },
            React.createElement("a", { href: href, className: styles$c.menuItemHeading, onClick: handleClickItemWithoutDropdown },
                React.createElement(Typography, { variant: "primary-alone", bold: true },
                    React.createElement("span", { className: cn({ [styles$c.menuItemLinkActive]: isParentActive }) }, displayNameMobile || displayName)))));
    }
    return (React.createElement("details", { ref: detailsRef, className: styles$c.menuItem },
        React.createElement("summary", { className: styles$c.menuItemHeading, onClick: handleClickItemWithDropdown },
            React.createElement(Typography, { variant: "primary-alone", bold: true }, displayNameMobile || displayName),
            React.createElement("div", { className: cn(styles$c.icon, { [styles$c.iconRotated]: isOpen }) },
                React.createElement(Icon, { name: "chevron-down", size: "s" }))),
        React.createElement("div", { "data-content": true, className: styles$c.menuItemDropdown }, dropdownMenu.map((subItem) => {
            const subHref = subItem.path || subItem.url;
            const isSubItemActive = pathname === subHref;
            return (React.createElement("a", { key: subItem.id, href: subHref, className: cn(styles$c.menuItemDropdownItem, {
                    [styles$c.menuItemDropdownItemActive]: isSubItemActive,
                }), onClick: handleClickSubItem(subItem) },
                React.createElement(Typography, { variant: "primary-alone" }, subItem.displayNameMobile || subItem.displayName)));
        }))));
};

const TabsForPublicAreaMobile = () => {
    var _a;
    const { items, pathname, partners, activePartner, onPartnerClick } = useContext(HeaderContextValue);
    const filteredItems = useMemo(() => getFilteredMenuItems(items, 'mobile'), [items]);
    const hasSessionStorage = hasStorage('sessionStorage');
    const [selectedTabId, setSelectedTabId] = useState(((_a = filteredItems[0]) === null || _a === void 0 ? void 0 : _a.id) || '');
    useEffect(() => {
        if (hasSessionStorage) {
            const saved = sessionStorage.getItem('selectedTabId');
            if (saved && filteredItems.some((item) => item.id === saved)) {
                setSelectedTabId(saved);
            }
        }
    }, [filteredItems, hasSessionStorage]);
    const currentMenuItem = filteredItems.find((item) => item.id === selectedTabId);
    const currentDropDownMenu = (currentMenuItem === null || currentMenuItem === void 0 ? void 0 : currentMenuItem.dropdownMenu) || [];
    const handleChangeTab = useCallback((value) => {
        const tabId = value.toString();
        setSelectedTabId(tabId);
        if (hasSessionStorage) {
            sessionStorage.setItem('selectedTabId', tabId);
        }
        const tab = filteredItems.find((item) => item.id === tabId);
        if (tab) {
            sendAnalyticsEvent$2({
                event: 'header_click',
                user_type: tab.displayNameMobile || tab.displayName,
                product_type: tab.displayNameMobile || tab.displayName,
            });
        }
    }, [filteredItems, hasSessionStorage]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles$d.tabs, "data-test": "header-tabs" },
            React.createElement(Tabs$1, { justified: true, size: "s", variant: "badge", onChange: handleChangeTab, "data-test": "header-tab-container" }, filteredItems.map((item) => (React.createElement(Tabs$1.Option, { key: item.id, value: item.id, active: item.id === selectedTabId }, item.displayNameMobile || item.displayName)))),
            React.createElement("div", { className: styles$d.menuContainer }, currentDropDownMenu.length !== 0 &&
                currentDropDownMenu.map((item) => (React.createElement(MenuItemForTabsPublicMobile, { key: `${selectedTabId}-${item.id}`, item: item, pathname: pathname, parentTabTitle: (currentMenuItem === null || currentMenuItem === void 0 ? void 0 : currentMenuItem.displayNameMobile) || (currentMenuItem === null || currentMenuItem === void 0 ? void 0 : currentMenuItem.displayName) }))))),
        selectedTabId === TabsIds.DEFAULT && partners && (React.createElement("div", { className: styles$d.partnersButtonContainer, "data-test": "header-tab-item" },
            React.createElement(PartnersButton, { partners: partners, activePartner: activePartner, onPartnerClick: onPartnerClick })))));
};

const HeaderMenuBlock = ({ isMenuOpened, isInfoMenuVisible, userRegionName, onChangeRegionClick, shouldShowPublicAreaMenuMobile, }) => {
    return (React.createElement("div", { className: cn(styles$t.menu, {
            [styles$t.menuOpened]: isMenuOpened,
            [styles$t.menuOpenedAlternative]: shouldShowPublicAreaMenuMobile,
        }) },
        React.createElement("div", { className: styles$t.infoMenu }, isInfoMenuVisible && React.createElement(InfoMenu, null)),
        React.createElement("div", { className: cn(styles$t.changeRegionButton, {
                [styles$t.fixedChangeRegionButton]: shouldShowPublicAreaMenuMobile,
            }) },
            React.createElement(ChangeRegionButton$1, { onClick: onChangeRegionClick, regionName: userRegionName })),
        React.createElement("div", { className: styles$t.regularTabs },
            React.createElement(Tabs, null)),
        React.createElement("div", { className: styles$t.mobileTabsPublicArea },
            React.createElement(TabsForPublicAreaMobile, null))));
};

const HeaderLayout = ({ className, logoHref = '/', logoVariant, isSticky, isBordered, isFullWidth, isTransparent, hideOnMobile, hasBurgerMenu, personalAreaMobileButtonText, }) => {
    const { isMenuOpened, toggleMenu, isPersonalButtonsVisible, isInfoMenuVisible, personalButtons, isOnlyLogoVisible, } = useContext(HeaderContextValue);
    const { isAuthorized } = useAuthorizeContext();
    const { isShort, isScrolled, iconTransform } = useHeaderVariant(!!isSticky);
    const { userRegionName, showSelectRegionModal } = useUserRegionContext();
    const handleChangeRegionButtonClick = () => {
        showSelectRegionModal === null || showSelectRegionModal === void 0 ? void 0 : showSelectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_HEADER);
    };
    useEffect(() => {
        preventBodyScrollOverlayOpened(isMenuOpened);
    }, [isMenuOpened]);
    if (isOnlyLogoVisible) {
        return (React.createElement(React.Fragment, null,
            React.createElement("header", { className: cn(styles$M.headerLayout, className) },
                React.createElement("div", { className: styles$M.headerLayoutContent },
                    React.createElement("div", { className: styles$M.headerLayoutLogo },
                        React.createElement(MenuItemBase, { path: logoHref, url: logoHref, className: styles$M.headerLayoutLogoIcon },
                            React.createElement(Logo, { variant: logoVariant, transform: iconTransform }))))),
            React.createElement("div", { className: styles$M.headerSpacer })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: cn(styles$M.headerLayout, className, {
                [styles$M.headerLayoutShort]: isShort,
                [styles$M.headerLayoutSticky]: isSticky && isScrolled,
                [styles$M.headerLayoutOpened]: isMenuOpened,
                [styles$M.headerLayoutBordered]: isBordered,
                [styles$M.headerLayoutTransparent]: isTransparent,
                [styles$M.headerLayoutHiddenOnMobile]: hideOnMobile,
            }), "data-test": isMenuOpened ? 'header-opened' : 'header-closed' },
            React.createElement("div", { className: cn(styles$M.headerLayoutContent, {
                    [styles$M.headerLayoutContentFull]: isFullWidth,
                }) },
                React.createElement("div", { className: styles$M.headerLayoutLeft },
                    React.createElement("div", { className: styles$M.headerLayoutLogo },
                        React.createElement(MenuItemBase, { path: logoHref, url: logoHref, className: styles$M.headerLayoutLogoIcon },
                            React.createElement(Logo, { variant: logoVariant, transform: iconTransform }))),
                    React.createElement(HeaderMenuBlock, { isMenuOpened: isMenuOpened, isInfoMenuVisible: isInfoMenuVisible, userRegionName: userRegionName, onChangeRegionClick: handleChangeRegionButtonClick, shouldShowPublicAreaMenuMobile: Boolean(personalAreaMobileButtonText) })),
                React.createElement("div", { className: styles$M.headerLayoutPersonalButtonsMobile }, isPersonalButtonsVisible && (React.createElement(React.Fragment, null,
                    React.createElement(PersonalButtons, null),
                    React.createElement(OfferPlacementLink, { url: getOfferPlacementButtonUrl(isAuthorized, personalButtons === null || personalButtons === void 0 ? void 0 : personalButtons.offerPlacement) })))),
                React.createElement("div", { className: styles$M.headerMobileButtonsContainer },
                    personalAreaMobileButtonText && (React.createElement("div", { className: styles$M.personalAreaBtn },
                        React.createElement(LinkButton$1, { variant: "secondary-alt-bg", size: "xs", href: "/personal-area" }, personalAreaMobileButtonText))),
                    hasBurgerMenu && (React.createElement("div", { className: styles$M.headerLayoutBurger }, isMenuOpened ? (React.createElement(CloseButton, { onClick: toggleMenu, dataTest: "header-close-button" })) : (React.createElement(BurgerButton, { onClick: toggleMenu, dataTest: "header-burger-button" }))))))),
        React.createElement("div", { className: styles$M.headerSpacer })));
};

const DEFAULT = 'default';
function useActiveRegionPartner({ partners = {} }) {
    const { userRegionSelectedIdNarrow, userRegionSelectedId, userRegionDetectedId } = useUserRegionContext();
    const regionId = userRegionSelectedIdNarrow || userRegionSelectedId || userRegionDetectedId;
    const activePartner = useMemo(() => {
        if (!regionId) {
            return DEFAULT;
        }
        return Object.keys(partners).find((key) => {
            var _a;
            return (_a = partners[key].regionIds) === null || _a === void 0 ? void 0 : _a.includes(regionId);
        });
    }, [regionId, partners]);
    return activePartner || DEFAULT;
}

const Header = (props) => {
    var _a, _b;
    const { isMenuOpened, setIsMenuOpened } = useMenuToggle(false);
    const isTablet = useMedia(MOBILE_WIDE_QUERY);
    const { sticky, isFullWidth, hideElementsDependOnAuthState, hideAllElementsExceptLogo, pathname, isBordered, isTransparent, items, partners, activePartner, onPartnerClick, authorizedItems, onMenuItemClick, cdnUrl, logoHref = '/', logoVariant = 'm2', roleType, className, logoutPath = '', loginText = 'Войти', mobileLoginText = loginText, loginPaths, personalAreaPath = '/personal-area', personalButtons, hasBurgerMenu, personalAreaMobileButtonText, } = props;
    const loginPath = (getActiveTabId(items, pathname) === TabsIds.DEVELOPERS
        ? (_a = loginPaths === null || loginPaths === void 0 ? void 0 : loginPaths.partner) === null || _a === void 0 ? void 0 : _a.url
        : (_b = loginPaths === null || loginPaths === void 0 ? void 0 : loginPaths.default) === null || _b === void 0 ? void 0 : _b.url) || '/login/';
    const isInfoMenuVisible = !hideElementsDependOnAuthState;
    const isPersonalButtonsVisible = shouldShowPersonalButtons({
        currentRoleType: roleType,
        pathname,
        items,
    });
    const { isShort } = useHeaderVariant(!!sticky);
    const activeRegionPartner = useActiveRegionPartner({
        partners,
    });
    const contextValue = useMemo(() => ({
        items,
        authorizedItems,
        isInfoMenuVisible,
        isPersonalButtonsVisible,
        personalButtons,
        partners,
        activePartner,
        activeRegionPartner,
        onPartnerClick,
        pathname,
        roleType,
        loginText,
        mobileLoginText,
        loginPath,
        closeMenu: () => setIsMenuOpened(false),
        setIsMenuOpened: setIsMenuOpened,
        toggleMenu: () => setIsMenuOpened(!isMenuOpened),
        logoutPath,
        personalAreaPath,
        isMenuOpened,
        onMenuItemClick,
        isUserInfoMenuOpened: true,
        isPartnerLogoVariant: logoVariant !== 'm2',
        isTransparent: isTransparent && !isShort,
        isTablet,
        isOnlyLogoVisible: hideAllElementsExceptLogo,
    }), [
        isMenuOpened,
        isShort,
        logoutPath,
        loginPath,
        personalAreaPath,
        onMenuItemClick,
        authorizedItems,
        logoVariant,
        activePartner,
        activeRegionPartner,
        isTablet,
    ]);
    useEffect(() => {
        const headEl = document.querySelector('head');
        const metaThemeColorEl = headEl === null || headEl === void 0 ? void 0 : headEl.querySelector('meta[name="theme-color"]');
        if (isMenuOpened) {
            if (metaThemeColorEl) {
                metaThemeColorEl.setAttribute('content', '#6c44f8');
            }
            else {
                const newMetaThemeColorEl = document.createElement('meta');
                newMetaThemeColorEl.setAttribute('name', 'theme-color');
                newMetaThemeColorEl.setAttribute('content', '#6c44f8');
                headEl === null || headEl === void 0 ? void 0 : headEl.appendChild(newMetaThemeColorEl);
            }
        }
        else {
            metaThemeColorEl === null || metaThemeColorEl === void 0 ? void 0 : metaThemeColorEl.remove();
        }
    }, [isMenuOpened]);
    return (React.createElement(HeaderContextValue.Provider, { value: contextValue },
        React.createElement(HeaderLayout, { cdnUrl: cdnUrl, logoHref: logoHref, logoVariant: logoVariant, className: className, isSticky: sticky, isFullWidth: isFullWidth, isBordered: isBordered, isTransparent: isTransparent, personalAreaMobileButtonText: personalAreaMobileButtonText, hasBurgerMenu: hasBurgerMenu })));
};

var styles$b = {"footer":"_3-172-11jQ7-JvKGM","content":"_3-172-11BRm-iZrJ4","contentLanding":"_3-172-11ARt-1qlBG"};

var commonStyles = {"row":"_3-172-11jCi-8MM0X","col":"_3-172-11aZK-qs5Tt","link":"_3-172-11Vg9-ziMb4"};

const FooterLink = (_a) => {
    var { component: Component, cdn, cdnUrl, to, href, onClick, className, analytics } = _a, rest = __rest(_a, ["component", "cdn", "cdnUrl", "to", "href", "onClick", "className", "analytics"]);
    const prefix = cdn ? cdnUrl : '';
    const clickHandler = (e) => {
        analytics && window.dataLayer.push({ event: analytics });
        if (onClick) {
            onClick(e);
        }
    };
    return (React.createElement(Component, Object.assign({}, rest, { path: to, url: `${prefix}${href}`, onClick: clickHandler, className: cn(className, commonStyles.link) })));
};

var styles$a = {"button":"_3-172-11SaP--ZVlY","buttonIcon":"_3-172-11FQ3-tF5q2","buttonLink":"_3-172-11SX0-Qpnwd"};

const ChangeRegionButton = ({ regionName, onClick }) => {
    return (React.createElement("div", { "data-test": "change-region-button" },
        React.createElement("button", { className: styles$a.button, onClick: onClick },
            React.createElement("span", { className: styles$a.buttonIcon },
                React.createElement(Icon, { name: "placemark", size: "s" })),
            React.createElement("span", { className: styles$a.buttonLink }, regionName))));
};

const FooterPhone = ({ phone, className }) => {
    const { phoneNumber, analytics } = phone;
    const cleanPhoneNumber = clearPhone(phoneNumber);
    const clickHandler = () => {
        analytics && window.dataLayer.push({ event: analytics });
    };
    return (React.createElement("a", { href: `tel:${cleanPhoneNumber}`, onClick: clickHandler, className: className }, phoneNumber));
};

var styles$9 = {"top":"_3-172-11GrI-wLh-n","socialLink":"_3-172-119wj-MjNfU","icon":"_3-172-11L7w-ZJkFw","mobile":"_3-172-111jM-WTJHk","name":"_3-172-11-wW-vpYmW","logoCol":"_3-172-11snT-r2GMq","logo":"_3-172-11Zkq-oXmBD","linksCol":"_3-172-11Qmj-W3Mkb","socialCol":"_3-172-11W0T-5jFdf","linksColItem":"_3-172-11JaC-q-Dva","socialColItem":"_3-172-11Bzr-uGC0Y","title":"_3-172-11O1h-rSxSd","phone":"_3-172-11F9F-8CVui","supportPhone":"_3-172-11vU0-EPmMJ","backupSupportPhone":"_3-172-11uxD-4jlkw","workTime":"_3-172-11asY-kkXPw","feedback":"_3-172-11CNe-8oKRz","contactsRow":"_3-172-11nrj-dtavx","appsCol":"_3-172-11fZL-76FNh","app":"_3-172-11OG--sdhWT","qrImage":"_3-172-119bX-xOCYi","qrDesc":"_3-172-11-AM-9Pmdw","qrDescImage":"_3-172-11gza-hjyWs","qrDescText":"_3-172-11hLN-mlZ1j","linksRow":"_3-172-11oQ3-CutdL","changeRegionButton":"_3-172-11yxr-4-YOU"};

const showFeedbackPopup = () => {
    var _a;
    const showFeedbackEvent = {
        type: 'survey:show',
        category: 'simple',
        data: {
            link: FEEDBACK_SURVEY_LINK,
            query: {},
            type: 'ces',
        },
    };
    (_a = EventBus === null || EventBus === void 0 ? void 0 : EventBus.getInstance()) === null || _a === void 0 ? void 0 : _a.publish(showFeedbackEvent);
};
const QRCodeControl = ({ imageSrc }) => {
    const { control } = useDropdownHover();
    return (React.createElement("span", { className: styles$9.qrImage, ref: control },
        React.createElement("img", { src: imageSrc, alt: "QR-\u043A\u043E\u0434" })));
};
const Top = ({ top, menuItemComponent, socialLinks, downloadAppQrCode, apps, logoHref }) => {
    const { userRegionName, showSelectRegionModal } = useUserRegionContext();
    const { cdnUrl = 'https://cdn.m2.ru', supportPhone, backupSupportPhone } = useConfigContext();
    const handleChangeRegionButtonClick = () => {
        showSelectRegionModal === null || showSelectRegionModal === void 0 ? void 0 : showSelectRegionModal();
        sendAnalyticsEvent$2(GEO_CONFIRM_FOOTER);
    };
    const SocialLink = ({ name, icon, href }) => (React.createElement(FooterLink, { href: href, target: "_blank", rel: "noopener noreferrer", analytics: `FooterLink${icon[0].toUpperCase() + icon.substring(1)}`, component: menuItemComponent, className: styles$9.socialLink },
        React.createElement("span", { className: styles$9.icon },
            React.createElement(Icon, { name: icon, size: "s" })),
        ' ',
        React.createElement("span", { className: cn(styles$9.icon, styles$9.mobile) },
            React.createElement(Icon, { name: icon, size: "m" })),
        ' ',
        React.createElement("span", { className: styles$9.name }, name)));
    return (React.createElement("div", { className: styles$9.top },
        React.createElement("div", { className: cn(commonStyles.row, styles$9.linksRow) },
            React.createElement("div", { className: cn(commonStyles.col, styles$9.logoCol) },
                React.createElement(FooterLink, { to: logoHref, component: menuItemComponent },
                    React.createElement("img", { className: styles$9.logo, src: `${cdnUrl}/assets/images/m2logo.svg`, alt: "" })),
                React.createElement("div", { className: styles$9.location },
                    supportPhone && (React.createElement(FooterPhone, { phone: { phoneNumber: supportPhone }, className: cn(styles$9.phone, styles$9.supportPhone) })),
                    !!backupSupportPhone && (React.createElement("div", { className: styles$9.backupSupportPhone },
                        React.createElement(FooterPhone, { phone: { phoneNumber: backupSupportPhone }, className: styles$9.phone }))),
                    React.createElement("div", { className: styles$9.workTime }, WORK_TIME)),
                userRegionName && (React.createElement("div", { className: styles$9.changeRegionButton },
                    React.createElement(ChangeRegionButton, { regionName: userRegionName, onClick: handleChangeRegionButtonClick })))),
            top.map((links, i) => (React.createElement("ul", { key: i, className: cn(commonStyles.col, styles$9.linksCol) }, links.map((link) => (React.createElement("li", { key: link.to || link.href, className: styles$9.linksColItem },
                React.createElement(FooterLink, Object.assign({ cdnUrl: cdnUrl }, link, { component: menuItemComponent }), link.name))))))),
            React.createElement("ul", { className: cn(commonStyles.col, styles$9.socialCol) }, socialLinks.map((link) => (React.createElement("li", { key: link.href, className: styles$9.socialColItem },
                React.createElement(SocialLink, Object.assign({}, link))))))),
        React.createElement("div", { className: cn(commonStyles.row, styles$9.contactsRow) },
            React.createElement("div", { className: commonStyles.col },
                React.createElement(Button$1, { variant: "secondary", size: "s", onClick: showFeedbackPopup, fullWidth: true }, "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0442\u043D\u0443\u044E \u0441\u0432\u044F\u0437\u044C")),
            React.createElement("div", { className: cn(commonStyles.col, styles$9.appsCol) },
                apps.map((app) => (React.createElement(FooterLink, { key: app.href, className: styles$9.app, analytics: app.analytics, href: app.href, rel: "nofollow noreferrer noopener", component: menuItemComponent },
                    React.createElement("img", { src: `${cdnUrl}${app.imgSrc}`, alt: "" })))),
                React.createElement(Dropdown, null,
                    React.createElement(QRCodeControl, { imageSrc: downloadAppQrCode }),
                    React.createElement(Dropdown.Content, null,
                        React.createElement("div", { className: styles$9.qrDesc },
                            React.createElement("img", { src: downloadAppQrCode, alt: "QR-\u043A\u043E\u0434", className: styles$9.qrDescImage }),
                            React.createElement("span", { className: styles$9.qrDescText }, "\u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u0430\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043D\u0430 \u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"))))))));
};

var styles$8 = {"middleLine":"_3-172-11lfj-L8DUK","middleLineTitle":"_3-172-11N26-qs8AQ","middleRow":"_3-172-11ZmM-XKzjQ","middleCol":"_3-172-11K9h-XU6eC","middle":"_3-172-11PGJ-KqNvf"};

const Middle = ({ menuItemComponent, middle }) => {
    const { cdnUrl } = useConfigContext();
    return (React.createElement("div", { className: styles$8.middle }, middle.map((col) => (React.createElement("div", { key: col.title, className: styles$8.middleLine },
        React.createElement("strong", { className: styles$8.middleLineTitle }, col.title),
        React.createElement("ul", { className: cn(commonStyles.row, styles$8.middleRow) }, col.links.map((link) => (React.createElement("li", { key: link.href || link.to, className: cn(commonStyles.col, styles$8.middleCol) },
            React.createElement(FooterLink, Object.assign({ component: menuItemComponent, cdnUrl: cdnUrl }, link), link.name))))))))));
};

function transformMardownLinks({ str, mapping, }) {
    const match = str.matchAll(/\[([^\[\]]*)\]\((.*?)\)/g);
    const reverseArr = [];
    for (const item of match) {
        reverseArr.unshift(item);
    }
    let text = str;
    const result = [];
    for (const item of reverseArr) {
        const textLength = item[0].length;
        const startIndex = +item.index;
        const endIndex = startIndex + textLength;
        const textItem = text.slice(endIndex);
        if (textItem) {
            result.push(textItem);
        }
        result.push(mapping({ text: item[1], href: item[2] }));
        text = text.slice(0, startIndex);
    }
    if (text) {
        result.push(text);
    }
    return result.reverse();
}

var styles$7 = {"requirements":"_3-172-11Aky-DxbNa","requirementsLink":"_3-172-11YRZ-3igKO","copyright":"_3-172-11hfN-uQk4l"};

const Bottom = () => {
    const { ITRequirements, copyright } = useConfigContext();
    const result = ITRequirements &&
        transformMardownLinks({
            str: ITRequirements,
            mapping: ({ href, text }) => {
                return (React.createElement(Link, { key: href, href: href, target: "blank" },
                    React.createElement("span", { className: styles$7.requirementsLink }, text)));
            },
        });
    return (React.createElement("div", null,
        result && React.createElement("div", { className: styles$7.requirements }, result),
        React.createElement("div", { className: styles$7.copyright }, copyright)));
};

const Footer = (_a) => {
    var { isLandingWidth, logoHref = '/' } = _a, props = __rest(_a, ["isLandingWidth", "logoHref"]);
    return (React.createElement("footer", { id: "footer", className: styles$b.footer },
        React.createElement("div", { className: cn(styles$b.content, { [styles$b.contentLanding]: isLandingWidth }) },
            React.createElement(Top, Object.assign({ logoHref: logoHref }, props)),
            React.createElement(Middle, Object.assign({}, props)),
            React.createElement(Bottom, null))));
};

var styles$6 = {"wrapper":"_3-172-11ZgP-iIpC0","open":"_3-172-11h5S-U1m6Z","sidebar":"_3-172-11Lzw-NXH3O","logoSlot":"_3-172-11Ov0-F8gF5","mainSection":"_3-172-11AeI-hk35c","footer":"_3-172-112o7-wLl-f","closed":"_3-172-11Lfi-DI4O0","divider":"_3-172-11cw4-4HXCz","partnerLogo":"_3-172-117fE--E6vH","links":"_3-172-11U-b-hSN5y","profile":"_3-172-11vg9-t-3yl","wallet":"_3-172-1132V-L0h09","footerButton":"_3-172-11u3j-3OnPo","groupName":"_3-172-118Hb-lL5Ur"};

function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var m2Logo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "36",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 0h25v25H25v7H0V7h11V0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.174 16.857V15.17h-4.035v-.014c1.423-.633 3.906-1.713 3.906-3.957 0-1.773-1.473-3.288-3.555-3.288-2.081 0-3.144 1.435-3.613 2.728l1.54.603c.348-1.079.96-1.737 2.087-1.737.985 0 1.796.734 1.715 1.708-.104 1.256-1.447 2.167-2.683 2.847a95.885 95.885 0 01-2.406 1.255v1.54h7.044zM7.417 15.177v8.428h1.82v-6.32l2.602 6.32h1.38l2.556-6.32v6.32h1.835v-8.428h-2.65l-2.447 6.045-2.461-6.045H7.417z",
  fill: "#fff"
}));

function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var m2ProLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "118",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M49.805 23.015v-4.33H39.398v-.04c3.677-1.634 10.095-4.412 10.095-10.187 0-4.56-3.811-8.458-9.188-8.458-5.382 0-8.133 3.689-9.337 7.02l3.985 1.553c.892-2.778 2.482-4.47 5.391-4.47 2.543 0 4.649 1.886 4.43 4.395-.272 3.226-3.74 5.576-6.927 7.329-2.443 1.334-6.225 3.23-6.225 3.23v3.958h18.183zM0 .861v22.154h4.757V6.387l6.864 16.628h3.647l6.735-16.628v16.628h4.857V.861h-6.978l-6.447 15.886L6.948.861H0z",
  fill: "#3216B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.833.339c3.023 0 5.61 1.125 7.75 3.38 2.146 2.25 3.217 4.998 3.217 8.24 0 3.265-1.071 6.023-3.217 8.258-2.146 2.24-4.727 3.356-7.75 3.356-3.35 0-5.918-1.235-7.712-3.709v11.963h-4.757V.911h4.758v3.181C60.914 1.588 63.481.34 66.831.34zm-5.759 16.687c1.318 1.34 2.973 2.012 4.966 2.012 1.992 0 3.647-.668 4.965-2.012 1.319-1.339 1.978-3.027 1.978-5.058 0-2.031-.66-3.714-1.978-5.058C69.687 5.57 68.032 4.9 66.04 4.9c-1.993 0-3.648.672-4.966 2.011-1.318 1.34-1.977 3.027-1.977 5.058 0 2.036.659 3.72 1.977 5.058zM86.725 4.67c1.194-2.738 3.444-4.107 6.74-4.107V5.73c-1.81-.12-3.385.319-4.728 1.305-1.343.985-2.012 2.613-2.012 4.878v11.102h-4.758V.961h4.758V4.67zM106.349 23.583c-3.221 0-5.961-1.12-8.221-3.355-2.255-2.236-3.385-4.989-3.385-8.26 0-3.266 1.13-6.019 3.385-8.26 2.255-2.234 4.995-3.355 8.221-3.355 3.251 0 6.002 1.12 8.242 3.356 2.24 2.235 3.36 4.988 3.36 8.26 0 3.265-1.12 6.018-3.36 8.258-2.245 2.24-4.991 3.356-8.242 3.356zm-4.881-6.621c1.318 1.324 2.944 1.986 4.876 1.986 1.933 0 3.559-.662 4.877-1.986 1.318-1.325 1.977-2.987 1.977-4.989 0-2.001-.659-3.664-1.977-4.988-1.318-1.325-2.944-1.987-4.877-1.987-1.932 0-3.558.662-4.876 1.987-1.318 1.324-1.977 2.987-1.977 4.988 0 2.002.659 3.664 1.977 4.989z",
  fill: "#000"
}));

function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var m2ProLogoCollapsed = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "36",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M36 17.059v-3.116h-7.522v-.029c2.658-1.175 7.296-3.174 7.296-7.328C35.774 3.305 33.02.5 29.134.5c-3.891 0-5.88 2.654-6.75 5.05l2.88 1.118c.645-1.999 1.795-3.217 3.898-3.217 1.837 0 3.36 1.358 3.202 3.163-.197 2.321-2.704 4.012-5.008 5.273-1.766.96-4.499 2.324-4.499 2.324v2.848H36zM0 1.12v15.939h3.439V5.095L8.4 17.06h2.636l4.869-11.964V17.06h3.51V1.119H14.37l-4.66 11.43L5.022 1.12H0z",
  fill: "#3216B5"
}));

function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var avitoLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  width: "98",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.36 23.56h3.626V10.518H65.36V23.56zM60.225 10.517l-3.548 9.49-3.547-9.49h-3.623l4.879 13.044h4.583l4.877-13.044h-3.621zM81.778 13.39v-2.874h-4.34V6.918h-3.621v3.598H70.95v2.874h2.866v5.611c0 2.896 1.475 4.827 5.233 4.827 1.454 0 2.728-.52 2.728-.52l-.439-2.819s-.714.208-1.59.208c-1.075 0-2.31-.453-2.31-1.916v-5.39h4.339zM39.877 17.036l2.248-6.006 2.246 6.006h-4.494zm6.934 6.524h3.857L43.524 4.454H40.73L33.585 23.56h3.858l1.361-3.645h6.64l1.367 3.645z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "82",
  y: "10",
  width: "16",
  height: "14"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.977 10.183H97.2V23.85H82.977V10.183z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.086 20.578c-2.018 0-3.656-1.573-3.656-3.512 0-1.941 1.638-3.515 3.656-3.515 2.02 0 3.655 1.574 3.655 3.514 0 1.94-1.634 3.513-3.655 3.513zm.001-10.395c-3.925 0-7.11 3.062-7.11 6.834 0 3.773 3.185 6.834 7.11 6.834 3.924 0 7.113-3.06 7.113-6.834 0-3.772-3.19-6.834-7.113-6.834z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.51 6.696c0 1.267-1.047 2.294-2.335 2.294-1.293 0-2.337-1.027-2.337-2.295 0-1.265 1.044-2.294 2.337-2.294 1.288 0 2.335 1.029 2.335 2.295z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "13",
  height: "13"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 .5h12.207v11.994H0V.5z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.207 6.496c0 3.312-2.731 5.998-6.102 5.998C2.734 12.494 0 9.808 0 6.496 0 3.185 2.734.5 6.105.5c3.37 0 6.102 2.685 6.102 5.996z",
  fill: "#0AF"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.482 20.205c0 4.03-3.326 7.295-7.427 7.295-4.1 0-7.422-3.266-7.422-7.295 0-4.03 3.323-7.297 7.422-7.297 4.101 0 7.427 3.267 7.427 7.297z",
  fill: "#97CF26"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.836 6.496c0 2.594-2.14 4.698-4.781 4.698-2.637 0-4.778-2.104-4.778-4.698 0-2.593 2.14-4.695 4.778-4.695 2.64 0 4.781 2.102 4.781 4.695z",
  fill: "#FF6163"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.563 20.204c0 1.877-1.55 3.395-3.458 3.395-1.91 0-3.459-1.518-3.459-3.395 0-1.876 1.55-3.394 3.459-3.394 1.908 0 3.457 1.518 3.457 3.394z",
  fill: "#A169F7"
}));

function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var sravniruLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "109",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("image", {
  width: "109",
  height: "20",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYoAAABICAYAAADoKbIbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABzMSURBVHgB7Z1djxvXecf/Z7gvkuU0q6J+g5GYG6BAsgrilXORSHIjrm6MoA0subXb3kQrf4BIygewdvMBYqkfwF71poBTxOuiQFG3kCi0ldKmsdYXkYSk1jJF27h1E63jKPvC5Zw8zyGHHA7PzJwznCG53PMDDjkzHA7ncGae/3nOc14EhkD5upzhN0onvTpmpYdnhKR1iRkISj5m1I4SNX4T/C6wIRt4XzSw5pVQ++kfijU4HA6Ho3AEBgSJQ9mbwFky9hUSgHklChJQCUoM2sva9+g2oCZ8rFEOVht13KidETU4HA6HI3cKFQrlOUzgPC2yOFTaYhBOaL6LJFFI2ibb31+l96sfnBGrcDgcDkduFCIU7D1gEhdo8SyltuegfoyX/daO3Ya+e1vScuS7kVSj31n64CVxFQ6Hw+Hom1yFonybPIhtXCJjfSHRc4hJbSGxFQofOq+jRr+19MGfOMFwOByOfshNKD77Q3mJDPMF4YdiD5pqolihQOQzIFko/NB7wu+xh+E3sFD7cxfDcDgcjiz0LRTlf5PzUuBNFaBmdGKA7nXh6z/TCgU0x2KiApEgQK2cLt1/WSzD4XA4HFb0JRRU1XReNnBZrcRVIemqmNKEAoj3EAJshYJXBapyF+esvYtms90NOBwOxz7EQwY4FvHZ2/JNKUkkAqkRnSSjXxAJSbevDYYioQ4tUfFKuF7+Kwq2mx+fPaV1eq/A4XA49iHWHgWJRJlK5m+j2ReiiW08wo/5DOnVVj3rSZ5FPBv0tYXaKymd9poicR1QHQBrlI46z8LhcOw3rDwKJRIeGU5BBjTsEUQ9hMCziJMhnUeRpRLMXiACZkpoxVTijx0WCaZM6RIcDodjn2FsnpVIlJThLKfGEdK8Cj/e2xAy5bhAtycR51EkZ/rcB6+IldgdekUizAIdoAqHw+HYJxh5FEokJslweiQSOk8ivBxJMsZ7kHExijSigmFJnyLBvA6Hw+HYR6Saag5cy2kynAYxidjSf7SlU2tZaDyCVI8i4ploPYr4zPYrEgGLdLCr2IuUKzM4sNWdv3s/qGGvsbQErFS787J1YAO16ujHkCoV4MOtcte2vXgNHPuGVKH47D35Ohn5C2pFZ8DDywlJRA18VED8yL5px02qetJnNC+RYNgYzY58YJtF4ZGd0ypvQpykP7YMGZM/lRcK7vvyfaBUxSalvIzu3AsC8pPX4YlnjfaX8jLu3HynvR6IwiHOC+UDsqJGGdblpch8ZIFF4f936aXxLHxB7+o+K+t35sYVskbXahWNxo0e8ZirCIj6NZgh6RivpgrQ579ahudVMEjY6vilDbrOG7j3z1X0w5f/CPjNL07Tf5b+3Aa/e/efso0HZ/NbAXdursR+FhQYTP9/Pv+HU6u53M9zL9NLje7FyXmT3ROFonxPnie7ezlRHMLLJmIRMfBar8I3OK4PvVjoM5mnSARcpANfxqjB4nBwu0I333l6ECvoj1XI0tXMD1YAGzhJBk4YnQ9fxVfVAxYYWd8/T/91JVbk0lmhYywPrNQeCNsjOzwg5iJihSEFIapoiOW2MZ2n/3Fnxzf8tqQ8fy5dKJ5fgOebik8xcD75GunEMY0v0X+yu32fDlI2/MY63VufQxbs7mNG0m95Ccej0945R3u9AdPjmVxTE+YroHtpCWYNdGRsJp68K8u+hyUVS+C9RB/JaybdsWSWFlBRkUqgIJFgzmPU+OKx81TqXqcH7+0cRIKh0lPjbcwdv48jJ85iUPD1L1cO43+32cBfV+eRXSSYRRLOdcrHm6oEXRQsECzUb717SV0H2oKsIsHwNfQo/0Wf97DhfEq5QteI82piuBwDJlYopibwtnLvW8Zc9iMUAbrjQPOeRJInE6FAkWDKGJVOeF98vkIP2G2q2rjcp0GNY1Y9yEeOvzcAg8V3ybN4ZPs9Ery8xYkF434hxoi9n7/+xwU679tggcj3OvB5X8NWJK4xfpTB/93c8e8rwXWMDFqh+MxP5GJXXwld6T/HFD1uipPQJG0nHxcLFImA4Zd+2ItolrqN6hr7QuIoGaz38IVjF1AkUlywqEqwhe8yNkb5id5Xvk5VZNsX6DpcK/C8Z9V/vz84Q9V234VjZOgRiifXKeBZwiUZGOxBiAUi71HPIuo16OIk3fsv3/8zER8/yEckmPmCSvBmcJWELwYdJzlMJf3vjkEVwVFVSu9XLLiu95OPl+g6DKLZ9H4qZS8WXiBxGNMjFBM+zsqgXjWodmoth2MNMi4WYSAKOgEKfq8HGbMuY/ZhkfhTsYQ48hMJtI6xiGHAIjGs325eqUtjIBazfYmFXUDQYYegAslrcIwEXULB3gQJwCIvdxXWY+IU0svuYUjduilxsYnBikTAixg0TQO9iOEyTmJhXyfuRGIQzJCIV+AYOl1CUfJxmt7KMhIv6Eqit/VS17qnSbZCoiOumWzn82GIBFN8bCAMxySarWlGgaZY7P2H+SgObZuXXjlwvbU1CycSRUNehTf4gpijh4nwCnkI55Wdlt3eRNh2S+7nIJrv6jPR2l+2d+/FQ6e/QyBN/B2/9f2Q4Ah01mPiD533zvKwRAJozglewSDGf+IqEpmQz+EgqET+BpXIn9sTvaLj4AD657/6N7j3g2rqvr/kPIvh9j0YHtynJst1nkeWQpVoVYM7hkpbKJ7+D7nIsYl2/CB4k932OiwSYQIDL8Od63Sl/+C9JRrqUMHxAo9Ehg8aYrQ8iTD8G1UUjaB85hM8pwddth521cu032PO4pEdDjwuYTBwr941+j9qak2q+UXKtF5GdpqCByR3xuJOUo2dxRxaN/H/X6O01lyVM61jDtZDtYM7fF0xEtMozV7IC3SN3rC8Tma9+R2F0hYKWcKLUfscFo1gse1JBPuEjbyMeBjhnteMh26vwkc71hEWJRF4F1HvoTeNgkgwxd/Mc8c5L2eRFSmrUD2t5Ts9PTtVMNcjr0iepT+/gmy8RsdZKbD3M4kDrpIbuqo1VDwkgajNw5+40Ef/i7LqWPjjf7kau8cE3aq78rX4OtIU+DpIuYytA2s9Hlh7DCiPr8WlPoVvtKhW+Rpdp2v0EuTkfmnmOzYok81BbF9wL1x0tXTSOQMy1HIp3HopHL+QkeqkrlhFWvwivC3KaIoEU0HRSJmtqaCkUqvvL+DuLU5XtIact927uaL28XGOfqtm/0OqRL6IIpDyOuXhKO7evBBbmr3zPeDHP1zDE9OLapgDyFXYQ3edHy8y/XgTEuvt68B50FXTsTENrsX09CxtWcY4wddIHlprFVrMEJnuRUfOBGX7Cr90CUPEgLebySIkBtALRnv/oDmt11nuEYxSZ5/YwHfPyY2USDBlFAmX+LOUkiVVa2xOHbWqKmAjJeUC2lUiVnwr9x61PN3u3VunjD2VprFdx9T0GWQxtJI8qrjg/HRd0Pl8C9bH5Kl0/VNW12GNd316Cag/h3GaVfGgev2Z8f5SfAzH0FFCQUa9p2WBzqMIt4JqfU8rGF3eRUgoqHqrWzAi4iHDY0LFxyeW77+cKBJlDFYkwr9bDFlG92yKxEKmADMb5ampUxk8i+ZotXmhROLmRWRBGdpPLdN9dAV26FvacLXQZqMM2xhCRyRqsIVL4I8fuo2G/xLGhU1+8Z4x3FvSPXgDjqETeBTzujhxmGjz2K7qqei2UPVTez3kNciWF5GYomJRhEgkZdie4oRJWnoTXN0k/TN9tUKawQN6SE8ZlGY3WlUJy1S1cgq/mcpS5dMLG9jNKXuPIMwrxyQm6Ri2gqcpOGGTisIlYSuCZOhEf6PWsod04ADf03u/GorF1qcYjLAYsFLKfO4nR19MPLYu58mQl4NgcugtFoFQdVNA8F3RXVvUE2rwQh8EzWvDh+EAeMizCILjSiT+2Egkyq31hBPv+W7m2GQILiVlqa5JR1iOBMtNaPsNKrOBmq+sY2eHS+SXQp8ELY5ukDBUtUHZ/mka2H6Py6O5VioP8KF8lc7XpjlrWVX3hf/DzY8FfPE1y/uEgvsJgXFTTleA1eoV1HfOY5hDxvRDc8j4BXjCdEhtpojGEYdx5MR1ZKLOz+J8joXLPcOETw8FF/B7DH8ScUZYs48MNbUNWjS1m86GvAYRWlYtphohEWGROGMoEtLyvMOfCYNt8RxGEXz++Uqn2ZgB7E3kYZyYwEBtb58sWBi6yTMPLHhHT1SxLVnEzauNPI9bstXa67t0I3g8HLbpAVRT0r9EHrDgzZPgSURFe9Bwg4WzmDtesfmSEreP6s82h743fqAe0P/3HeTPTE5D8O8rJkSr2imNLuchZPyDJq2JX9AQNH9tew2tprJtEWH12lW7Lt//Rg4i0f0d/bnKhH379ziy4fll2PEO8oINFD+wwAIGS355YOQkXcUdPqa5UEg5217m/2G1OkPelXlpXoldhv4GcQSivbMzTKFgFmGLKiVaFcM5NvEdNz3s6OCRQX42GrjWJT9mmy86KYhN+LoU2rcRvFP1kk+pQaLgT1CabCbJaUKl5fsvWIiEaeo9TjpJ3y+Wss3Oqp/B3oaMhJ+vULB59/0bFt/gIssz7bW3fgw83CnDBoH3kScsVr7qKFnDeMMi8W3cvXUZjpGBowHGpSTZR/JjBKRLLEpdYrFc+4MEkdgkA9ogkWio944BzyIUyLDvoGj2Orahhr1PDXnC9eMHDtjFj4T4dHv58Y/Iw/VsYwP5CoVih0tixcTBRoFmX5NTTiRGD488wnI/AhC2p6aeSeBVhD2LXU4kFLuTKi3/59EEkXigPIjr9NyU+dlRVVQN6N2etBNNI044erc9wCgwDu563nloVqENsi8C3xU15M3kFB96jPsVKG+pBsfI4VFV0UxX89aMyc+QWCh2Q6nuqXYFyx/+foJIrJM4bJJIbEVEIkhJYgEkG3wTAZEx23bhOgY5HP0gxEJhU9U6+sIjGzeTh0cRW92EUIoKRMuTUAJB3kRdYPmXswkicbtV3VSPiERULBqhHzUVjCi2n02MSO/ZcZhruPh5uYtHyvyvg11ntb0Kh77dvNkjhnbObCMhiASwdd5FsJ/O6+DqpnaVk6dqX5d//ZkUkSiFYhK7mqTzLMJiEd2my2zSH5H8WQ1FIISdAE0+LGOv02yamh88YODDHcse1dEqnt0azOkOhucFD+Ep/DL2B2dwaPv7cEQpIw92pgXdpcZC7GWuakLH5kY9BhlTzdSOTXg9cYrlnacTROIW/Tk+iYRP74Eo1BEvEOEUFQudQIRJqn6K9zI2ChuPx3ZQtImJCvY2PJ5SBblCwegpq6E36ErLn7XXmr2ja7BB4CTyhAPyOzyyrChjqPD9mCVleD4kVUXNHV/CuPI42BjWbL5ChagycmGbDa9xgWwizvbF2kQR/5kM7RNeb7+HvQw0xYIWlnefShEJryUSvD+LQXiYDxk5ARnaHh4KRELfFyJ8DKHJkNm24lqi+OSpCIv9PTX8RH6tRr5cEdisvwGemEnK93HnZvGtboQaTj3bGE9xR/TFNzvj1hsgZXc+VZ9HNniiDDPmVdVJXp0T1RAi26dhkYUCkPDluUz9Q7IPA88DTV7e05NixfF/j5E9++8Nfb2OFi5E5eRt19lNMO5lzs5sTYbcGZlilGTcuujdJkXvelgoUkXiOp0Xt26S6r3bhQkEQ6DdWa+9TwmdzswCXT3AY4kTjKRtnfUCmkIGx1bDZVjs3xr9NI/OXjys9hYPq41FyuNic9vxGnioEiFWCxSOmdzyEMzxYDuw4lakOe0k+Nm6AfMZ10SukzltbmYbuXZU4AEO+b6Ze+EcxCc8t8h5w2/O4OD2IvIr/LDg2A4UGUKezc2r42bXH/obsFCKXApR6pnYrZBQGFc9TQSGW0eP2Ije7bp9eoQhst4y7ukiMRERiWhdV6N1rEbrO6XQPp7u5LrPs0sEossmnkTAhOr0VwzcVHTuWM3q5iyJS8hjxj39JD1llaQ8rdaKEY78plf9hEeDVf+HDb3DlEwclPC237cs0X8rl8mc5ito9sgWZex1eKDG1eoy6jtnYTZuFV+/k8hPKB7QPbqELMyRdy3rJ8kzLSMP1GROJ6jGQG7AfAyv/gtRv9il/9Q3FWqFJ71mtYnUJERjE5HP/bjYhei0eOoKaKMtSukiUYrpcR0+WT9DkgkJmt8Io9vW5AYKRdj1VGavot8mhmycdo2ME39OVSJyhd7fwxeOXUA+zFIw8zX0A+dhc+eS9VweUnM9v/4V8iqmV2DHYRK8/lrvcJVN/eFRDHeMp/zgPi2izoaxZvGt8Z0OdRqw/C+CQlS2e4qfiYa/qB0hOQGPSuMfd1UfJQiDzjvQCgciQoOOSAgWiSdSREKEPIkoPT+K7OIQPiaARFHSnUOTKoqeWMbPNCzHUmaxaJZgl5DFOOU5LLQUFzLngavN6vVF2OeBhxDprZpgA7fTHlLdhqNUBfVdZIFFAjUSiclrGCe2eegFq9Z849tMdvtRNoq2Bc1shShVlbw1S3++9Xc9nzyKqDAACV5FTPJFgmDAQiTCQ4XHoTP6SQIR10RWJyLQvEeXu1lB0bCbmW160iUcOfa6cb8ENoZcUqnXX0cWkRBkRPPtVc1FFxa8N636Vsy9QK415UHKN2FLUh4OPsp3wV/AnnOUh/tWefjK1+np/K/zECQSe3VocR18j01RfjiQas4Y96fY5nvKPsYpxUV6ts0KIByT+BJVm3lqmPdrWaowPc9vuj09tjdk7KOf+0Jf4A6+g/BnwlIkTIOFUZGIE4+07X7oeHHvOuEI1ktFVzu1EOIqssClcs+7hiMnzsYaqkAg3nr3Eg7trGecn1ui4WU7x3QWjfPwhWNngF/dLyQPP/pbnixlNaMHOUt5WE8VPX6ov/h8Bb/+1XV60C6PlUgwq1X2Vm3n1Ri/Fk8Br1R4aJZs9xSLBRdA+LmIwoUlbrHIcRWeB6S+vUI1E5lEgpkoNVDlAfkUIr4QHXgX2s8iQV4Z2W4kEjIkEkKT4oiepC6F9xMxxxAJ74jZ1qx2qmEQTE1dxvb2WRKMMuyZVTEEz+PgGcWklHfSKsWIZ/C9fyjjkdYY/RLZyHMOCT2dPBw5UYVPgfPg4WKj89a7z+AQKnTTZTesRnmYJDHZ+TZV2r6BbLDoLarrwNN8dhkIuhYf7ZweO3FgWMhXquytXqI1WxGvYVzh/2WuEkwGVoE9zefiyHEK9ou19nMhP5nBJj8L8mSza4FAP0xszIqNg/+jDEc52Bg19GG67IjQF7YjzWKXGzYiEYeuFZLO3UkTCpnyG6ZiwXgDqHYKWKtuUGmZm8W9jb5QLj+n06317OIQOqiaF3pQ8MQzItQpL3x9+jgqduvpc1PfqfKDvQK5/c2MD3bwc/N03vPRU8jhWhSJQMl7nYTavvT71rtUGImJO6aTR0u60eVx+lc+lN/p635ShYvQcyGaG/NiQr36eEd6nXbNcR5CmxjPI+x1BCLhm4hEXEzCRAR1ohDdHjX8SZiKBZdyJlBkCbqXu7dWMXeMgsXWczcXzd6fZIZnj/vpDw0N0mMSXu3bkJPvYb8hWdwGqmaSquBuYJxRzWQrVSp8VPsrfBSH6ukhS1hNagar9ol8jvA+re0QXd8xF4nACAvDlEScYADp93eSBxI9ppdTRypbpqbPZQxsFwPPIZC1XfqowHm4e9O8ExN3Hnv0926rCXYcxVJ8leaIwIWP3ZG9n5RQbG1hjWzfRtTGKgIRCBEVkPD2FvmIBGAmDnFEFS28rEu6ffXHGbw3EcBVUFIujIRYsIEdZJVTEWTNw7/+Hd2Xv3OZ7s0+evk6UhHIZ97xUWfECx/NvuMUpxAy0pM34j0wOg8juh1ZRSJKnGDEeRY6TwJAbHWUTiCg+b5uXQzJmwjgap5hi0VgYPdylVO/ebjz9xIHpi7SddgHJd4hMA7eqg1c+Hhk+vIo3k/tQUYaQckoRSDUut6LYOxFIiDOm9B9FicsupNFynbAxIMIb69hakjeRJhhioXE7X0vEgE/qkpMTy/S0jKKRo5x658o4+CtZuEbFb6fLmbo2GkLt5ww7hzbFordp0SVAtobSQVpXT+JEGYiISIikVbdlCQMScIR5y1Ig6Q7Vmd5AaMCG7np6aMDrf6QuIzNqWJFQhbdykW+TXl4Lrc8rFWBT316iR7uiyiql/5+Mpzj4K1mhZvLrlUfULXmqdZzLZE/Ut2rfsm482jXsIXS7xicNC/CWiSinenSYhImKUqSYCR5FHHfQeTdp1LjwREr1amYxdMXUMdzhXoXXMLx/QUV9C12yGcK6tF96JOhyDs/bIB25RncufVS7nngaoMnqNqg4R/NvepAyuvKcNrOibEnyVnE9ypcrSmnLpDNeZWu/zryEQypngF+jp+YtipcdgnF7hYukyB0exVJXkRzu5lIoCUScaIQXTcRCAF74mIT6R5FDYeGHJuIgwNhP715G2J6lm6sc7m6rW2BuLWQy7DfRr8J9pauk7c0C67S6V8wNtRx2AD95FZ+Y1FF4WaObOCeoKoo/s/6vw4PVMnv7q1xL13z9VlR/1kRIr5X4T47926u0HP9uYhg2IoG7/8AwTNw7wc3YMlE1xoFtfFzeYUM8CV1dE1rp/YyC4ikH7YViQBbzyG6DM2yLRK9/STCn3V+o0ZpAaMO31j8wFUqK2oOBngVCMm9ubljl2lv343WpD2r2Jy+OtSHlqt01FhPlSX4O4vw5It0MSowyguJixTvUEl8dWACF8CCwb32K5Wqug5C8Eidpw3byAf//xX6/6td/z/PE28uPhJbB9KvXcPfUONbDRJVPSea+eSh6Xnuj8z32Q4bo2C0AYPfFuvIzDafu81Q8/lUGwXP9dzLK63Jn07S+osGzzX9v7jRega6xaE5aRJVccnrMKDXzD6QM6U61xF2TqAnbmErEjrDnuZFeJplL7Kc9pmI2WYrShyX+FQO8zsMi2B2sUZpBiWvDNkSbkbKB/DEx/Bl88EtouTaHMf/Gt2UFYO9+XZ7FXeoJKU9VnumtDKtPUMPy+H2ZyzoReajX5qTKJF4q2FGOufO10DQNRD1NTw8VHMlaocxwcRcpcaMer6D4U5yvv+15XHv53JJeC2vIvJZZpFIejcViySRSBIF3XZo1oX2vC7i0RynFt2P5CkUDodj4Gjn4POfEkv0tK71NBbKUyRsS/cmghNHXBxCF5eIBq+dSDgcjn1O7GStvt+Zl7U9PIeJSETHbooTifCyiVgA6eKRFZ2AsEh8ekSD1w6HwzFA4mf1fkpUyWBeafe+ThOJAJ3xThOJ6PdNxCPu2HGikeQ59O53DoedSDgcDgfjJX3oPyl43Pg1Y5FYUIEU7gDWbIKoE4vocrAuNPvEeQ39eBK6prEdauDzPzzA4cMdDodjxPHSdpAPyfybiETAAjZQwRnI1pAGSWKhM/QiZb+47/RPFXz2h8d87HuHw+GwJFUoVN+KLCxQ1Y1PggHVB6FDWlUTkOxhRI+TJBJmArKBBsVjfleJRA0Oh8Ph6CJdKPphgaqgGvQqcTW2WiktBgHExyXSSO/uUkWdqpoedy2bHA6HI45ihYLhuMXXsKgMsmh5FyaGPs2rMD2ODh5SnQXsMUpPOS/C4XA4kiheKAIWqO7/BJpjEXFJPs6T6EcA0qmqXtZPKoGowuFwOBypDE4oAp7HCo6Rod4lD8NX8zp0YiD9xxt0bIBHxW0ocXAC4XA4HJYUV3a34d9xGjxomgce7Krc42kkjdOk/2xDNdEVJES75MnMwo2dM0x4jP2V6gwObJkNTMiD2bnxjhyOkWE0hCLMbRIKYF6lEp6lM5whMeBtM2q5IxBsSDbUu1BNWj9WE96UyGOYdXEHh8PhyIvfApi1cOto6tcuAAAAAElFTkSuQmCC"
}));

function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var groupLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "68",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 .866v6.12h1.368v-4.92H3.96v4.92h1.368V.866H0zM10.4.722c-.972 0-1.596.444-1.896.936V.866h-1.32v8.412h1.368V6.302c.288.444.912.828 1.812.828 1.452 0 2.748-1.104 2.748-3.204S11.828.722 10.4.722zm-.264 5.196c-.972 0-1.62-.768-1.62-1.968v-.048c0-1.2.648-1.968 1.62-1.968.96 0 1.596.804 1.596 1.992 0 1.2-.636 1.992-1.596 1.992zM17.279.722c-1.8 0-3.012 1.308-3.012 3.204 0 1.896 1.212 3.204 3.012 3.204s3.012-1.308 3.012-3.204c0-1.896-1.212-3.204-3.012-3.204zm0 5.196c-1.008 0-1.62-.816-1.62-1.992 0-1.176.612-1.992 1.62-1.992s1.62.816 1.62 1.992c0 1.176-.612 1.992-1.62 1.992zM27.163 4.322v-.564c0-1.848-1.092-3.036-2.772-3.036-1.728 0-2.94 1.224-2.94 3.216 0 1.98 1.212 3.192 3.024 3.192 1.668 0 2.46-1.02 2.616-1.8h-1.344c-.096.276-.516.66-1.248.66-.984 0-1.644-.72-1.644-1.644v-.024h4.308zm-2.784-2.46c.852 0 1.38.54 1.416 1.428h-2.928c.084-.864.648-1.428 1.512-1.428zM30.035 6.986V4.13l2.352 2.856h1.656l-2.676-3.252 2.64-2.868h-1.62L30.035 3.41V.866h-1.368v6.12h1.368zM34.715 2.066h1.956v4.92h1.368v-4.92h1.956v-1.2h-5.28v1.2zM5.544 13.822v-1.284h-5.4v8.448h1.428v-7.164h3.972zM9.146 14.722c-.972 0-1.596.444-1.896.936v-.792H5.93v8.412h1.368v-2.976c.288.444.912.828 1.812.828 1.453 0 2.748-1.104 2.748-3.204s-1.284-3.204-2.712-3.204zm-.264 5.196c-.972 0-1.62-.768-1.62-1.968v-.048c0-1.2.648-1.968 1.62-1.968.96 0 1.597.804 1.597 1.992 0 1.2-.637 1.992-1.597 1.992zM17.228 14.866l-1.608 4.38-1.608-4.38h-1.476l2.352 6.012-.948 2.4h1.464l3.3-8.412h-1.476zM19.854 14.866v6.12h1.368v-4.92h2.592v4.92h1.368v-6.12h-5.328zM27.038 14.866v6.12h1.368v-4.92h2.592v4.92h1.368v-6.12h-5.328zM35.579 14.866h-1.356v6.12h2.58c1.368 0 2.244-.924 2.244-2.148 0-1.212-.864-2.112-2.244-2.112h-1.224v-1.86zm5.604 0h-1.356v6.12h1.356v-6.12zm-4.548 3.012c.672 0 1.056.396 1.056.96s-.384 1.008-1.056 1.008h-1.056v-1.968h1.056zM45.993 20.986h3.372c1.74 0 2.82-.996 2.82-2.4 0-1.224-.804-1.836-1.428-2.016.54-.228 1.104-.828 1.104-1.836 0-1.224-.888-2.196-2.604-2.196h-3.264v8.448zm3.264-3.744c.9 0 1.476.48 1.476 1.26 0 .804-.612 1.26-1.524 1.26h-1.788v-2.52h1.836zm-.204-3.48c.864 0 1.368.432 1.368 1.152 0 .648-.42 1.152-1.308 1.152h-1.692v-2.304h1.632zM53.129 13.822h2.664v7.164h1.428v-7.164h2.652v-1.284h-6.744v1.284zM66.792 13.822v-1.284H61.44v8.448h3.216c1.68 0 2.748-1.116 2.748-2.604 0-1.548-1.044-2.58-2.76-2.58h-1.776v-1.98h3.924zm-2.34 3.192c.936 0 1.5.516 1.5 1.356 0 .84-.564 1.368-1.5 1.368h-1.584v-2.724h1.584z",
  fill: "#6E6A81"
}));

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var samoletLogo = ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "\u0421\u043B\u043E\u0439_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "160",
  height: "80",
  viewBox: "60 0 700.3 332.4"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M333 166.9H76.6c-6 0-10.9 4.9-10.9 10.9v66.3c0 6 4.9 10.9 10.9 10.9H333c6 0 10.9-4.9 10.9-10.9v-66.3c0-6.1-4.9-10.9-10.9-10.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M95.2 188.4h43.2l-10.1 48.5h-12.2l7.6-36.7H105l-7.7 36.7H85.1zM158.5 188.4h37l-10.1 48.4H173l7.7-36.8h-12.8c-1.4 5.9-2.9 13.3-4.6 20.3-3.1 12.9-8.3 16.5-18.6 16.5h-5.5l2.5-12.1h2.4c4.1 0 6.5-1.8 7.6-6.3 2-7.7 4.6-19.4 6.8-30zM223.2 218.5h-7.3l-3.8 18.4h-12.3l10.1-48.4h12.3l-3.8 18.3h6.7c3.3-10.4 11.7-19 26.4-19 13.3 0 21.2 7.7 21.2 19.7 0 14.7-8.3 30.1-28.3 30.1-12.8 0-21-7.3-21.2-19.1zm36.8-9.6c0-6.1-3.4-10-9.6-10-9 0-14.6 8.9-14.6 17.8 0 5.9 3.8 9.8 9.6 9.8 9.3 0 14.6-8.5 14.6-17.6zM312.6 218.9l12 2.2c-3.7 10.2-11.3 16.5-24.3 16.5-12.2 0-20.4-7.6-20.4-19.6 0-14.8 9-30.3 27.4-30.3 12.5 0 19.4 6.3 19.9 16.5l-12.5 2.1c-.5-4.2-3.1-7.5-8.5-7.5-8.5 0-13.8 8.7-13.8 17.8 0 6.3 3.4 9.8 8.8 9.8 5.3.1 9.3-3 11.4-7.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M250.6 79l-16.4 43.9L217.6 79h-20.5v58.5h12.3V93l17.2 44.5h13.5l17.1-44.7v44.7h13.2V79zM356.4 79h45.3v58.4h-14v-46h-18.5c-.1 8.2-.4 19.2-.6 25.4-.5 15.3-5 20.8-18.1 20.8h-6.3v-12.3h3.5c5.9 0 7.8-2.7 8.2-11 .4-9.1.5-26.8.5-35.3zM473.3 79h53.3v12.4h-19.7v46.1H493V91.4h-19.7zM160.8 77.8h-5c-12 0-21.2 7.3-23.3 18.2l12.8 2.1c1.8-5.2 5.8-8.7 10.9-9 1.6-.1 1.2-.1 2.9 0 7.6.3 11 3.9 11 12.9-14.3 0-24.1-.7-31.3 4.1-5.9 3.9-8.4 8.2-8.4 15 0 9.8 7.7 17.6 20 17.6h1.7c8.7 0 15.8-3.4 18.7-7.5v6.3h12.9v-35.2c-.1-13.6-7.4-24.5-22.9-24.5zm-7.8 49.5c-5.5-.2-8.7-3.3-8.7-7.4 0-3.3 1.5-5 3.5-6.1 2.1-1.2 4.8-1.6 9-1.8 4-.1 7.3-.3 13.6-.3 0 10-6.3 15-14.1 15.5-1.3.1-2 .1-3.3.1zM470.1 112.2v-5.5c0-18.9-11.8-28.6-27.1-28.6h-3c-16.5 0-27 11.2-27.5 27.1-.1 2.3-.1 3.3 0 6.5.4 15.8 11.4 26.4 26.2 26.8 2.7.1 2.4.1 4.9 0 12.9-.4 22.6-7.8 25.5-17.5l-12.4-2.2c-3 6.1-8.8 8.4-13.5 8.6-1.5.1-1.7.1-3.1 0-7.3-.3-13.8-6-13.8-14.3v-.9h43.8zm-30.4-23.1c1.5-.1 2-.1 3.5 0 6.1.3 12.5 4.3 13.2 12.2h-30.1c.6-7 6.3-11.8 13.4-12.2zM340.4 103.1c-.3-14.1-11.7-25-26.8-25h-5.5c-15.1 0-26.5 10.8-26.8 25-.1 3.9-.1 6.2 0 10.2.3 14.2 11.7 25 26.8 25h5.5c15.1 0 26.5-10.8 26.8-25v-10.2zm-13.8 9.5c-.2 8.3-6.2 13.9-14.3 14.3-1.6.1-1.5.1-3 0-8.2-.4-14.1-6-14.3-14.3-.1-3.4-.1-5.4 0-8.8.2-8.2 6.1-13.8 14.3-14.2 1.6-.1 1.5-.1 3 0 8.1.4 14.1 6 14.3 14.3.1 3.4.1 5.3 0 8.7zM108.6 116.9c-1.6 5.4-6 9.1-11.8 9.9-1.7.2-3.4.2-4.7 0-7.3-1-12.4-6.5-12.6-14.2-.1-3.4-.1-5.4 0-8.8.2-7.7 5.5-13.4 13-14.2.4 0 2-.2 3.6 0 6.2.7 10.9 4.4 12.6 10.1l13.6-2.6c-2.9-11.1-13-19-25.8-19h-3.9c-15.1 0-26.5 10.8-26.8 25-.1 3.9-.1 6.2 0 10.2.3 14.2 11.7 25 26.8 25h3.9c13.1 0 23.3-8.2 25.9-19.7l-13.8-1.7z"
}));

const logoImages = {
    m2: {
        image: m2Logo,
    },
    'm2-light': {
        image: m2Logo,
    },
    'm2-pro': {
        image: m2ProLogo,
        collapsedImage: m2ProLogoCollapsed,
        position: 'single',
    },
    avito: {
        position: 'left',
        image: avitoLogo,
    },
    sravniru: {
        position: 'left',
        image: sravniruLogo,
    },
    group: {
        position: 'right',
        image: groupLogo,
    },
    vtb: {
        image: m2Logo,
    },
    aeon: {
        image: aeonLogo,
        position: 'single',
    },
    samolet: {
        image: samoletLogo,
        position: 'single',
    },
};

const SidebarLogo = ({ logo, onClick, isSidebarExpanded }) => {
    const { image: M2 } = logoImages['m2'];
    const variant = logo.variant;
    if (!variant || !logoImages[variant] || variant === 'm2') {
        return (React.createElement("a", { onClick: onClick },
            React.createElement(M2, null)));
    }
    const { image: PartnerLogo, position, collapsedImage: CollapsedLogo } = logoImages[variant];
    if (!isSidebarExpanded && CollapsedLogo) {
        return React.createElement(CollapsedLogo, null);
    }
    return (React.createElement(React.Fragment, null,
        position === 'left' && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles$6.partnerLogo },
                React.createElement(PartnerLogo, null)),
            React.createElement("span", { className: styles$6.divider }))),
        position === 'single' && (React.createElement("a", { onClick: onClick },
            React.createElement(PartnerLogo, null))),
        position !== 'single' && (React.createElement("a", { onClick: onClick },
            React.createElement(M2, null))),
        position === 'right' && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles$6.divider }),
            React.createElement("span", { className: styles$6.partnerLogo },
                React.createElement(PartnerLogo, null))))));
};

var styles$5 = {"toggler":"_3-172-11BGt-9xpUp","open":"_3-172-11bCZ-hsOuA"};

const Toggler = ({ open, toggleOpen }) => {
    const { to, registerControl } = useTooltip();
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { onClick: toggleOpen, ref: registerControl, className: cn(styles$5.toggler, open && styles$5.open), "data-test": open ? 'side-nav-open' : 'side-nav-closed' },
            React.createElement(Icon, { name: "chevron-double-right" })),
        !isTouchDevice() && (React.createElement(Tooltip, { placement: "body", direction: "right", to: to },
            open ? 'Свернуть' : 'Развернуть',
            " \u0431\u043E\u043A\u043E\u0432\u0443\u044E \u043F\u0430\u043D\u0435\u043B\u044C"))));
};

var styles$4 = {"button":"_3-172-11KwO-Eq2p0","icon":"_3-172-11ESn-IAgql","content":"_3-172-11C5b-r-3Rm","toggler":"_3-172-11Sqi-kbGUe","closed":"_3-172-11oUS-ZFCx9","collapse":"_3-172-11t-S-ErlYU","fresh":"_3-172-11tEt-WSMXp","text":"_3-172-11JS--K-VV9","active":"_3-172-119iG-ineN8","collapseWrapper":"_3-172-116gl-w7fxp","collapsed":"_3-172-11ZS--MeMVi"};

const getMatchPathProps = (item) => {
    const routesArray = item.activeRoute !== undefined
        ? typeof item.activeRoute === 'string'
            ? [item.activeRoute]
            : item.activeRoute.slice()
        : [];
    const routesFiltered = routesArray.filter((route) => typeof route === 'string' && route !== '');
    const routes = routesFiltered.length > 0 ? routesFiltered : [item.path || item.url || ''];
    return routes.map((route) => ({
        path: route,
        exact: item.exact,
    }));
};
const matchAny = (pathname, item) => {
    return getMatchPathProps(item).some((props) => Boolean(matchPath(pathname, props)));
};
const useSidebarActiveItemsProps = (item) => {
    const { pathname } = useLocation();
    let dropdownMenu;
    if (item.dropdownMenu) {
        dropdownMenu = item.dropdownMenu.map((subItem) => (Object.assign(Object.assign({}, subItem), { active: matchAny(pathname, subItem) })));
    }
    const isActive = dropdownMenu ? dropdownMenu.some((item) => item.active) : matchAny(pathname, item);
    return { isActive, dropdownMenu };
};

const STATE_PREFIX = 'sidebar_dropdown_menu_state_';
const useSidebarMenuState = (id, initialState) => {
    const { pathname } = useLocation();
    const hasSessionStorage = hasStorage('sessionStorage');
    const key = `${STATE_PREFIX + id}`;
    const savedState = initialState || Boolean(hasSessionStorage && sessionStorage.getItem(key));
    const [state, setState] = useState(savedState);
    const saveState = (state) => {
        hasSessionStorage && sessionStorage.setItem(key, state ? '1' : '');
    };
    const toggleState = () => {
        setState((state) => {
            if (id) {
                window.dataLayer.push({
                    event: 'lk_action',
                    section: 'menu',
                    page_type: 'lk',
                    type: id,
                });
            }
            saveState(!state);
            return !state;
        });
    };
    useEffect(() => {
        if (initialState && !state) {
            toggleState();
        }
    }, [pathname]);
    return [state, toggleState];
};

const DATA_TEST_PREFIX = 'side-link-';
const Button = (item) => {
    const { isActive, dropdownMenu } = useSidebarActiveItemsProps(item);
    const hasDropdownMenu = Boolean(dropdownMenu && dropdownMenu.length);
    return hasDropdownMenu ? (React.createElement(CollapseLinkButtons, Object.assign({}, item, { dropdownMenu: dropdownMenu, active: isActive }))) : (React.createElement(LinkButton, Object.assign({}, item, { active: isActive })));
};
const LinkButton = ({ icon, active, children, onClick, url, path, closed, className, target, id, }) => {
    const { to, registerControl } = useTooltip();
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, href: url || path, "data-test": `${DATA_TEST_PREFIX}${path || url}`, onClick: (e) => onClick(e, { url, path, target, id, isSidebarEl: true }), className: cn(className, styles$4.button, closed && styles$4.closed, active && styles$4.active) },
            React.createElement("span", { ref: registerControl, className: styles$4.icon },
                React.createElement(Icon, { name: icon })),
            React.createElement("span", { className: styles$4.content }, children)),
        closed && !isTouchDevice() && (React.createElement(Tooltip, { placement: "body", direction: "right", to: to }, children))));
};
const CollapseLinkButtons = ({ id, closed, active, onClick, icon, dropdownMenu = [], children, }) => {
    const [open, toggleOpen] = useSidebarMenuState(id, active);
    const { to, registerControl } = useTooltip();
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { onClick: toggleOpen, "data-test": `${DATA_TEST_PREFIX}${id}`, className: cn(styles$4.button, closed && styles$4.closed, active && styles$4.active) },
            React.createElement("span", { ref: registerControl, className: styles$4.icon },
                React.createElement(Icon, { name: icon })),
            React.createElement("span", { className: styles$4.content }, children),
            React.createElement("span", { className: styles$4.toggler },
                React.createElement(Icon, { name: open ? 'chevron-up' : 'chevron-down', size: "s" }))),
        React.createElement("div", { className: cn(styles$4.collapseWrapper, (!open || closed) && styles$4.collapsed) }, dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.map(({ url, path, target, displayName, active, id, freshCount }) => {
            return (React.createElement("a", { target: target, key: id, "data-test": `${DATA_TEST_PREFIX}${path || url}`, href: url || path, onClick: (e) => onClick(e, { path, url, target, id, isSidebarEl: true }), className: cn(styles$4.button, styles$4.collapse, active && styles$4.active) },
                React.createElement("span", { className: styles$4.text }, displayName),
                freshCount ? (React.createElement("span", { className: styles$4.fresh }, freshCount >= 99 ? '99+' : `+${freshCount}`)) : null));
        })),
        closed && !isTouchDevice() && (React.createElement(Tooltip, { placement: "body", direction: "right", to: to }, children))));
};

var styles$3 = {"link":"_3-172-11wTZ-Fou1F","text":"_3-172-11tzp-M3HE5"};

const WalletLink = () => {
    const { walletLink, walletText } = useDisplayWallet();
    return (React.createElement(RRLink, { href: walletLink, text: false, onClick: () => sendAnalyticsEvent$2({ event: 'lk_action', page_type: 'lk', section: 'menu', type: 'wallet' }) },
        React.createElement("span", { className: styles$3.link },
            React.createElement(Icon, { name: "m2-wallet", size: "s" }),
            React.createElement(Typography, { tag: "span", variant: "small-alone", color: "primary", className: styles$3.text }, walletText),
            React.createElement(Icon, { name: "chevron-right", size: "xs", color: "rgba(116, 109, 147, 0.5)" }))));
};

const eventBus = EventBus.getInstance();
const useSidebarToggle = () => {
    const [tabletOpen, setTabletOpen] = useState(false);
    const [desktopOpen, setDesktopOpen] = useState(true);
    const isTablet = useMedia(TABLET_QUERY);
    const open = isTablet ? tabletOpen : desktopOpen;
    const setOpen = isTablet ? setTabletOpen : setDesktopOpen;
    useEffect(() => {
        const subscription = eventBus.subscribe('app:sidebar:toggle', (event) => setOpen(event.data.isOpen));
        return () => {
            subscription.unsubscribe();
        };
    }, [setOpen]);
    const handleClickOutside = () => {
        if (tabletOpen) {
            setTabletOpen(false);
        }
    };
    return { open, setOpen, handleClickOutside };
};

const SidebarButtonComponent = (props) => {
    if (props.id === 'news') {
        return (React.createElement(NewsContainer, { isSidebarClosed: props.closed },
            React.createElement(Button, Object.assign({}, props))));
    }
    if (props.freshCount !== undefined && props.freshCount > 0) {
        return (React.createElement(FreshDot, { isCircleVisible: true, isSidebarClosed: props.closed },
            React.createElement(Button, Object.assign({}, props))));
    }
    return React.createElement(Button, Object.assign({}, props));
};
const SidebarItemsList = ({ list, onMenuItemClick, open }) => {
    const { servicesUpdates } = useUpdatesContext();
    const itemsWithDots = useMemo(() => mapUpdatesToSidebar(list, servicesUpdates), [list, servicesUpdates]);
    return (React.createElement(React.Fragment, null, itemsWithDots.map((item) => (React.createElement(SidebarButtonComponent, Object.assign({ key: item.id, onClick: onMenuItemClick, closed: !open }, item), item.displayName)))));
};

const Sidebar = ({ className, onMenuItemClick, items, footerItems, logo, groupedItems }) => {
    const { open, setOpen, handleClickOutside } = useSidebarToggle();
    const { shouldDisplayWallet } = useDisplayWallet();
    const { user } = useAuthorizeContext();
    const { currentRoleType = '', username: rawUsername } = user || {};
    const sidebar = useRef(null);
    const username = rawUsername && isPhoneNumberString(rawUsername) ? formatPhone(rawUsername) : rawUsername;
    useOnClickOutside([sidebar], handleClickOutside);
    const toggleOpen = () => setOpen((open) => !open);
    const handleClick = () => {
        if (!open) {
            setOpen(true);
        }
    };
    return (React.createElement("aside", { onClick: handleClick, className: cn(className, styles$6.wrapper, open && styles$6.open) },
        React.createElement("div", { ref: sidebar, className: cn(styles$6.sidebar, open ? styles$6.open : styles$6.closed) },
            React.createElement("div", { className: styles$6.logoSlot },
                React.createElement(SidebarLogo, { logo: logo, isSidebarExpanded: open, onClick: (e) => onMenuItemClick(e, { path: logo.href || '/' }) })),
            open && !isAnonymousUser(username) && (React.createElement("div", { className: styles$6.profile },
                username && (React.createElement(Typography, { bold: true, variant: "small-alone", color: "secondary" },
                    React.createElement(React.Fragment, null,
                        username,
                        " \u00B7 ",
                        getProfileHeaderByRoleType(currentRoleType)))),
                shouldDisplayWallet && (React.createElement("div", { className: styles$6.wallet },
                    React.createElement(WalletLink, null))))),
            React.createElement("div", { className: styles$6.mainSection },
                React.createElement(React.Fragment, null,
                    React.createElement(SidebarItemsList, { list: items, open: open, onMenuItemClick: onMenuItemClick }), groupedItems === null || groupedItems === void 0 ? void 0 :
                    groupedItems.map((groupedItem) => (React.createElement(React.Fragment, { key: groupedItem.name },
                        open && (React.createElement(Typography, { className: styles$6.groupName, bold: true, variant: "secondary", color: "secondary" }, groupedItem.name)),
                        React.createElement(SidebarItemsList, { list: groupedItem.items, open: open, onMenuItemClick: onMenuItemClick })))))),
            React.createElement("div", { className: styles$6.footer },
                React.createElement("div", { className: styles$6.links }, footerItems.map((item) => (React.createElement(Button, Object.assign({ className: styles$6.footerButton, key: item.id, onClick: onMenuItemClick }, item), item.displayName)))),
                React.createElement(Toggler, { open: open, toggleOpen: toggleOpen })))));
};

var styles$2 = {"root":"_3-172-11Lek-aZF5q"};

var styles$1 = {"personalArea":"_3-172-11QfS-qqwBs","main":"_3-172-113Mf-KC4QV","publicArea":"_3-172-11Rqp-WXHso","contentFullHeight":"_3-172-1184o--KW8b","content-wrapper":"_3-172-110e1-0DxyM","anonymousArea":"_3-172-11xVz-T6bJ8"};

const DefaultLayout = (props) => {
    const { header, footer, sidebar, isAnonymous, className, children } = props;
    const isPersonalArea = Boolean(sidebar);
    const contentFullHeight = !footer;
    if (isAnonymous && isPersonalArea) {
        return (React.createElement("div", { className: cn(className, styles$1.anonymousArea) },
            header,
            React.createElement("main", { className: cn(styles$1.main) }, children)));
    }
    if (isPersonalArea) {
        return (React.createElement("div", { className: cn(className, styles$1.personalArea) },
            sidebar,
            React.createElement("main", { className: cn(styles$1.main) }, children)));
    }
    return (React.createElement("div", { className: cn(className, styles$1.publicArea, { [styles$1.contentFullHeight]: contentFullHeight }) },
        header,
        React.createElement("div", { className: styles$1.contentWrapper },
            React.createElement("main", { className: styles$1.main }, children)),
        footer));
};

var LayoutType;
(function (LayoutType) {
    LayoutType["Default"] = "default";
    LayoutType["Sidebar"] = "sidebar";
    LayoutType["SidebarAndFooter"] = "sidebar-and-footer";
})(LayoutType || (LayoutType = {}));
const switchLayout = (props) => {
    return React.createElement(DefaultLayout, Object.assign({}, props));
};
const Layout = (_a) => {
    var otherProps = __rest(_a, []);
    const props = Object.assign(Object.assign({}, otherProps), { className: styles$2.root });
    return switchLayout(props);
};

var styles = {"container":"_3-172-11Myu-HjLuo","fluid":"_3-172-11yTe-FT6ks","mobileFullWidth":"_3-172-11mfO-Iv6Fa"};

const Container = ({ className, fluid, mobileFullWidth, children }) => {
    return (React.createElement("div", { className: cn(className, fluid && styles.fluid, mobileFullWidth && styles.mobileFullWidth) }, children));
};

export { ANONYM_USER_PREFIX, CALL_CENTER_EMAIL, Container, ErrorType, FEEDBACK_SURVEY_LINK, Footer, HEADER_NAMES, Header, HeaderVariant, INTERNAL_DOMAINS, Layout, LayoutType, LinkGenerationId, MESSAGES, PHONE, Shell, Sidebar, TRACE_HEADER_NAME, TRUSTED_HOSTS, USER_REGION_ID_DETECTED_COOKIE, USER_REGION_ID_SELECTED_COOKIE, USER_REGION_ID_SELECTED_COOKIE_SEPARATOR, WORK_TIME, composeNotification, composeSentryReplayNotification, configureUnhandledErrorsNotification, copyToClipboard, daysToMilliseconds, extractErrorDataByType, extractQratorTransactionId, getFirebaseConfig, getTrivialErrorTypesMessage, isBlockedByQrator, mergeErrorDataWithNotificationPayload, parseErrorType, reportErrorToSentry, restartSentryReplay, useAuthorizeContext, useConfigContext, useFeatureManagerContext, useFeatureValue, useShellContext, useSurveyContext, useUserRegionContext };
